import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { InjectionToken, signal, inject, Component, Input, HostBinding, computed, input, booleanAttribute, forwardRef, EventEmitter, Output, Optional, Inject, numberAttribute, effect, ContentChildren, NgModule, ViewChild, output, model, Self, ViewChildren, viewChild, ElementRef, ContentChild, Directive, Injectable, ViewEncapsulation, makeEnvironmentProviders } from '@angular/core';
import * as i2 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule, ReactiveFormsModule, NgControl, Validators, FormGroup, FormControl, NG_VALIDATORS, FormControlName } from '@angular/forms';
import { merge, fromEvent, debounceTime, Subject, scheduled, asyncScheduler, mergeAll } from 'rxjs';
import { LepiClickOutsideDirective, LepiAutoAnimateDirective, LepiTooltipDirective } from '@lepisode-ui/directives';
import dayjs from 'dayjs';
import { getKoreanRegex } from 'ko-fuzzy';
import * as i4 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import { trigger, state, style, transition, group, animate } from '@angular/animations';
import * as i2$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$1 from '@angular/cdk/dialog';
import { DIALOG_DATA, DialogModule } from '@angular/cdk/dialog';
import * as i3 from '@angular/cdk/menu';
import { CdkMenuModule } from '@angular/cdk/menu';
import { Node, mergeAttributes, Editor } from '@tiptap/core';
import Color from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import Image from '@tiptap/extension-image';
import { Table } from '@tiptap/extension-table';
import TableHeader from '@tiptap/extension-table-header';
import { TableRow } from '@tiptap/extension-table-row';
import TextAlign from '@tiptap/extension-text-align';
import TextStyle from '@tiptap/extension-text-style';
import { Underline } from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import Youtube from '@tiptap/extension-youtube';
import Link from '@tiptap/extension-link';
import { YouTubePlayer } from '@angular/youtube-player';
import * as i1$2 from '@angular/platform-browser';
const _c0 = ["*"];
const _c1 = (a0, a1, a2, a3) => [a0, a1, a2, a3];
function LepiButton_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon());
  }
}
function LepiCheckbox_lepi_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 7);
  }
}
function LepiCheckbox_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function LepiCheckbox_p_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiCheckbox_p_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
function LepiLabel_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 2);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
  }
}
function LepiMultiLepiCheckbox_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label());
  }
}
const _c2 = ["inputRef"];
const _c3 = (a0, a1, a2) => [a0, a1, a2];
function LepiInputNumber_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function LepiInputNumber_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.prefix, " ");
  }
}
function LepiInputNumber_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 11);
    i0.ɵɵtext(1, " \uC774 \uD56D\uBAA9\uC740 \uC218\uC815\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. ");
    i0.ɵɵelementEnd();
  }
}
function LepiInputNumber_ng_container_9_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label ? ctx_r1.label + "\uC744(\uB97C) \uC785\uB825\uD574 \uC8FC\uC138\uC694." : "\uC774 \uD56D\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.", " ");
  }
}
function LepiInputNumber_ng_container_9_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label ? ctx_r1.label + "\uC740(\uB294) " + ctx_r1.min + "\uBCF4\uB2E4 \uCEE4\uC57C\uD569\uB2C8\uB2E4." : "\uC774 \uD56D\uBAA9\uC740 " + ctx_r1.min + "\uBCF4\uB2E4 \uCEE4\uC57C\uD569\uB2C8\uB2E4.", " ");
  }
}
function LepiInputNumber_ng_container_9_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label ? ctx_r1.label + "\uC740(\uB294) " + ctx_r1.max + "\uBCF4\uB2E4 \uC791\uC544\uC57C\uD569\uB2C8\uB2E4." : "\uC774 \uD56D\uBAA9\uC740 " + ctx_r1.max + "\uBCF4\uB2E4 \uC791\uC544\uC57C\uD569\uB2C8\uB2E4.", " ");
  }
}
function LepiInputNumber_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputNumber_ng_container_9_p_1_Template, 2, 1, "p", 12)(2, LepiInputNumber_ng_container_9_p_2_Template, 2, 1, "p", 12)(3, LepiInputNumber_ng_container_9_p_3_Template, 2, 1, "p", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control == null ? null : ctx_r1.control.errors == null ? null : ctx_r1.control.errors["required"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control == null ? null : ctx_r1.control.errors == null ? null : ctx_r1.control.errors["min"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control == null ? null : ctx_r1.control.errors == null ? null : ctx_r1.control.errors["max"]);
  }
}
function LepiInputText_div_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 11);
    i0.ɵɵelement(1, "lepi-icon", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.hint, " ");
  }
}
function LepiInputText_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "lepi-label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, LepiInputText_div_1_div_3_Template, 4, 1, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.hint);
  }
}
function LepiInputText_lepi_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 14);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function LepiInputText_p_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1, " \uC774 \uD56D\uBAA9\uC740 \uC218\uC815\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. ");
    i0.ɵɵelementEnd();
  }
}
function LepiInputText_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "p", 15);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_2_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.value().length, " / ", (tmp_2_0 = ctx_r0.maxlength) !== null && tmp_2_0 !== undefined ? tmp_2_0 : 100, " ");
  }
}
function LepiInputText_ng_container_8_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label + "\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694." : "\uC774 \uD56D\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.", " ");
  }
}
function LepiInputText_ng_container_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputText_ng_container_8_p_1_Template, 2, 1, "p", 16);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control == null ? null : ctx_r0.control.errors == null ? null : ctx_r0.control.errors["required"]);
  }
}
const _c4 = () => ["\uC77C", "\uC6D4", "\uD654", "\uC218", "\uBAA9", "\uAE08", "\uD1A0"];
const _c5 = (a0, a1) => ({
  "text-red-500": a0,
  "text-blue-500": a1
});
const _c6 = (a0, a1, a2, a3) => ({
  "text-red-500": a0,
  "text-blue-500": a1,
  "text-gray-400": a2,
  "bg-primary text-white": a3
});
const _c7 = a0 => ({
  "bg-primary text-white hover:bg-primary-400": a0
});
const _c8 = () => [];
function LepiCalendar_ng_container_1_div_20_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r3 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5, day_r3 === "\uC77C", day_r3 === "\uD1A0"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r3, " ");
  }
}
function LepiCalendar_ng_container_1_div_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_div_22_Template_div_click_0_listener() {
      const day_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleSelectDate(day_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c6, day_r5.day() === 0 && day_r5.month() === ctx_r1.currentDate.month(), day_r5.day() === 6 && day_r5.month() === ctx_r1.currentDate.month(), day_r5.month() !== ctx_r1.currentDate.month(), day_r5.isSame(ctx_r1.value, "day")));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r5.format("DD"), " ");
  }
}
function LepiCalendar_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "section", 2)(2, "div", 3)(3, "div", 4);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_3_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isYearSelectorOpen = true);
    });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_5_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isMonthSelectorOpen = true);
    });
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 5)(8, "div", 6);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevYear());
    });
    i0.ɵɵelement(9, "lepi-icon", 7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 6);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_10_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevMonth());
    });
    i0.ɵɵelement(11, "lepi-icon", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 9);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.navigateToday());
    });
    i0.ɵɵtext(13, " \uC624\uB298 ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 6);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_14_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextMonth());
    });
    i0.ɵɵelement(15, "lepi-icon", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 6);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_1_Template_div_click_16_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextYear());
    });
    i0.ɵɵelement(17, "lepi-icon", 11);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "section")(19, "div", 12);
    i0.ɵɵtemplate(20, LepiCalendar_ng_container_1_div_20_Template, 2, 5, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "div", 12);
    i0.ɵɵtemplate(22, LepiCalendar_ng_container_1_div_22_Template, 2, 7, "div", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentDate.format("YYYY\uB144"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentDate.format("MM\uC6D4"), " ");
    i0.ɵɵadvance(14);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(4, _c4));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.days);
  }
}
function LepiCalendar_ng_container_2_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_2_div_4_Template_div_click_0_listener() {
      const year_r8 = i0.ɵɵrestoreView(_r7).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleYearSelect(year_r8));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r8 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, ctx_r1.currentDate.year() === year_r8));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", year_r8, " ");
  }
}
function LepiCalendar_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_2_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isYearSelectorOpen = false);
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "section", 18);
    i0.ɵɵtemplate(4, LepiCalendar_ng_container_2_div_4_Template, 2, 4, "div", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentDate.format("YYYY\uB144 MM\uC6D4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.years);
  }
}
function LepiCalendar_ng_container_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_3_ng_container_4_Template_div_click_1_listener() {
      const i_r11 = i0.ɵɵrestoreView(_r10).index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleMonthSelect(i_r11));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const i_r11 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, ctx_r1.currentDate.month() === i_r11));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i_r11 + 1, "\uC6D4 ");
  }
}
function LepiCalendar_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 17);
    i0.ɵɵlistener("click", function LepiCalendar_ng_container_3_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isMonthSelectorOpen = false);
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "section", 21);
    i0.ɵɵtemplate(4, LepiCalendar_ng_container_3_ng_container_4_Template, 3, 4, "ng-container", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.currentDate.format("YYYY\uB144 MM\uC6D4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(2, _c8).constructor(12));
  }
}
const _c9 = a0 => ({
  active: a0
});
const _c10 = (a0, a1) => [a0, a1];
function LepiDatePicker_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function LepiDatePicker_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 7)(1, "lepi-calendar", 8);
    i0.ɵɵtwoWayListener("ngModelChange", function LepiDatePicker_Conditional_8_Template_lepi_calendar_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r1.value, $event) || (ctx_r1.value = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function LepiDatePicker_Conditional_8_Template_lepi_calendar_ngModelChange_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.change());
    })("selected", function LepiDatePicker_Conditional_8_Template_lepi_calendar_selected_1_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isOpen.set(false));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c10, ctx_r1.yPosition() === "bottom" ? "top-[100%]" : "bottom-[100%]", ctx_r1.xPosition() === "right" ? "right-0" : "left-0"));
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.value);
    i0.ɵɵproperty("keyupDate", ctx_r1.keyupDate());
  }
}
function RangeCalendarComponent_Conditional_1_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_1_For_4_Template_div_click_0_listener() {
      const year_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleYearSelect(year_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const year_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, ctx_r1.dayjs()(ctx_r1.value).year() === year_r4));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", year_r4, " ");
  }
}
function RangeCalendarComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isYearSelectorOpen.set(false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "section", 2);
    i0.ɵɵrepeaterCreate(3, RangeCalendarComponent_Conditional_1_For_4_Template, 2, 4, "div", 3, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dayjs()(ctx_r1.value).format("YYYY\uB144 MM\uC6D4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.years);
  }
}
function RangeCalendarComponent_Conditional_2_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_2_For_4_Template_div_click_0_listener() {
      const $index_r7 = i0.ɵɵrestoreView(_r6).$index;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleMonthSelect($index_r7));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const $index_r7 = ctx.$index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, ctx_r1.dayjs()(ctx_r1.value).month() === $index_r7));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", $index_r7 + 1, "\uC6D4 ");
  }
}
function RangeCalendarComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isMonthSelectorOpen.set(false));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "section", 6);
    i0.ɵɵrepeaterCreate(3, RangeCalendarComponent_Conditional_2_For_4_Template, 2, 4, "div", 3, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dayjs()(ctx_r1.value).format("YYYY\uB144 MM\uC6D4"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(1, _c8).constructor(12));
  }
}
function RangeCalendarComponent_Conditional_3_For_18_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r9 = ctx.$implicit;
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c5, day_r9 === "\uC77C", day_r9 === "\uD1A0"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r9, " ");
  }
}
function RangeCalendarComponent_Conditional_3_For_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_For_21_Template_div_click_0_listener() {
      const day_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.handleSelectDate(day_r11));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const day_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.setStyle(day_r11));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", day_r11.format("DD"), " ");
  }
}
function RangeCalendarComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 7)(1, "div", 8)(2, "div", 9);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_2_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isYearSelectorOpen.set(true));
    });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 9);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_4_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isMonthSelectorOpen.set(true));
    });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 10)(7, "div", 11);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_7_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevYear());
    });
    i0.ɵɵelement(8, "lepi-icon", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 11);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_9_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.prevMonth());
    });
    i0.ɵɵelement(10, "lepi-icon", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 11);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_11_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextMonth());
    });
    i0.ɵɵelement(12, "lepi-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 11);
    i0.ɵɵlistener("click", function RangeCalendarComponent_Conditional_3_Template_div_click_13_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.nextYear());
    });
    i0.ɵɵelement(14, "lepi-icon", 15);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(15, "section")(16, "div", 16);
    i0.ɵɵrepeaterCreate(17, RangeCalendarComponent_Conditional_3_For_18_Template, 2, 5, "div", 17, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 16);
    i0.ɵɵrepeaterCreate(20, RangeCalendarComponent_Conditional_3_For_21_Template, 2, 2, "div", 18, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dayjs()(ctx_r1.value).format("YYYY\uB144"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dayjs()(ctx_r1.value).format("MM\uC6D4"), " ");
    i0.ɵɵadvance(12);
    i0.ɵɵrepeater(i0.ɵɵpureFunction0(2, _c4));
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r1.days());
  }
}
const _c11 = ["inputStartDate"];
const _c12 = ["inputEndDate"];
function LepiDateRange_Conditional_13_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function LepiDateRange_Conditional_13_For_4_Template_div_click_0_listener() {
      const item_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r4 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r4.handleSegment(item_r4));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r4 = ctx.$implicit;
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("active", item_r4.name === ctx_r4.segment());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r4.name, " ");
  }
}
function LepiDateRange_Conditional_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 11)(1, "section", 12)(2, "div", 13);
    i0.ɵɵrepeaterCreate(3, LepiDateRange_Conditional_13_For_4_Template, 2, 3, "div", 14, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "lepi-range-calendar", 15);
    i0.ɵɵlistener("selected", function LepiDateRange_Conditional_13_Template_lepi_range_calendar_selected_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.change($event, "start"));
    })("outOfRange", function LepiDateRange_Conditional_13_Template_lepi_range_calendar_outOfRange_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.outOfRange.emit($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "lepi-range-calendar", 16);
    i0.ɵɵlistener("selected", function LepiDateRange_Conditional_13_Template_lepi_range_calendar_selected_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.change($event, "end"));
    })("dateClick", function LepiDateRange_Conditional_13_Template_lepi_range_calendar_dateClick_6_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.isOpen.set(false));
    })("outOfRange", function LepiDateRange_Conditional_13_Template_lepi_range_calendar_outOfRange_6_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.outOfRange.emit($event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("right-0", ctx_r4.calendarPosition === "left");
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r4.segmentItems());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("minDate", ctx_r4.minDate)("maxDate", ctx_r4.maxDate)("value", ctx_r4._startDate())("startDate", ctx_r4._startDate())("endDate", ctx_r4._endDate());
    i0.ɵɵadvance();
    i0.ɵɵproperty("minDate", ctx_r4.minDate)("maxDate", ctx_r4.maxDate)("value", ctx_r4._endDate())("startDate", ctx_r4._startDate())("endDate", ctx_r4._endDate());
  }
}
const _c13 = ["textarea"];
function LepiTextArea_ng_container_7_small_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", ctx_r1.label, "\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694. ");
  }
}
function LepiTextArea_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiTextArea_ng_container_7_small_1_Template, 2, 1, "small", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const errors_r3 = ctx.ngIf;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", errors_r3["required"] && ctx_r1.showLength);
  }
}
function LepiTextArea_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r1.value ? ctx_r1.value.length : 0, "/", ctx_r1.maxlength, " ");
  }
}
function LepiInputGroup_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "lepi-label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelement(5, "lepi-input-text", 7);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_6_0;
    let tmp_7_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", (tmp_3_0 = item_r1.required) !== null && tmp_3_0 !== undefined ? tmp_3_0 : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", item_r1.formControlName)("debounce", (tmp_6_0 = item_r1.debounce) !== null && tmp_6_0 !== undefined ? tmp_6_0 : 0)("placeholder", (tmp_7_0 = item_r1.placeholder) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "");
  }
}
function LepiInputGroup_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "lepi-label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelement(5, "lepi-input-number", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_8_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", (tmp_3_0 = item_r1.required) !== null && tmp_3_0 !== undefined ? tmp_3_0 : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", item_r1.formControlName)("max", item_r1.max)("min", item_r1.min)("placeholder", (tmp_8_0 = item_r1.placeholder) !== null && tmp_8_0 !== undefined ? tmp_8_0 : "");
  }
}
function LepiInputGroup_ng_container_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "lepi-label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelement(5, "lepi-date-picker", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", (tmp_3_0 = item_r1.required) !== null && tmp_3_0 !== undefined ? tmp_3_0 : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("formControlName", item_r1.formControlName);
  }
}
function LepiInputGroup_ng_container_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "lepi-label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6)(5, "lepi-date-range", 10);
    i0.ɵɵlistener("selectedStartDate", function LepiInputGroup_ng_container_1_div_4_Template_lepi_date_range_selectedStartDate_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const item_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dateChange(item_r1.formControlName.startDate, $event));
    })("selectedEndDate", function LepiInputGroup_ng_container_1_div_4_Template_lepi_date_range_selectedEndDate_5_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const item_r1 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.dateChange(item_r1.formControlName.endDate, $event));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_3_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", (tmp_3_0 = item_r1.required) !== null && tmp_3_0 !== undefined ? tmp_3_0 : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
  }
}
function LepiInputGroup_ng_container_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "lepi-label", 5);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(4, "div", 6);
    i0.ɵɵelement(5, "lepi-text-area", 11);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    let tmp_5_0;
    let tmp_7_0;
    const item_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("required", (tmp_3_0 = item_r1.required) !== null && tmp_3_0 !== undefined ? tmp_3_0 : false);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(item_r1.label);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap((tmp_5_0 = item_r1.class) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "");
    i0.ɵɵproperty("formControlName", item_r1.formControlName)("maxlength", (tmp_7_0 = item_r1.maxlength) !== null && tmp_7_0 !== undefined ? tmp_7_0 : "")("placeholder", item_r1.placeholder);
  }
}
function LepiInputGroup_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputGroup_ng_container_1_div_1_Template, 6, 5, "div", 2)(2, LepiInputGroup_ng_container_1_div_2_Template, 6, 6, "div", 2)(3, LepiInputGroup_ng_container_1_div_3_Template, 6, 3, "div", 2)(4, LepiInputGroup_ng_container_1_div_4_Template, 6, 2, "div", 2)(5, LepiInputGroup_ng_container_1_div_5_Template, 6, 7, "div", 2);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.type === "text");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.type === "number");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.type === "date-picker");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.type === "date-range");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r1.type === "textarea");
  }
}
function LepiInputPassword_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 10);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function LepiInputPassword_lepi_icon_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 11);
  }
}
function LepiInputPassword_lepi_icon_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 12);
  }
}
function LepiInputPassword_div_9_div_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelement(1, "lepi-icon", 18);
    i0.ɵɵelementStart(2, "span", 16);
    i0.ɵɵtext(3, "CapsLock\uC774 \uCF1C\uC838 \uC788\uC2B5\uB2C8\uB2E4.");
    i0.ɵɵelementEnd()();
  }
}
function LepiInputPassword_div_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵelement(2, "lepi-icon", 15);
    i0.ɵɵelementStart(3, "span", 16);
    i0.ɵɵtext(4, "8\uAE00\uC790 \uC774\uC0C1");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 14);
    i0.ɵɵelement(6, "lepi-icon", 15);
    i0.ɵɵelementStart(7, "span", 16);
    i0.ɵɵtext(8, "1\uAE00\uC790 \uC774\uC0C1\uC758 \uC22B\uC790");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 14);
    i0.ɵɵelement(10, "lepi-icon", 15);
    i0.ɵɵelementStart(11, "span", 16);
    i0.ɵɵtext(12, "1\uAE00\uC790 \uC774\uC0C1\uC758 \uD2B9\uC218\uBB38\uC790");
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(13, LepiInputPassword_div_9_div_13_Template, 4, 0, "div", 17);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("name", ctx_r1.regLength.test(ctx_r1._value()) ? "ic:baseline-check" : "ic:sharp-close");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", ctx_r1.regNum.test(ctx_r1._value()) ? "ic:baseline-check" : "ic:sharp-close");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", ctx_r1.regSpecial.test(ctx_r1._value()) ? "ic:baseline-check" : "ic:sharp-close");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.isCapsLockOn());
  }
}
const _c14 = ["content"];
const _c15 = ["group"];
const _c16 = ["select"];
function LepiSelect_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label, " ");
  }
}
function LepiSelect_ng_container_6_lepi_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.isOpen() ? "bg-primary" : "bg-gray-300");
  }
}
function LepiSelect_ng_container_6_lepi_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.isOpen() ? "bg-primary" : "bg-gray-300");
  }
}
function LepiSelect_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiSelect_ng_container_6_lepi_icon_1_Template, 1, 2, "lepi-icon", 9)(2, LepiSelect_ng_container_6_lepi_icon_2_Template, 1, 2, "lepi-icon", 10);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isOpen());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOpen());
  }
}
function LepiSelect_ng_container_7_lepi_icon_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 12);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.isOpen() ? "bg-primary" : "bg-gray-300");
  }
}
function LepiSelect_ng_container_7_lepi_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.isOpen() ? "bg-primary" : "bg-gray-300");
  }
}
function LepiSelect_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiSelect_ng_container_7_lepi_icon_1_Template, 1, 2, "lepi-icon", 10)(2, LepiSelect_ng_container_7_lepi_icon_2_Template, 1, 2, "lepi-icon", 9);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isOpen());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isOpen());
  }
}
function LepiSelect_div_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
}
function LepiSelect_div_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 15);
    i0.ɵɵtext(1, " \uBAA9\uB85D\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. ");
    i0.ɵɵelementEnd();
  }
}
function LepiSelect_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, LepiSelect_div_8_Conditional_1_Template, 2, 0, "div", 14)(2, LepiSelect_div_8_Conditional_2_Template, 2, 0, "p", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("top-[calc(100%+4px)]", ctx_r1.position === "bottom")("bottom-[calc(100%+4px)]", ctx_r1.position === "top");
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isEmpty() ? 1 : 2);
  }
}
function LepiInputTel_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiInputTel_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "input", 5, 0);
    i0.ɵɵlistener("input", function LepiInputTel_ng_container_2_Template_input_input_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.formatPhoneNumber($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassProp("border-danger", ctx_r0.invalid)("border-success", ctx_r0.valid);
    i0.ɵɵproperty("ngModel", ctx_r0.value)("maxlength", ctx_r0.maxlength)("placeholder", ctx_r0.placeholder)("required", ctx_r0.required)("ngClass", i0.ɵɵpureFunction3(9, _c3, ctx_r0.currentSize().wrapper, ctx_r0.currentSize().input, ctx_r0.currentRounded()));
  }
}
function LepiInputTel_ng_container_3_lepi_label_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiInputTel_ng_container_3_lepi_select_option_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-select-option", 11);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const prefix_r4 = ctx.$implicit;
    i0.ɵɵproperty("value", prefix_r4);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(prefix_r4);
  }
}
function LepiInputTel_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 6);
    i0.ɵɵtemplate(2, LepiInputTel_ng_container_3_lepi_label_2_Template, 2, 2, "lepi-label", 2);
    i0.ɵɵelementStart(3, "lepi-select", 7);
    i0.ɵɵtwoWayListener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_select_ngModelChange_3_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.input1, $event) || (ctx_r0.input1 = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_select_ngModelChange_3_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onInputChange());
    });
    i0.ɵɵtemplate(4, LepiInputTel_ng_container_3_lepi_select_option_4_Template, 2, 2, "lepi-select-option", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 9);
    i0.ɵɵtext(6, "-");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "lepi-input-number", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_input_number_ngModelChange_7_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.input2, $event) || (ctx_r0.input2 = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_input_number_ngModelChange_7_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onInputChange());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "p", 9);
    i0.ɵɵtext(9, "-");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "lepi-input-number", 10);
    i0.ɵɵtwoWayListener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_input_number_ngModelChange_10_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r0.input3, $event) || (ctx_r0.input3 = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function LepiInputTel_ng_container_3_Template_lepi_input_number_ngModelChange_10_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.onInputChange());
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.label);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("border-danger", ctx_r0.invalid)("border-success", ctx_r0.valid);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.input1);
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.prefixes);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("border-danger", ctx_r0.invalid)("border-success", ctx_r0.valid);
    i0.ɵɵproperty("required", ctx_r0.required)("maxLength", 4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.input2);
    i0.ɵɵadvance(3);
    i0.ɵɵclassProp("border-danger", ctx_r0.invalid)("border-success", ctx_r0.valid);
    i0.ɵɵproperty("required", ctx_r0.required)("maxLength", 4);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r0.input3);
  }
}
const _c17 = (a0, a1, a2) => ({
  "flex-wrap": a0,
  "flex-col": a1,
  "bg-gray-100 cursor-not-allowed": a2
});
function LepiInputChip_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiInputChip_lepi_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function LepiInputChip_ng_container_5_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label + "\uC744" : "\uC774 \uD56D\uBAA9\uC744", " \uC785\uB825\uD574 \uC8FC\uC138\uC694. ");
  }
}
function LepiInputChip_ng_container_5_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const minLength_r2 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.label ? ctx_r0.label + "\uC744" : "\uC774 \uD56D\uBAA9\uC740", " ", minLength_r2, " \uAC1C \uC774\uC0C1\uC774\uC5EC\uC57C \uD569\uB2C8\uB2E4. ");
  }
}
function LepiInputChip_ng_container_5_p_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const maxLength_r3 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r0.label ? ctx_r0.label + "\uC744" : "\uC774 \uD56D\uBAA9\uC740", " ", maxLength_r3, " \uAC1C \uC774\uD558\uC5EC\uC57C \uD569\uB2C8\uB2E4. ");
  }
}
function LepiInputChip_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputChip_ng_container_5_p_1_Template, 2, 1, "p", 11)(2, LepiInputChip_ng_container_5_p_2_Template, 2, 2, "p", 11)(3, LepiInputChip_ng_container_5_p_3_Template, 2, 2, "p", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control == null ? null : ctx_r0.control.errors == null ? null : ctx_r0.control.errors["required"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control == null ? null : ctx_r0.control.errors == null ? null : ctx_r0.control.errors["minLength"]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.control == null ? null : ctx_r0.control.errors == null ? null : ctx_r0.control.errors["maxLength"]);
  }
}
function LepiInputChip_div_8_lepi_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 18);
  }
}
function LepiInputChip_div_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 14);
    i0.ɵɵtemplate(2, LepiInputChip_div_8_lepi_icon_2_Template, 1, 0, "lepi-icon", 15);
    i0.ɵɵelementStart(3, "div", 16);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "lepi-icon", 17);
    i0.ɵɵlistener("click", function LepiInputChip_div_8_Template_lepi_icon_click_5_listener() {
      const i_r5 = i0.ɵɵrestoreView(_r4).index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.removeValue(i_r5));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("cursor-grab", ctx_r0.direction === "horizontal");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.direction === "vertical" && ctx_r0.reorder);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r6);
  }
}
const _c18 = ["options"];
function LepiInputEmail_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiInputEmail_div_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11, 1);
    i0.ɵɵlistener("click", function LepiInputEmail_div_5_div_1_Template_div_click_0_listener() {
      const i_r3 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleClick(i_r3));
    })("mouseover", function LepiInputEmail_div_5_div_1_Template_div_mouseover_0_listener($event) {
      const i_r3 = i0.ɵɵrestoreView(_r2).index;
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.handleHover($event, i_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const domain_r4 = ctx.$implicit;
    const i_r3 = ctx.index;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i_r3 === ctx_r0.selectedIndex() ? "bg-primary-500 text-white font-semibold" : "bg-white text-primary-500");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate3(" ", ctx_r0.userEmail(), "", "@", "", domain_r4, " ");
  }
}
function LepiInputEmail_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtemplate(1, LepiInputEmail_div_5_div_1_Template, 3, 4, "div", 10);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r0.filteredDomain());
  }
}
function LepiInputEmail_ng_container_6_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.label ? ctx_r0.label : "\uC774\uBA54\uC77C", "\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694. ");
  }
}
function LepiInputEmail_ng_container_6_p_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 13);
    i0.ɵɵtext(1, " \uC774\uBA54\uC77C\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. ");
    i0.ɵɵelementEnd();
  }
}
function LepiInputEmail_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputEmail_ng_container_6_p_1_Template, 2, 1, "p", 12)(2, LepiInputEmail_ng_container_6_p_2_Template, 2, 0, "p", 12);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.invalid && (ctx_r0.control == null ? null : ctx_r0.control.errors == null ? null : ctx_r0.control.errors["email"]));
  }
}
const _c19 = () => [1, 2, 3, 4, 5];
function LepiInputRating_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiInputRating_For_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lepi-icon", 5);
    i0.ɵɵlistener("click", function LepiInputRating_For_4_Template_lepi_icon_click_0_listener() {
      const ɵ$index_10_r3 = i0.ɵɵrestoreView(_r2).$index;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.handleClick(ɵ$index_10_r3 + 1));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ɵ$index_10_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ɵ$index_10_r3 < ctx_r0.value ? "ic:baseline-star" : "ic:baseline-star-border");
  }
}
const _c20 = ["hoursRef"];
const _c21 = ["minutesRef"];
function LepiInputDuration_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r1.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function LepiInputDuration_lepi_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.icon);
  }
}
function LepiInputDuration_ng_container_12_p_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.label ? ctx_r1.label + "\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694." : "\uC774 \uD56D\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694.", " ");
  }
}
function LepiInputDuration_ng_container_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiInputDuration_ng_container_12_p_1_Template, 2, 1, "p", 11);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control == null ? null : ctx_r1.control.errors == null ? null : ctx_r1.control.errors["required"]);
  }
}
function TimePickerComponent_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵlistener("click", function TimePickerComponent_For_10_Template_p_click_0_listener() {
      const hour_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectHour(hour_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const hour_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "hour-" + hour_r3)("ngClass", ctx_r3.isSameHour(hour_r3) ? "bg-primary text-white" : "hover:bg-neutral-100");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(hour_r3);
  }
}
function TimePickerComponent_For_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵlistener("click", function TimePickerComponent_For_15_Template_p_click_0_listener() {
      const minute_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r3 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r3.selectMinute(minute_r6));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const minute_r6 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", "minute-" + minute_r6)("ngClass", minute_r6 === ctx_r3.currentMinute() ? "bg-primary text-white" : "hover:bg-neutral-100");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(minute_r6);
  }
}
function LepiInputTime_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "lepi-label", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("required", ctx_r1.required());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx);
  }
}
function LepiInputTime_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "app-time-picker", 10);
    i0.ɵɵlistener("outside", function LepiInputTime_Conditional_7_Template_app_time_picker_outside_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.isOpen.set(false));
    })("pick", function LepiInputTime_Conditional_7_Template_app_time_picker_pick_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.pick($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("currentTime", ctx_r1.value());
  }
}
function LepiInputTime_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1, "\uC774 \uD56D\uBAA9\uC740 \uC218\uC815\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.");
    i0.ɵɵelementEnd();
  }
}
const _c22 = a0 => ({
  "min-h-[18.75rem]": a0
});
const _c23 = a0 => ({
  "max-w-[7rem]": a0
});
function LepiFileUploader_lepi_label_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiFileUploader_lepi_hint_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.hint);
  }
}
function LepiFileUploader_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-spinner", 5);
  }
}
function LepiFileUploader_Conditional_5_div_0_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17)(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r0.items().length, " / ", ctx_r0.maxlength, "");
  }
}
function LepiFileUploader_Conditional_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11);
    i0.ɵɵlistener("click", function LepiFileUploader_Conditional_5_div_0_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.openFileSelect());
    })("dragover", function LepiFileUploader_Conditional_5_div_0_Template_div_dragover_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragOver($event));
    })("dragleave", function LepiFileUploader_Conditional_5_div_0_Template_div_dragleave_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDragLeave($event));
    })("drop", function LepiFileUploader_Conditional_5_div_0_Template_div_drop_1_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onFileDrop($event));
    });
    i0.ɵɵelement(2, "lepi-icon", 12);
    i0.ɵɵelementStart(3, "div", 13)(4, "p", 14);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 15);
    i0.ɵɵtext(7, "\uB610\uB294 \uD074\uB9AD\uD574\uC11C \uC120\uD0DD\uC774 \uAC00\uB2A5\uD569\uB2C8\uB2E4");
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(8, LepiFileUploader_Conditional_5_div_0_div_8_Template, 3, 2, "div", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("bg-primary-50", ctx_r0.isDragOvered())("border-primary", ctx_r0.isDragOvered())("bg-white", !ctx_r0.isDragOvered());
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(9, _c22, ctx_r0.direction === "row"));
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.type() === "image" ? "\uC0AC\uC9C4" : "\uD30C\uC77C", "\uC744 \uB4DC\uB798\uADF8\uD558\uC5EC \uC62C\uB824\uB193\uC73C\uC138\uC694 ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r0.maxlength > 1);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_img_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "img", 32);
    i0.ɵɵlistener("click", function LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_img_1_Template_img_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext(2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.openImage(item_r5.url));
    })("error", function LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_img_1_Template_img_error_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const item_r5 = i0.ɵɵnextContext(2).$implicit;
      return i0.ɵɵresetView(item_r5.status = "fail");
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("src", item_r5.url, i0.ɵɵsanitizeUrl);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33);
    i0.ɵɵelement(1, "lepi-icon", 34);
    i0.ɵɵelementEnd();
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_img_1_Template, 1, 1, "img", 30)(2, LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_div_2_Template, 2, 0, "div", 31);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r5 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r5.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r5.status);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 35);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 36);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 37);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 38);
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "lepi-icon", 39);
    i0.ɵɵlistener("click", function LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_12_Template_lepi_icon_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const item_r5 = i0.ɵɵnextContext().$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.deleteFile(item_r5.url));
    });
    i0.ɵɵelementEnd();
  }
}
function LepiFileUploader_Conditional_5_div_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, LepiFileUploader_Conditional_5_div_1_div_1_ng_container_2_Template, 3, 2, "ng-container", 22)(3, LepiFileUploader_Conditional_5_div_1_div_1_ng_template_3_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementStart(5, "div", 23)(6, "p", 24);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(8, "div", 25);
    i0.ɵɵtemplate(9, LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_9_Template, 1, 0, "lepi-icon", 26)(10, LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_10_Template, 1, 0, "lepi-icon", 27)(11, LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_11_Template, 1, 0, "lepi-icon", 28)(12, LepiFileUploader_Conditional_5_div_1_div_1_lepi_icon_12_Template, 1, 0, "lepi-icon", 29);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const files_r7 = i0.ɵɵreference(4);
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.type() === "image")("ngIfElse", files_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c23, ctx_r0.direction === "row"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", item_r5.filename, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r5.status === "fail");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r5.status === "success");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !item_r5.status);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", item_r5.status);
  }
}
function LepiFileUploader_Conditional_5_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("cdkDropListDropped", function LepiFileUploader_Conditional_5_div_1_Template_div_cdkDropListDropped_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r0 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r0.onDrop($event));
    });
    i0.ɵɵtemplate(1, LepiFileUploader_Conditional_5_div_1_div_1_Template, 13, 10, "div", 19);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r8 = ctx.ngIf;
    i0.ɵɵproperty("cdkDropListData", items_r8)("cdkDropListDisabled", items_r8.length < 2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", items_r8);
  }
}
function LepiFileUploader_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LepiFileUploader_Conditional_5_div_0_Template, 9, 11, "div", 8)(1, LepiFileUploader_Conditional_5_div_1_Template, 2, 3, "div", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", ctx_r0.items().length !== ctx_r0.maxlength);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.items());
  }
}
const _c24 = ["*", "*"];
function LepiRadioOption_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label());
  }
}
function LepiRadioOption_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function LepiRadio_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-label", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("required", ctx_r0.required);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.label);
  }
}
function LepiSegmentItem_lepi_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("name", ctx_r1.icon);
  }
}
function LepiSegmentItem_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.label);
  }
}
function LepiSegmentItem_ng_content_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 0, ["*ngIf", "!label"]);
  }
}
function LepiSegmentItem_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.itemLength, " ");
  }
}
const _c25 = ["indicator"];
const _c26 = [[["", "icons", ""]], "*"];
const _c27 = ["[icons]", "*"];
const _c28 = a0 => ({
  "shadow-md border-b border-gray-200": a0
});
function LepiTopBar_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.description);
  }
}
function LepiTopBar_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0, 1);
  }
}
function LepiTopBar_For_9_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 7);
  }
  if (rf & 2) {
    const icon_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("name", icon_r3.icon);
  }
}
function LepiTopBar_For_9_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 8);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(icon_r3 == null ? null : icon_r3.label);
  }
}
function LepiTopBar_For_9_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵlistener("click", function LepiTopBar_For_9_Template_div_click_0_listener() {
      const icon_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      return i0.ɵɵresetView(icon_r3 == null ? null : icon_r3.handler());
    });
    i0.ɵɵtemplate(1, LepiTopBar_For_9_Conditional_1_Template, 1, 1, "lepi-icon", 7)(2, LepiTopBar_For_9_Conditional_2_Template, 2, 1, "p", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵconditional(icon_r3.icon ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(icon_r3.label ? 2 : -1);
  }
}
function LepiSideMenu_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.logo, i0.ɵɵsanitizeUrl);
  }
}
function LepiSideMenu_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 6);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.iconClass);
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
function LepiSideMenuItemGroup_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵprojection(2);
    i0.ɵɵelementEnd();
  }
}
const _c29 = [[["", "menu", ""]], [["", "header", ""]], [["", "content", ""]]];
const _c30 = ["[menu]", "[header]", "[content]"];
function LepiPageSelect_div_0_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function LepiPageSelect_div_0_div_1_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setPage(1));
    });
    i0.ɵɵelement(1, "lepi-icon", 6);
    i0.ɵɵelementEnd();
  }
}
function LepiPageSelect_div_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function LepiPageSelect_div_0_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.pageInfo.currentPage - 1));
    });
    i0.ɵɵelement(1, "lepi-icon", 7);
    i0.ɵɵelementEnd();
  }
}
function LepiPageSelect_div_0_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵlistener("click", function LepiPageSelect_div_0_div_3_Template_div_click_0_listener() {
      const page_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.pageInfo.currentPage !== page_r5 && ctx_r1.setPage(page_r5));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const page_r5 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.pageInfo.currentPage === page_r5 ? "bg-primary text-white" : "hover:bg-gray-100 text-gray-600 ");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", page_r5, " ");
  }
}
function LepiPageSelect_div_0_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function LepiPageSelect_div_0_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.pageInfo.currentPage + 1));
    });
    i0.ɵɵelement(1, "lepi-icon", 7);
    i0.ɵɵelementEnd();
  }
}
function LepiPageSelect_div_0_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function LepiPageSelect_div_0_div_5_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.setPage(ctx_r1.pageInfo.totalPages));
    });
    i0.ɵɵelement(1, "lepi-icon", 6);
    i0.ɵɵelementEnd();
  }
}
function LepiPageSelect_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵtemplate(1, LepiPageSelect_div_0_div_1_Template, 2, 0, "div", 2)(2, LepiPageSelect_div_0_div_2_Template, 2, 0, "div", 2)(3, LepiPageSelect_div_0_div_3_Template, 2, 2, "div", 3)(4, LepiPageSelect_div_0_div_4_Template, 2, 0, "div", 4)(5, LepiPageSelect_div_0_div_5_Template, 2, 0, "div", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pageInfo.currentPage > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pageInfo.currentPage > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.pages());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pageInfo.currentPage < ctx_r1.pageInfo.totalPages);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.pageInfo.currentPage < ctx_r1.pageInfo.totalPages);
  }
}
const _c31 = ["image"];
const LepiImage_Defer_3_DepsFn = () => [i1.NgClass];
function LepiImage_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.src, i0.ɵɵsanitizeUrl)("alt", ctx_r0.alt)("ngClass", ctx_r0.imageClass);
  }
}
function LepiImage_DeferLoading_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-skeleton");
  }
}
function LepiImage_DeferPlaceholder_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-skeleton");
  }
}
function LepiImage_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 1, 0);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("src", ctx_r0.src, i0.ɵɵsanitizeUrl);
  }
}
function LepiToggle_lepi_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 4);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.iconClass);
    i0.ɵɵproperty("name", ctx_r0.iconName);
  }
}
const _c32 = ["headerContent"];
const _c33 = [[["", "headerContent", ""]], [["", "buttons", ""]], "*"];
const _c34 = ["[headerContent]", "[buttons]", "*"];
function LepiAccordion_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 5);
  }
}
function LepiAccordion_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 6);
  }
}
function LepiAccordion_Conditional_9_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "lepi-hint");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const text_r1 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(text_r1);
  }
}
function LepiAccordion_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, LepiAccordion_Conditional_9_For_1_Template, 2, 1, "lepi-hint", null, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.hints);
  }
}
function LepiAccordion_Conditional_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵelement(1, "div", 10);
    i0.ɵɵprojection(2, 2);
    i0.ɵɵelementEnd();
  }
}
const _c35 = a0 => ({
  "bg-black/70": a0
});
function ModalComponent_ng_template_2_Template(rf, ctx) {}
function AlertComponent_lepi_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.iconClass);
    i0.ɵɵclassProp("bg-danger", ctx_r0.icon === "danger")("bg-success", ctx_r0.icon === "success");
    i0.ɵɵproperty("name", ctx_r0.headerIcon(ctx_r0.icon));
  }
}
function AlertComponent_ng_container_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "lepi-button", 10);
    i0.ɵɵlistener("click", function AlertComponent_ng_container_10_Template_lepi_button_click_1_listener() {
      const button_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.dismiss(button_r3));
    });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const button_r3 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("color", button_r3.color || "medium")("variant", (tmp_3_0 = button_r3.type) !== null && tmp_3_0 !== undefined ? tmp_3_0 : "solid");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(button_r3.text);
  }
}
function SideDialogComponent_Conditional_0_ng_template_1_Template(rf, ctx) {}
function SideDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 0);
    i0.ɵɵtemplate(1, SideDialogComponent_Conditional_0_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@slideLeftIn", undefined)("ngClass", ctx_r0.currentRounded());
  }
}
function SideDialogComponent_Conditional_1_ng_template_1_Template(rf, ctx) {}
function SideDialogComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "article", 0);
    i0.ɵɵtemplate(1, SideDialogComponent_Conditional_1_ng_template_1_Template, 0, 0, "ng-template", 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeIn", undefined)("ngClass", ctx_r0.currentRounded());
  }
}
function LepiModalHeaderComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 5);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r0.iconClass);
    i0.ɵɵproperty("name", ctx_r0.icon);
  }
}
const _c36 = [[["", "buttons", ""]]];
const _c37 = ["[buttons]"];
const LepiDataGrid_Defer_2_DepsFn = () => [i1.NgTemplateOutlet, import('./lepisode-ui-components-list-grid.component-pSWcz9gH.mjs').then(m => m.ListGridComponent), import('./lepisode-ui-components-group-grid.component-B7cDh5SR.mjs').then(m => m.GroupGridComponent)];
function LepiDataGrid_Defer_0_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "team-lepisode-list-grid", 5);
    i0.ɵɵlistener("checked", function LepiDataGrid_Defer_0_Conditional_0_Conditional_1_Template_team_lepisode_list_grid_checked_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.checked.emit($event));
    })("selectCurrentColumn", function LepiDataGrid_Defer_0_Conditional_0_Conditional_1_Template_team_lepisode_list_grid_selectCurrentColumn_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleGroup($event));
    })("itemDrop", function LepiDataGrid_Defer_0_Conditional_0_Conditional_1_Template_team_lepisode_list_grid_itemDrop_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.itemDrop.emit($event));
    });
    i0.ɵɵprojection(1, 0, ["buttons", ""]);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("enableGroup", ctx_r1.isGroup())("id", ctx_r1.id())("columns", ctx_r1.columns())("rowData", ctx_r1.rowData())("option", ctx_r1.option());
  }
}
function LepiDataGrid_Defer_0_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "team-lepisode-group-grid", 6);
    i0.ɵɵlistener("selectCurrentColumn", function LepiDataGrid_Defer_0_Conditional_0_Conditional_2_Template_team_lepisode_group_grid_selectCurrentColumn_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleGroup($event));
    })("disableGroup", function LepiDataGrid_Defer_0_Conditional_0_Conditional_2_Template_team_lepisode_group_grid_disableGroup_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.handleDisableGroup());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("defaultColumn", ctx_r1.defaultColumn())("id", ctx_r1.id())("columns", ctx_r1.columns())("rowData", ctx_r1.rowData())("option", ctx_r1.option());
  }
}
function LepiDataGrid_Defer_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 1);
    i0.ɵɵtemplate(1, LepiDataGrid_Defer_0_Conditional_0_Conditional_1_Template, 2, 5, "team-lepisode-list-grid", 3)(2, LepiDataGrid_Defer_0_Conditional_0_Conditional_2_Template, 1, 5, "team-lepisode-group-grid", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.isGroup() ? 1 : 2);
  }
}
function LepiDataGrid_Defer_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function LepiDataGrid_Defer_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, LepiDataGrid_Defer_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const loading_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", loading_r4);
  }
}
function LepiDataGrid_Defer_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, LepiDataGrid_Defer_0_Conditional_0_Template, 3, 1, "section", 1)(1, LepiDataGrid_Defer_0_Conditional_1_Template, 2, 1, "div", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵconditional(ctx_r1.visible() ? 0 : 1);
  }
}
function LepiDataGrid_DeferPlaceholder_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function LepiDataGrid_DeferPlaceholder_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, LepiDataGrid_DeferPlaceholder_1_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const loading_r4 = i0.ɵɵreference(5);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", loading_r4);
  }
}
function LepiDataGrid_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "lepi-icon", 8);
  }
}
function LepiGridFileDownload_Conditional_1_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-file-download", 1);
  }
  if (rf & 2) {
    const file_r1 = ctx.$implicit;
    i0.ɵɵproperty("url", file_r1.url)("name", file_r1.name);
  }
}
function LepiGridFileDownload_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, LepiGridFileDownload_Conditional_1_For_1_Template, 1, 2, "app-file-download", 1, i0.ɵɵrepeaterTrackByIndex);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r1.value());
  }
}
function LepiGridFileDownload_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-file-download", 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("url", ctx_r1.value().url)("name", ctx_r1.value().name);
  }
}
const _c38 = ["editorRef"];
const _c39 = a0 => ({
  minHeight: a0
});
const _c40 = a0 => ({
  "background-color": a0
});
function LepiEditor_Conditional_1_Conditional_37_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 38);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().deleteTable().run, $event));
    });
    i0.ɵɵelement(1, "lepi-icon", 39);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 40);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_2_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().addColumnAfter().run, $event));
    });
    i0.ɵɵelement(3, "lepi-icon", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "button", 42);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_4_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().addRowAfter().run, $event));
    });
    i0.ɵɵelement(5, "lepi-icon", 43);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 44);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_6_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().deleteColumn().run, $event));
    });
    i0.ɵɵelement(7, "lepi-icon", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 46);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_8_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().deleteRow().run, $event));
    });
    i0.ɵɵelement(9, "lepi-icon", 47);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 48);
    i0.ɵɵelement(11, "lepi-icon", 49);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "button", 50);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_12_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().splitCell().run, $event));
    });
    i0.ɵɵelement(13, "lepi-icon", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 52);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Conditional_37_Template_button_click_14_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().mergeCells().run, $event));
    });
    i0.ɵɵelement(15, "lepi-icon", 53);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const cellBackgroundColorMenu_r5 = i0.ɵɵreference(9);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("cdkMenuTriggerFor", cellBackgroundColorMenu_r5);
  }
}
function LepiEditor_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "section", 8)(1, "section", 10)(2, "lepi-select", 11);
    i0.ɵɵlistener("ngModelChange", function LepiEditor_Conditional_1_Template_lepi_select_ngModelChange_2_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.changeTextNode($event));
    });
    i0.ɵɵelementStart(3, "lepi-select-option", 12);
    i0.ɵɵtext(4, "\uC81C\uBAA9 1");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "lepi-select-option", 13);
    i0.ɵɵtext(6, "\uC81C\uBAA9 2");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "lepi-select-option", 14);
    i0.ɵɵtext(8, "\uC81C\uBAA9 3");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "lepi-select-option", 15);
    i0.ɵɵtext(10, "\uBB38\uB2E8");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(11, "section", 10)(12, "button", 16);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_12_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleBold().run, $event));
    });
    i0.ɵɵelement(13, "lepi-icon", 17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "button", 18);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_14_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleUnderline().run, $event));
    });
    i0.ɵɵelement(15, "lepi-icon", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "button", 20);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_16_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleItalic().run, $event));
    });
    i0.ɵɵelement(17, "lepi-icon", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 22);
    i0.ɵɵelement(19, "lepi-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 24);
    i0.ɵɵelement(21, "lepi-icon", 25);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "section", 10)(23, "button", 26);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_23_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleBulletList().run, $event));
    });
    i0.ɵɵelement(24, "lepi-icon", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "button", 28);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_25_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleOrderedList().run, $event));
    });
    i0.ɵɵelement(26, "lepi-icon", 29);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "button", 30);
    i0.ɵɵelement(28, "lepi-icon", 31);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(29, "section", 10)(30, "button", 32);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_30_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.selectImage($event));
    });
    i0.ɵɵelement(31, "lepi-icon", 33);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "button", 34);
    i0.ɵɵelement(33, "lepi-icon", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(34, "section", 10)(35, "button", 36);
    i0.ɵɵlistener("click", function LepiEditor_Conditional_1_Template_button_click_35_listener($event) {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().insertTable({
        rows: 3,
        cols: 3,
        withHeaderRow: false
      }).run, $event));
    });
    i0.ɵɵelement(36, "lepi-icon", 37);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(37, LepiEditor_Conditional_1_Conditional_37_Template, 16, 1);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const textColorMenu_r6 = i0.ɵɵreference(5);
    const backgroundColorMenu_r7 = i0.ɵɵreference(7);
    const textAlignMenu_r8 = i0.ɵɵreference(11);
    const youtubeForm_r9 = i0.ɵɵreference(13);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngModel", ctx_r2.currentNodeTextSize());
    i0.ɵɵadvance(10);
    i0.ɵɵclassProp("active", (ctx_r2.editor == null ? null : ctx_r2.editor.isActive("bold")) ? ctx_r2.editor == null ? null : ctx_r2.editor.isActive("bold") : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("active", (ctx_r2.editor == null ? null : ctx_r2.editor.isActive("underline")) ? ctx_r2.editor == null ? null : ctx_r2.editor.isActive("underline") : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("active", (ctx_r2.editor == null ? null : ctx_r2.editor.isActive("italic")) ? ctx_r2.editor == null ? null : ctx_r2.editor.isActive("italic") : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cdkMenuTriggerFor", textColorMenu_r6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(18, _c40, (ctx_r2.editor == null ? null : ctx_r2.editor.getAttributes("textStyle")["color"]) || "#000 !important"));
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", (ctx_r2.editor == null ? null : ctx_r2.editor.isActive("highlight")) ? ctx_r2.editor == null ? null : ctx_r2.editor.isActive("highlight") : undefined);
    i0.ɵɵproperty("cdkMenuTriggerFor", backgroundColorMenu_r7);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(20, _c40, (ctx_r2.editor == null ? null : ctx_r2.editor.getAttributes("highlight")["color"]) || "#000 !important"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("cdkMenuTriggerFor", textAlignMenu_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", ctx_r2.currentTextAlignIcon());
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("cdkMenuTriggerFor", youtubeForm_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", (ctx_r2.editor == null ? null : ctx_r2.editor.isActive("table")) ? ctx_r2.editor == null ? null : ctx_r2.editor.isActive("table") : undefined);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((ctx_r2.editor == null ? null : ctx_r2.editor.isActive("table")) ? 37 : -1);
  }
}
function LepiEditor_ng_template_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_4_For_2_Template_button_click_0_listener($event) {
      const color_r11 = i0.ɵɵrestoreView(_r10).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().setColor(color_r11).run, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const color_r11 = ctx.$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c40, color_r11));
  }
}
function LepiEditor_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵrepeaterCreate(1, LepiEditor_ng_template_4_For_2_Template, 1, 3, "button", 55, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.colors);
  }
}
function LepiEditor_ng_template_6_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_6_For_2_Template_button_click_0_listener($event) {
      const color_r13 = i0.ɵɵrestoreView(_r12).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().toggleHighlight({
        color: color_r13
      }).run, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const color_r13 = ctx.$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c40, color_r13));
  }
}
function LepiEditor_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵrepeaterCreate(1, LepiEditor_ng_template_6_For_2_Template, 1, 3, "button", 55, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.colors);
  }
}
function LepiEditor_ng_template_8_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 56);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_8_For_2_Template_button_click_0_listener($event) {
      const color_r15 = i0.ɵɵrestoreView(_r14).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().setCellAttribute("backgroundColor", color_r15).run, $event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const color_r15 = ctx.$implicit;
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(1, _c40, color_r15));
  }
}
function LepiEditor_ng_template_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 54);
    i0.ɵɵrepeaterCreate(1, LepiEditor_ng_template_8_For_2_Template, 1, 3, "button", 55, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r2.colors);
  }
}
function LepiEditor_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 57)(1, "button", 58);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_10_Template_button_click_1_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().setTextAlign("left").run, $event));
    });
    i0.ɵɵelement(2, "lepi-icon", 59);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "button", 58);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_10_Template_button_click_3_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().setTextAlign("center").run, $event));
    });
    i0.ɵɵelement(4, "lepi-icon", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 58);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_10_Template_button_click_5_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.handleCommand(ctx_r2.editor.chain().focus().setTextAlign("right").run, $event));
    });
    i0.ɵɵelement(6, "lepi-icon", 61);
    i0.ɵɵelementEnd()();
  }
}
function LepiEditor_ng_template_12_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "youtube-player", 65);
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const youtubeInputRef_r18 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("videoId", ctx_r2.getYouTubeVideoId(youtubeInputRef_r18.value()));
  }
}
function LepiEditor_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 62)(1, "h5", 63);
    i0.ɵɵtext(2, "\uC720\uD29C\uBE0C \uB3D9\uC601\uC0C1 \uCD94\uAC00");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "lepi-input-text", 64, 6);
    i0.ɵɵtemplate(5, LepiEditor_ng_template_12_Conditional_5_Template, 1, 1, "youtube-player", 65);
    i0.ɵɵelementStart(6, "lepi-button", 66);
    i0.ɵɵlistener("click", function LepiEditor_ng_template_12_Template_lepi_button_click_6_listener() {
      i0.ɵɵrestoreView(_r17);
      const youtubeInputRef_r18 = i0.ɵɵreference(4);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.addYoutube(youtubeInputRef_r18.value()));
    });
    i0.ɵɵtext(7, "\uCD94\uAC00");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const youtubeInputRef_r18 = i0.ɵɵreference(4);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵconditional(ctx_r2.isYoutubeUrl(youtubeInputRef_r18.value()) ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", !ctx_r2.isYoutubeUrl(youtubeInputRef_r18.value()));
  }
}
const LEPI_GLOBAL_CONFIG_TOKEN = new InjectionToken('LEPI_GLOBAL_CONFIG_TOKEN');
const LEPI_EDITOR_IMAGE_HANDLER = new InjectionToken('LEPI_EDITOR_IMAGE_HANDLER');
class BaseComponent {
  constructor() {
    this.config = signal({});
    const _config = inject(LEPI_GLOBAL_CONFIG_TOKEN, {
      optional: true
    });
    if (_config) {
      this.config.set(_config);
    }
  }
}
let LepiIcon = /*#__PURE__*/(() => {
  class LepiIcon {
    constructor() {
      this.maskSize = 'cover';
      this.webkitMaskSize = 'cover';
    }
    get backgroundImage() {
      return `url(${this._name})`;
    }
    get webkitMaskImage() {
      return `url(${this._name})`;
    }
    get _name() {
      return encodeURI(`https://api.iconify.design/${this.name}.svg`);
    }
    static {
      this.ɵfac = function LepiIcon_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiIcon)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiIcon,
        selectors: [["lepi-icon"]],
        hostVars: 8,
        hostBindings: function LepiIcon_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("mask-size", ctx.maskSize)("mask-image", ctx.backgroundImage)("-webkit-mask-size", ctx.webkitMaskSize)("-webkit-mask-image", ctx.webkitMaskImage);
          }
        },
        inputs: {
          name: "name"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 0,
        vars: 0,
        template: function LepiIcon_Template(rf, ctx) {},
        dependencies: [CommonModule]
      });
    }
  }
  return LepiIcon;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const BUTTON_SIZE = {
  sm: 'px-2 py-1 text-xs',
  md: 'px-3 py-1.5 text-sm',
  lg: 'px-4 py-2 text-base',
  xl: 'px-5 py-3 text-lg'
};
const BUTTON_ROUNDED = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full'
};
const BUTTON_STYLE = {
  solid: {
    primary: 'bg-primary text-white',
    secondary: 'bg-secondary text-white ',
    tertiary: 'bg-tertiary text-white ',
    light: 'bg-light text-white ',
    danger: 'bg-danger text-white ',
    warning: 'bg-warning text-white ',
    success: 'bg-success text-white ',
    medium: 'bg-medium text-white ',
    dark: ''
  },
  text: {
    primary: 'text-primary',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
    light: 'text-light',
    danger: 'text-danger',
    warning: 'text-warning',
    success: 'text-success',
    medium: 'text-medium',
    dark: 'text-dark'
  },
  outline: {
    primary: 'border border-primary text-primary',
    secondary: 'border border-secondary text-secondary',
    tertiary: 'border border-tertiary text-tertiary',
    light: 'border border-light text-light',
    danger: 'border border-danger text-danger',
    warning: 'border border-warning text-warning',
    success: 'border border-success text-success',
    medium: 'border border-medium text-medium',
    dark: 'border border-dark text-dark'
  }
};
const BUTTON_STATE_STYLE = {
  solid: {
    primary: 'hover:bg-primary-400 active:bg-primary-300 disabled:bg-gray-200',
    secondary: 'hover:bg-secondary-400 active:bg-secondary-300  disabled:bg-gray-200',
    tertiary: 'hover:bg-tertiary-400 active:bg-tertiary-300  disabled:bg-gray-200',
    light: 'hover:bg-light-400 active:bg-light-300  disabled:bg-gray-200',
    danger: 'hover:bg-danger-400 active:bg-danger-300  disabled:bg-gray-200',
    warning: 'hover:bg-warning-400 active:bg-warning-300  disabled:bg-gray-200',
    success: 'hover:bg-success-400 active:bg-success-300  disabled:bg-gray-200',
    medium: 'hover:bg-medium-400 active:bg-medium-300  disabled:bg-gray-200',
    dark: 'hover:bg-dark-400 active:bg-dark-300  disabled:bg-gray-200'
  },
  text: {
    primary: 'text-primary hover:bg-gray-100 active:bg-gray-200',
    secondary: 'text-secondary hover:bg-gray-100 active:bg-gray-200',
    tertiary: 'text-tertiary hover:bg-gray-100 active:bg-gray-200',
    light: 'text-light hover:bg-gray-100 active:bg-gray-200',
    danger: 'text-danger hover:bg-gray-100 active:bg-gray-200',
    warning: 'text-warning hover:bg-gray-100 active:bg-gray-200',
    success: 'text-success hover:bg-gray-100 active:bg-gray-200',
    medium: 'text-medium hover:bg-gray-100 active:bg-gray-200',
    dark: 'text-dark hover:bg-gray-100 active:bg-gray-200'
  },
  outline: {
    primary: 'border-primary text-primary hover:bg-primary-100 active:bg-primary-200',
    secondary: 'border-secondary text-secondary hover:bg-secondary-100 active:bg-secondary-200',
    tertiary: 'border-tertiary text-tertiary hover:bg-tertiary-100 active:bg-tertiary-200',
    light: 'border-light text-light hover:bg-light-100 active:bg-light-200',
    danger: 'border-danger text-danger hover:bg-danger-100 active:bg-danger-200',
    warning: 'border-warning text-warning hover:bg-warning-100 active:bg-warning-200',
    success: 'border-success text-success hover:bg-success-100 active:bg-success-200',
    medium: 'border-medium text-medium hover:bg-medium-100 active:bg-medium-200',
    dark: 'border-dark text-dark hover:bg-dark-100 active:bg-dark-200'
  }
};
let LepiButton = /*#__PURE__*/(() => {
  class LepiButton extends BaseComponent {
    get hostClasses() {
      if (this.expand()) {
        return 'w-full';
      }
      return '';
    }
    constructor() {
      super();
      this.buttonConfig = computed(() => this.config()?.button);
      this.variant = input('solid');
      this.color = input('primary');
      this.size = input(null);
      this.rounded = input(null);
      this.type = input('button');
      this.icon = input();
      this.expand = input(false, {
        transform: booleanAttribute
      });
      this.disabled = input(false, {
        transform: booleanAttribute
      });
      this.styles = signal(BUTTON_STYLE);
      this.stateStyles = signal(BUTTON_STATE_STYLE);
      this.currentStyle = computed(() => this.styles()[this.variant()][this.color()]);
      this.currentStateStyle = computed(() => this.stateStyles()[this.variant()][this.color()]);
      this.currentSize = computed(() => {
        if (!this.size()) {
          return BUTTON_SIZE[this.buttonConfig()?.size || 'md'];
        }
        return BUTTON_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return BUTTON_ROUNDED[this.buttonConfig()?.rounded || 'md'];
        }
        return BUTTON_ROUNDED[this.rounded()];
      });
    }
    static {
      this.ɵfac = function LepiButton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiButton)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiButton,
        selectors: [["lepi-button"]],
        hostVars: 2,
        hostBindings: function LepiButton_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.hostClasses);
          }
        },
        inputs: {
          variant: [1, "variant"],
          color: [1, "color"],
          size: [1, "size"],
          rounded: [1, "rounded"],
          type: [1, "type"],
          icon: [1, "icon"],
          expand: [1, "expand"],
          disabled: [1, "disabled"]
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 11,
        consts: [[1, "min-w-max", 3, "type", "ngClass", "disabled"], [1, "h-5", "bg-current", "aspect-square", 3, "name"]],
        template: function LepiButton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "button", 0);
            i0.ɵɵtemplate(1, LepiButton_Conditional_1_Template, 1, 1, "lepi-icon", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("w-full", ctx.expand());
            i0.ɵɵproperty("type", ctx.type())("ngClass", i0.ɵɵpureFunction4(6, _c1, ctx.currentStyle(), ctx.currentStateStyle(), ctx.currentSize(), ctx.currentRounded()))("disabled", ctx.disabled());
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.icon() ? 1 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiIcon],
        styles: ["button[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;gap:.5rem;font-weight:600;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}button[_ngcontent-%COMP%]:disabled{cursor:not-allowed;--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity))}"]
      });
    }
  }
  return LepiButton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiBadge = /*#__PURE__*/(() => {
  class LepiBadge {
    constructor() {
      this.color = 'primary';
      this.type = 'solid';
      this.active = false;
      this.styles = {
        solid: {
          primary: 'bg-primary text-white',
          secondary: 'bg-secondary text-white',
          tertiary: 'bg-tertiary text-white',
          light: 'bg-light text-white',
          danger: 'bg-danger text-white',
          warning: 'bg-warning text-white',
          success: 'bg-success text-white',
          medium: 'bg-medium text-white'
        },
        outline: {
          primary: 'text-primary border border-primary-200 text-primary-600 bg-primary-50',
          secondary: 'text-secondary border border-secondary-200 text-secondary-600 bg-secondary-50',
          tertiary: 'text-tertiary border border-tertiary-200 text-tertiary-600 bg-tertiary-50',
          light: 'text-light border border-light-200 text-light-600 bg-light-50',
          danger: 'text-danger border border-danger-200 text-danger-600 bg-danger-50',
          warning: 'text-warning border border-warning-200 text-warning-600 bg-warning-50',
          success: 'text-success border border-success-200 text-success-600 bg-success-50',
          medium: 'text-medium border border-medium-200 text-medium-600 bg-medium-50'
        }
      };
    }
    static {
      this.ɵfac = function LepiBadge_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiBadge)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiBadge,
        selectors: [["lepi-badge"]],
        inputs: {
          color: "color",
          type: "type",
          active: "active"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 3,
        consts: [[1, "badge", 3, "ngClass"]],
        template: function LepiBadge_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("active", ctx.active);
            i0.ɵɵproperty("ngClass", ctx.styles[ctx.type][ctx.color]);
          }
        },
        dependencies: [CommonModule, i1.NgClass],
        styles: [".cdk-overlay-container[_ngcontent-%COMP%], .cdk-global-overlay-wrapper[_ngcontent-%COMP%]{pointer-events:none;top:0;left:0;height:100%;width:100%}.cdk-overlay-container[_ngcontent-%COMP%]{position:fixed;z-index:1000}.cdk-overlay-container[_ngcontent-%COMP%]:empty{display:none}.cdk-global-overlay-wrapper[_ngcontent-%COMP%]{display:flex;position:absolute;z-index:1000}.cdk-overlay-pane[_ngcontent-%COMP%]{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}.cdk-overlay-backdrop[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:rgba(0,0,0,0);transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}.cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]   .cdk-overlay-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:.6}.cdk-overlay-dark-backdrop[_ngcontent-%COMP%]{background:#00000052}.cdk-overlay-transparent-backdrop[_ngcontent-%COMP%]{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing[_ngcontent-%COMP%]{opacity:0;visibility:visible}.cdk-overlay-backdrop-noop-animation[_ngcontent-%COMP%]{transition:none}.cdk-overlay-connected-position-bounding-box[_ngcontent-%COMP%]{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}.cdk-global-scrollblock[_ngcontent-%COMP%]{position:fixed;width:100%;overflow-y:scroll}div.badge[_ngcontent-%COMP%]{display:flex;height:max-content;width:max-content;-webkit-user-select:none;user-select:none;align-items:center;justify-content:center;border-radius:.75rem;padding:.125rem .5rem;font-size:.75rem;line-height:1rem;outline:2px solid transparent;outline-offset:2px;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}div.badge[_ngcontent-%COMP%]:empty{display:none}"]
      });
    }
  }
  return LepiBadge;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-empty-function */
function createProviders(type) {
  return [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true
  }];
}
class CustomValueAccessor {
  constructor() {
    this.disabled = false;
    this.required = false;
    this.touched = false;
    this.onChange = value => {};
    this.onTouched = () => {};
    this.onValidationchange = () => {};
  }
  set value(newValue) {
    if (this._value === newValue) {
      return;
    }
    this._value = newValue;
    this.onChange(newValue);
    this.onTouched();
    this.touched = true;
  }
  get value() {
    return this._value;
  }
  writeValue(value) {
    this.value = value;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  setDisabledState(disabled) {
    this.disabled = disabled;
  }
  registerOnValidatorChange(fn) {
    this.onValidationchange = fn;
  }
}
let LepiCheckbox = /*#__PURE__*/(() => {
  class LepiCheckbox extends CustomValueAccessor {
    constructor() {
      super(...arguments);
      this.selected = new EventEmitter();
    }
    toggle() {
      this.value = !this.value;
      this.selected.emit(this.value);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵLepiCheckbox_BaseFactory;
        return function LepiCheckbox_Factory(__ngFactoryType__) {
          return (ɵLepiCheckbox_BaseFactory || (ɵLepiCheckbox_BaseFactory = i0.ɵɵgetInheritedFactory(LepiCheckbox)))(__ngFactoryType__ || LepiCheckbox);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiCheckbox,
        selectors: [["lepi-checkbox"]],
        inputs: {
          label: "label",
          description: "description",
          modelValue: "modelValue"
        },
        outputs: {
          selected: "selected"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiCheckbox,
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 8,
        vars: 7,
        consts: [[1, "flex", "items-center", "gap-3", "select-none", "group"], [1, "relative", "flex", "items-center", "justify-center", "w-5", "h-5", "transition-all", "duration-200", "border-2", "rounded-sm", "cursor-pointer", "shrink-0", 3, "click", "ngClass"], [1, "absolute", "w-0", "h-0", "rounded-full", "-z-10", "group-hover:bg-primary-50", "group-hover:w-9", "group-hover:h-9", "group-hover:transition-all", "group-hover:ease-in-out", "group-hover:duration-200"], ["class", "w-4 h-4 text-white bg-white", "name", "mdi:check", 4, "ngIf"], [1, "flex", "flex-col", "gap-1", "text-sm", "cursor-pointer", 3, "click"], ["class", "text-sm", 4, "ngIf"], ["class", "text-sm text-gray-500", 4, "ngIf"], ["name", "mdi:check", 1, "w-4", "h-4", "text-white", "bg-white"], [1, "text-sm"], [1, "text-sm", "text-gray-500"]],
        template: function LepiCheckbox_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function LepiCheckbox_Template_div_click_1_listener() {
              return ctx.toggle();
            });
            i0.ɵɵelement(2, "div", 2);
            i0.ɵɵtemplate(3, LepiCheckbox_lepi_icon_3_Template, 1, 0, "lepi-icon", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵlistener("click", function LepiCheckbox_Template_div_click_4_listener() {
              return ctx.toggle();
            });
            i0.ɵɵtemplate(5, LepiCheckbox_div_5_Template, 2, 0, "div", 5)(6, LepiCheckbox_p_6_Template, 2, 1, "p", 5)(7, LepiCheckbox_p_7_Template, 2, 1, "p", 6);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.value ? "border-primary-500 bg-primary-500" : "bg-white border-gray-400");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.value);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("active", ctx.value);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.description);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, ReactiveFormsModule, LepiIcon]
      });
    }
  }
  return LepiCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const LABEL_SIZE = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-base',
  xl: 'text-lg'
};
let LepiLabel = /*#__PURE__*/(() => {
  class LepiLabel {
    constructor(config) {
      this.config = config;
      this.required = false;
      this.size = input(null);
      this.currentSize = computed(() => {
        if (!this.size()) {
          return LABEL_SIZE[this.config?.label?.size || 'md'];
        }
        return LABEL_SIZE[this.size()];
      });
    }
    static {
      this.ɵfac = function LepiLabel_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiLabel)(i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiLabel,
        selectors: [["lepi-label"]],
        inputs: {
          required: "required",
          size: [1, "size"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 2,
        consts: [[1, "font-semibold", "flex", "gap-0.5", 3, "ngClass"], ["class", "text-primary", 4, "ngIf"], [1, "text-primary"]],
        template: function LepiLabel_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "label", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵtemplate(2, LepiLabel_p_2_Template, 2, 0, "p", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.currentSize());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.required);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf]
      });
    }
  }
  return LepiLabel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiMultiLepiCheckbox = /*#__PURE__*/(() => {
  class LepiMultiLepiCheckbox {
    constructor() {
      this.required = input(false, {
        transform: booleanAttribute
      });
      this.label = input(null);
      this.grid = input(0, {
        transform: numberAttribute
      });
      this.display = computed(() => {
        if (!this.grid()) {
          return 'flex';
        }
        return `grid grid-cols-${this.grid()}`;
      });
      this.value = signal([]);
      this.onChange = value => {};
      this.onTouched = () => {};
      effect(() => {
        this.checkboxes.map(checkbox => {
          if (!checkbox.modelValue) {
            return false;
          }
          return checkbox.value = this.value().includes(checkbox.modelValue);
        });
        this.writeValue(this.value());
        this.onChange(this.value());
      }, {
        allowSignalWrites: true
      });
    }
    ngAfterContentInit() {
      merge(...this.checkboxes.map(checkbox => checkbox.selected)).subscribe(item => {
        const filtered = this.checkboxes.filter(checkbox => {
          if (!checkbox.modelValue) {
            return false;
          }
          return checkbox.value;
        }).map(checkbox => checkbox.modelValue);
        this.value.set(filtered);
      });
    }
    writeValue(obj) {
      this.value.set(obj);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {}
    static {
      this.ɵfac = function LepiMultiLepiCheckbox_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiMultiLepiCheckbox)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiMultiLepiCheckbox,
        selectors: [["lepi-multi-checkbox"]],
        contentQueries: function LepiMultiLepiCheckbox_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiCheckbox, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxes = _t);
          }
        },
        inputs: {
          required: [1, "required"],
          label: [1, "label"],
          grid: [1, "grid"]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiMultiLepiCheckbox,
          multi: true
        }]), i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [[1, "flex", "flex-col", "gap-2"], [3, "required"], [1, "gap-3", 3, "ngClass"]],
        template: function LepiMultiLepiCheckbox_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LepiMultiLepiCheckbox_Conditional_1_Template, 2, 2, "lepi-label", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.label() ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.display());
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiLabel]
      });
    }
  }
  return LepiMultiLepiCheckbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const components$3 = [LepiCheckbox, LepiMultiLepiCheckbox];
let LepiCheckboxModule = /*#__PURE__*/(() => {
  class LepiCheckboxModule {
    static {
      this.ɵfac = function LepiCheckboxModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiCheckboxModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LepiCheckboxModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [components$3]
      });
    }
  }
  return LepiCheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const INPUT_SIZE = {
  sm: {
    wrapper: 'px-2 text-xs',
    input: 'py-1 text-xs'
  },
  md: {
    wrapper: 'px-3 text-sm',
    input: 'py-1.5 text-sm'
  },
  lg: {
    wrapper: 'px-4 text-base',
    input: 'py-2 text-base'
  },
  xl: {
    wrapper: 'px-5 text-lg',
    input: 'py-3 text-lg'
  }
};
const INPUT_ROUNDED = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full'
};

/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-function */
let LepiInputNumber = /*#__PURE__*/(() => {
  class LepiInputNumber {
    get invalid() {
      return (this.control?.touched || false) && this.control?.invalid;
    }
    get valid() {
      return (this.control?.touched || false) && this.control?.valid;
    }
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.label = null;
      this.required = false;
      this.min = null;
      this.max = null;
      this.maxLength = null;
      this.debounce = 0;
      this.format = false;
      this.disabled = false;
      this.readonly = false;
      this.prefix = null;
      this.suffix = null;
      this.output = new EventEmitter();
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    writeValue(number) {
      this.value = `${number}`;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    ngOnInit() {
      /** FormControl Instance 주입 */
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
        if (this.control?.hasValidator(Validators.required)) {
          this.required = true;
        }
      }
    }
    ngAfterViewInit() {
      if (this.inputRef) {
        setTimeout(() => {
          let cleanedValue = this.inputRef.nativeElement.value.replace(/[^-0-9.]/g, '');
          if (this.format) {
            let integerPart = cleanedValue.split('.')[0];
            let decimalPart = cleanedValue.split('.')[1];
            cleanedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            if (decimalPart) {
              cleanedValue += '.' + decimalPart;
            }
            this.inputRef.nativeElement.value = cleanedValue;
            this.writeValue(cleanedValue);
            this.onChange(Number(`${this.value?.replace(/[^-0-9.]/g, '')}`));
          } else {
            this.writeValue(cleanedValue);
            this.onChange(Number(`${cleanedValue}`));
          }
        }, 200);
      }
    }
    OnInput(ev) {
      this.output.emit();
      const currentValue = this.inputRef.nativeElement.value;
      if (!currentValue) {
        this.inputRef.nativeElement.value = `${this.value}` ?? '0';
        if (!this.placeholder) this.placeholder = '0';
        this.writeValue('');
        this.onChange(0);
        return;
      }
      let cleanedValue = currentValue.replace(/[^-0-9.]/g, '');
      if ((cleanedValue.match(/\./g) ?? '').length > 1) {
        cleanedValue = cleanedValue.substring(0, cleanedValue.lastIndexOf('.'));
      }
      if (this.format) {
        let integerPart = cleanedValue.split('.')[0];
        let decimalPart = '';
        if (cleanedValue.includes('.')) decimalPart = `.${cleanedValue.split('.')[1]}`;
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        if (decimalPart) {
          cleanedValue = integerPart + decimalPart;
        } else {
          cleanedValue = integerPart;
        }
        this.inputRef.nativeElement.value = cleanedValue;
        this.writeValue(cleanedValue);
      } else {
        this.inputRef.nativeElement.value = cleanedValue;
        this.writeValue(cleanedValue);
      }
      this.onChange(Number(cleanedValue.replace(/,/g, '')));
      if (this.maxLength) this.inputRef.nativeElement.maxLength = this.maxLength;
    }
    static {
      this.ɵfac = function LepiInputNumber_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputNumber)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputNumber,
        selectors: [["lepi-input-number"]],
        viewQuery: function LepiInputNumber_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          placeholder: "placeholder",
          min: [2, "min", "min", numberAttribute],
          max: [2, "max", "max", numberAttribute],
          maxLength: [2, "maxLength", "maxLength", numberAttribute],
          debounce: [2, "debounce", "debounce", numberAttribute],
          format: [2, "format", "format", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          readonly: [2, "readonly", "readonly", booleanAttribute],
          prefix: "prefix",
          suffix: "suffix"
        },
        outputs: {
          output: "output"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputNumber,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 10,
        vars: 22,
        consts: [["inputRef", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [1, "flex", "items-center", "gap-2", "transition-colors", "border-2", "border-neutral-300", "group", 3, "ngClass"], ["class", "transition-colors text-neutral-400 group-focus-within:text-neutral-700", 4, "ngIf"], ["type", "text", 1, "w-full", "outline-none", "text-neutral-700", "disabled:cursor-not-allowed", "read-only:cursor-default", 3, "input", "ngClass", "required", "disabled", "readOnly", "placeholder", "max", "min", "ngModel"], [1, "transition-colors", "text-neutral-500", "group-focus-within:text-neutral-700"], ["class", "text-sm text-neutral-500", 4, "ngIf"], [4, "ngIf"], [3, "required"], [1, "transition-colors", "text-neutral-400", "group-focus-within:text-neutral-700"], [1, "text-sm", "text-neutral-500"], ["class", "text-sm text-danger-500", 4, "ngIf"], [1, "text-sm", "text-danger-500"]],
        template: function LepiInputNumber_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiInputNumber_lepi_label_1_Template, 2, 2, "lepi-label", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, LepiInputNumber_p_3_Template, 2, 1, "p", 4);
            i0.ɵɵelementStart(4, "input", 5, 0);
            i0.ɵɵlistener("input", function LepiInputNumber_Template_input_input_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.OnInput($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "p", 6);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, LepiInputNumber_p_8_Template, 2, 0, "p", 7)(9, LepiInputNumber_ng_container_9_Template, 4, 3, "ng-container", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(18, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.prefix);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.currentSize().input)("required", ctx.required)("disabled", ctx.disabled)("readOnly", ctx.readonly)("placeholder", ctx.placeholder)("max", ctx.max)("min", ctx.min)("ngModel", ctx.value);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.suffix, " ");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.readonly);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control == null ? null : ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, LepiLabel]
      });
    }
  }
  return LepiInputNumber;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
let LepiInputText = /*#__PURE__*/(() => {
  class LepiInputText {
    get valid() {
      return this.control?.touched && !this.control?.errors;
    }
    get invalid() {
      return this.control?.touched && this.control?.errors;
    }
    constructor(config) {
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.ngControl = null;
      this.value = signal('');
      this.autocomplete = false;
      this.debounce = 0;
      this.readonly = false;
      this.showLength = false;
      this.inputMode = input('text');
      this.required = false;
      this.disabled = false;
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    ngOnInit() {
      if (this.control?.hasValidator(Validators.required)) {
        this.required = true;
      }
      if (this.showLength && this.maxlength === undefined) {
        throw Error('maxlength is required when showLength is true');
      }
    }
    ngAfterViewInit() {
      fromEvent(this.inputRef.nativeElement, 'input').pipe(debounceTime(this.debounce)).subscribe({
        next: () => {
          this.value.set(this.inputRef.nativeElement.value);
          this.onChange(this.inputRef.nativeElement.value);
        }
      });
    }
    writeValue(obj) {
      this.value.set(obj);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {}
    static {
      this.ɵfac = function LepiInputText_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputText)(i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputText,
        selectors: [["lepi-input-text"]],
        viewQuery: function LepiInputText_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          placeholder: "placeholder",
          autocomplete: [2, "autocomplete", "autocomplete", booleanAttribute],
          debounce: [2, "debounce", "debounce", numberAttribute],
          icon: "icon",
          maxlength: "maxlength",
          readonly: [2, "readonly", "readonly", booleanAttribute],
          showLength: [2, "showLength", "showLength", booleanAttribute],
          hint: "hint",
          inputMode: [1, "inputMode"],
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputText,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 23,
        consts: [["inputRef", ""], [1, "flex", "flex-col", "gap-2"], ["class", "flex items-center gap-2", 4, "ngIf"], [1, "flex", "items-center", "gap-2", "transition-colors", "border-2", "border-gray-300", "group", 3, "ngClass"], ["class", "w-5 h-5 bg-neutral-400 group-focus-within:bg-primary group-hover:bg-primary", 3, "name", 4, "ngIf"], ["type", "text", 1, "w-full", "outline-none", "text-neutral-700", "disabled:cursor-not-allowed", 3, "ngClass", "ngModel", "required", "readonly", "disabled", "placeholder", "autocomplete", "maxlength", "inputMode"], ["class", "text-sm text-neutral-500", 4, "ngIf"], [4, "ngIf"], [1, "flex", "items-center", "gap-2"], [3, "required"], ["class", "flex items-center gap-2 px-2 py-1 text-xs text-gray-700 rounded-md bg-primary-100 w-max", 4, "ngIf"], [1, "flex", "items-center", "gap-2", "px-2", "py-1", "text-xs", "text-gray-700", "rounded-md", "bg-primary-100", "w-max"], ["name", "mdi:information-slab-circle", 1, "w-4", "h-4", "bg-primary"], [1, "mb-px"], [1, "w-5", "h-5", "bg-neutral-400", "group-focus-within:bg-primary", "group-hover:bg-primary", 3, "name"], [1, "text-sm", "text-neutral-500"], ["class", "text-sm text-danger-500", 4, "ngIf"], [1, "text-sm", "text-danger-500"]],
        template: function LepiInputText_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiInputText_div_1_Template, 4, 3, "div", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵtemplate(3, LepiInputText_lepi_icon_3_Template, 1, 1, "lepi-icon", 4);
            i0.ɵɵelement(4, "input", 5, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, LepiInputText_p_6_Template, 2, 0, "p", 6)(7, LepiInputText_div_7_Template, 3, 2, "div", 7)(8, LepiInputText_ng_container_8_Template, 2, 1, "ng-container", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_13_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(19, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.currentSize().input)("ngModel", ctx.value())("required", ctx.required)("readonly", ctx.readonly)("disabled", ctx.disabled)("placeholder", ctx.placeholder || "")("autocomplete", ctx.autocomplete ? "on" : "off")("maxlength", (tmp_13_0 = ctx.maxlength) !== null && tmp_13_0 !== undefined ? tmp_13_0 : 100)("inputMode", ctx.inputMode());
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.readonly);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showLength);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control == null ? null : ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.MaxLengthValidator, i2.NgModel, LepiLabel, LepiIcon, ReactiveFormsModule]
      });
    }
  }
  return LepiInputText;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiCalendar = /*#__PURE__*/(() => {
  class LepiCalendar extends CustomValueAccessor {
    constructor() {
      super();
      this.keyupDate = input(null);
      this.class = input('');
      this.selected = output();
      this.width = '100%';
      this.currentDate = dayjs();
      this.days = [];
      this.isYearSelectorOpen = false;
      this.isMonthSelectorOpen = false;
      this.gridX = 4;
      this.gridY = 6;
      this.handleSelectDate = day => {
        if (dayjs(this.currentDate).month() > day.month()) {
          this.prevMonth();
        } else if (dayjs(this.currentDate).month() < day.month()) {
          this.nextMonth();
        }
        this.onChange(day.toDate());
        this.selected.emit(day.toDate());
      };
      this.years = Array.from({
        length: 100
      }, (_, i) => dayjs().add(10, 'year').year() - i);
      effect(() => {
        if (this.keyupDate()) {
          this.setDate(this.keyupDate());
        } else {
          this.setDate(new Date());
        }
      });
    }
    setDate(date) {
      this.value = dayjs(date).toDate();
      this.currentDate = dayjs(date);
      this.setDays();
    }
    ngOnInit() {
      this.value = this.value || new Date();
      this.setDays();
    }
    // 년도 선택 로직
    handleYearSelect(year) {
      this.currentDate = this.currentDate.set('year', year);
      this.setDays();
      this.isYearSelectorOpen = false;
    }
    handleMonthSelect(month) {
      this.currentDate = this.currentDate.set('month', month);
      this.setDays();
      this.isMonthSelectorOpen = false;
    }
    // 날짜 로직
    prevYear() {
      this.currentDate = dayjs(this.currentDate).subtract(1, 'year');
      this.setDays();
    }
    prevMonth() {
      this.currentDate = dayjs(this.currentDate).subtract(1, 'month');
      this.setDays();
    }
    nextYear() {
      this.currentDate = dayjs(this.currentDate).add(1, 'year');
      this.setDays();
    }
    nextMonth() {
      this.currentDate = dayjs(this.currentDate).add(1, 'month');
      this.setDays();
    }
    navigateToday() {
      this.currentDate = dayjs();
      this.writeValue(this.currentDate.toDate());
      this.setDays();
    }
    setDays() {
      this.days = [];
      const firstDay = this.currentDate.startOf('month');
      const lastDay = dayjs(this.currentDate).daysInMonth();
      for (let i = 0; i < firstDay.day(); i++) {
        this.days.push(this.currentDate.startOf('month').subtract(i + 1, 'day'));
      }
      this.days.reverse();
      for (let i = 0; i < lastDay; i++) {
        this.days.push(this.currentDate.startOf('month').add(i, 'day'));
      }
      for (let i = 0; i < 6 - dayjs(this.currentDate).endOf('month').day(); i++) {
        this.days.push(this.currentDate.endOf('month').add(i + 1, 'day'));
      }
    }
    static {
      this.ɵfac = function LepiCalendar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiCalendar)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiCalendar,
        selectors: [["lepi-calendar"]],
        hostVars: 2,
        hostBindings: function LepiCalendar_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width);
          }
        },
        inputs: {
          keyupDate: [1, "keyupDate"],
          class: [1, "class"]
        },
        outputs: {
          selected: "selected"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature(createProviders(LepiCalendar)), i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 5,
        consts: [[1, "flex", "flex-col", "gap-2", "p-4", "bg-white", "rounded-md", "select-none"], [4, "ngIf"], [1, "flex", "justify-center", "gap-2"], [1, "flex", "gap-1"], [1, "font-semibold", "p-2.5", "rounded-[4px]", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], [1, "flex", "gap-0.5", "items-center"], [1, "text-gray-700", "p-1", "rounded-[4px]", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], ["name", "ic:baseline-keyboard-double-arrow-left", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:sharp-chevron-left", 1, "w-6", "h-6", "bg-gray-700"], [1, "text-gray-700", "text-sm", "p-1", "font-semibold", "rounded-[4px]", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], ["name", "ic:sharp-chevron-right", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:baseline-keyboard-double-arrow-right", 1, "w-6", "h-6", "bg-gray-700"], [1, "grid", "grid-cols-7"], ["class", "p-2.5 flex items-center justify-center rounded-[4px] text-sm", 3, "ngClass", 4, "ngFor", "ngForOf"], ["class", "p-2.5 flex items-center justify-center rounded-[4px] text-sm cursor-pointer transition-colors hover:text-white hover:bg-primary", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "p-2.5", "flex", "items-center", "justify-center", "rounded-[4px]", "text-sm", 3, "ngClass"], [1, "p-2.5", "flex", "items-center", "justify-center", "rounded-[4px]", "text-sm", "cursor-pointer", "transition-colors", "hover:text-white", "hover:bg-primary", 3, "click", "ngClass"], [1, "mx-auto", "font-semibold", "p-2.5", "rounded-[4px]", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], [1, "grid", "grid-cols-4", "overflow-y-auto", "grid-flow-dense", "h-80"], ["class", "p-2.5 cursor-pointer hover:bg-gray-100 transition-all flex items-center justify-center rounded-[4px] text-sm min-w-[5rem]", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], [1, "p-2.5", "cursor-pointer", "hover:bg-gray-100", "transition-all", "flex", "items-center", "justify-center", "rounded-[4px]", "text-sm", "min-w-[5rem]", 3, "click", "ngClass"], [1, "grid", "grid-cols-4", "year-selector-section", "grid-flow-dense"], [4, "ngFor", "ngForOf"]],
        template: function LepiCalendar_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵtemplate(1, LepiCalendar_ng_container_1_Template, 23, 5, "ng-container", 1)(2, LepiCalendar_ng_container_2_Template, 5, 2, "ng-container", 1)(3, LepiCalendar_ng_container_3_Template, 5, 3, "ng-container", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.isYearSelectorOpen && !ctx.isMonthSelectorOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isYearSelectorOpen);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isMonthSelectorOpen);
          }
        },
        dependencies: [LepiIcon, CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf]
      });
    }
  }
  return LepiCalendar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiDatePicker = /*#__PURE__*/(() => {
  class LepiDatePicker {
    writeValue(obj) {
      this.value.set(obj);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    setDisabledState(isDisabled) {}
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.required = false;
      this.type = 'date';
      this.disabled = false;
      this.yPosition = input('bottom');
      this.xPosition = input('left');
      this.isOpen = signal(false);
      this.keyupDate = signal(null);
      this.active = computed(() => this.isOpen() ? 'border-primary' : '');
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.value = model(null);
      this.onChange = value => {};
      this.onTouch = () => {};
      effect(() => {
        this.writeValue(this.value());
        this.onChange(this.value());
      }, {
        allowSignalWrites: true
      });
    }
    ngAfterViewInit() {
      if (this.placeholder && this.inputRef) {
        this.inputRef.nativeElement.dataset['placeholder'] = this.placeholder;
      }
      /** FormControl Instance 주입 */
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
        /** FormControl에 Validators.required가 있는 경우 컴포넌트의 Required 속성을 Override */
        if (this.control.hasValidator(Validators.required)) this.required = true;
        /** Input 이벤트 */
        fromEvent(this.inputRef.nativeElement, 'keyup').pipe(debounceTime(500)).subscribe({
          next: ev => {
            if (ev instanceof KeyboardEvent) this.keyupDate.set(dayjs(ev.target.value).toDate());
          }
        });
      }
    }
    change() {
      this.writeValue(this.value());
      this.onChange(this.value());
    }
    open() {
      this.isOpen.set(true);
      this.keyupDate.set(this.value());
    }
    static {
      this.ɵfac = function LepiDatePicker_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiDatePicker)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiDatePicker,
        selectors: [["lepi-date-picker"]],
        viewQuery: function LepiDatePicker_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          placeholder: "placeholder",
          type: "type",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          yPosition: [1, "yPosition"],
          xPosition: [1, "xPosition"],
          value: [1, "value"]
        },
        outputs: {
          value: "valueChange"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiDatePicker,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 16,
        consts: [["inputRef", ""], ["lepiClickOutside", "", 1, "relative", "flex", "flex-col", "gap-2", "text-sm", "bg-white", 3, "outside"], [3, "required"], [1, "relative"], [1, "flex", "items-center", "justify-between", "w-full", "transition-all", "duration-200", "border-2", "border-gray-300", "group", "hover:focus-within:border-primary", "hover:border-primary-300", "focus-within:border-primary", 3, "ngClass"], ["required", "", "type", "date", 1, "w-full", "outline-none", 3, "click", "disabled", "ngModel"], ["name", "heroicons:calendar-days-20-solid", 1, "w-4", "h-4", "transition-all", "duration-200", "bg-gray-700", "cursor-pointer", "group-hover:bg-primary", "group-focus-within:bg-primary", 3, "click", "ngClass"], [1, "absolute", "z-50", "shadow-md", 3, "ngClass"], [1, "w-full", 3, "ngModelChange", "selected", "ngModel", "keyupDate"]],
        template: function LepiDatePicker_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("outside", function LepiDatePicker_Template_div_outside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.isOpen.set(false));
            });
            i0.ɵɵtemplate(1, LepiDatePicker_Conditional_1_Template, 2, 2, "lepi-label", 2);
            i0.ɵɵelementStart(2, "section", 3)(3, "div", 4)(4, "input", 5, 0);
            i0.ɵɵpipe(6, "date");
            i0.ɵɵlistener("click", function LepiDatePicker_Template_input_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.open());
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "lepi-icon", 6);
            i0.ɵɵlistener("click", function LepiDatePicker_Template_lepi_icon_click_7_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.isOpen.set(!ctx.isOpen()));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(8, LepiDatePicker_Conditional_8_Template, 2, 6, "section", 7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.label ? 1 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(9, _c1, ctx.active(), ctx.currentSize().input, ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", ctx.disabled)("ngModel", i0.ɵɵpipeBind2(6, 6, ctx.value(), "y-MM-dd"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c9, ctx.isOpen()));
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isOpen() ? 8 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.DatePipe, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, ReactiveFormsModule, LepiCalendar, LepiIcon, LepiClickOutsideDirective, LepiLabel],
        styles: [".date-picker-section[_ngcontent-%COMP%]{position:relative}.calendar[_ngcontent-%COMP%]{min-width:300px;width:100%}.input-section[_ngcontent-%COMP%]{display:flex;justify-content:space-between;flex-direction:row;align-items:center;max-width:200px}.input-section.active[_ngcontent-%COMP%]{border:2px solid var(--primary);transition:.2s ease-in-out}input[type=date][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{display:none}input[type=date][_ngcontent-%COMP%]:before{content:attr(data-placeholder);font-weight:500;--tw-text-opacity: 1;color:rgb(156 163 175 / var(--tw-text-opacity));width:100%}input[type=date][_ngcontent-%COMP%]:focus:before, input[type=date][_ngcontent-%COMP%]:valid:before{display:none}"]
      });
    }
  }
  return LepiDatePicker;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RangeCalendarComponent = /*#__PURE__*/(() => {
  class RangeCalendarComponent {
    constructor() {
      this.class = '';
      this.dateClick = new EventEmitter();
      this.selected = new EventEmitter();
      this.outOfRange = new EventEmitter();
      this.width = '100%';
      this.changeDate = new Subject();
      this.days = signal([]);
      this.dayjs = signal(dayjs);
      this.isYearSelectorOpen = signal(false);
      this.isMonthSelectorOpen = signal(false);
      this.handleSelectDate = day => {
        if (this.minDate && dayjs(this.minDate).isAfter(day)) {
          this.outOfRange.emit();
          return;
        }
        if (this.maxDate && dayjs(this.maxDate).isBefore(day)) {
          this.outOfRange.emit();
          return;
        }
        if (dayjs(this.value).month() > day.month()) {
          this.prevMonth();
        } else if (dayjs(this.value).month() < day.month()) {
          this.nextMonth();
        }
        this.dateClick.emit();
        this.selected.emit(day.toDate());
      };
      this.years = Array.from({
        length: 100
      }, (_, i) => dayjs().add(10, 'year').year() - i);
      this.selected.subscribe(() => {
        this.setDays();
      });
      this.setDays();
    }
    ngOnChanges() {
      this.setDays();
    }
    // 년도 선택 로직
    handleYearSelect(year) {
      this.selected.emit(dayjs(this.value).set('year', year).toDate());
      this.isYearSelectorOpen.set(false);
    }
    handleMonthSelect(month) {
      this.selected.emit(dayjs(this.value).set('month', month).toDate());
      this.isMonthSelectorOpen.set(false);
    }
    // 날짜 로직
    prevYear() {
      this.selected.emit(dayjs(this.value).subtract(1, 'year').toDate());
    }
    prevMonth() {
      this.selected.emit(dayjs(this.value).subtract(1, 'month').toDate());
    }
    nextYear() {
      this.selected.emit(dayjs(this.value).add(1, 'year').toDate());
    }
    nextMonth() {
      this.selected.emit(dayjs(this.value).add(1, 'month').toDate());
    }
    setDays() {
      if (this.value) {
        this.days.set([]);
        const firstDay = dayjs(this.value).startOf('month');
        const lastDay = dayjs(dayjs(this.value)).daysInMonth();
        for (let i = 0; i < firstDay.day(); i++) {
          this.days().push(dayjs(this.value).startOf('month').subtract(i + 1, 'day'));
        }
        this.days.set(this.days().reverse());
        for (let i = 0; i < lastDay; i++) {
          this.days().push(dayjs(this.value).startOf('month').add(i, 'day'));
        }
        for (let i = 0; i < 6 - dayjs(dayjs(this.value)).endOf('month').day(); i++) {
          this.days().push(dayjs(this.value).endOf('month').add(i + 1, 'day'));
        }
      }
    }
    setStyle(day) {
      let style = '';
      if (this.startDate && this.endDate) {
        const _day = day.format('YY-MM-DD');
        const startDate = dayjs(this.startDate).format('YY-MM-DD');
        const endDate = dayjs(this.endDate).format('YY-MM-DD');
        if (_day === startDate) {
          style += 'rounded-none rounded-l bg-primary hover:bg-primary-600 text-white';
        } else if (_day === endDate) {
          style += 'rounded-none rounded-r bg-primary hover:bg-primary-600 text-white';
        } else if (day > dayjs(this.startDate) && day < dayjs(this.endDate)) {
          style += 'bg-primary-100 hover:bg-primary-200 rounded-none';
        } else if (day.day() === 0) {
          style += ' text-danger';
        } else if (day.day() === 6) {
          style += ' text-primary';
        }
        if (dayjs(this.value).month() !== day.month()) {
          style += ' text-gray-400';
        }
      }
      return style;
    }
    static {
      this.ɵfac = function RangeCalendarComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RangeCalendarComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RangeCalendarComponent,
        selectors: [["lepi-range-calendar"]],
        hostVars: 2,
        hostBindings: function RangeCalendarComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleProp("width", ctx.width);
          }
        },
        inputs: {
          class: "class",
          startDate: "startDate",
          endDate: "endDate",
          value: "value",
          minDate: "minDate",
          maxDate: "maxDate",
          changeDate: "changeDate"
        },
        outputs: {
          dateClick: "dateClick",
          selected: "selected",
          outOfRange: "outOfRange"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 3,
        consts: [[1, "flex", "flex-col", "gap-2", "p-4", "rounded-md", "select-none", "min-w-max"], [1, "overflow-x-hidden", "mx-auto", "font-semibold", "p-2.5", "rounded", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], [1, "grid", "grid-cols-4", "overflow-y-auto", "grid-flow-dense", "h-80"], [1, "p-2.5", "cursor-pointer", "hover:bg-gray-100", "transition-all", "flex", "items-center", "justify-center", "rounded", "text-sm", "min-w-[5rem]", 3, "ngClass"], [1, "p-2.5", "cursor-pointer", "hover:bg-gray-100", "transition-all", "flex", "items-center", "justify-center", "rounded", "text-sm", "min-w-[5rem]", 3, "click", "ngClass"], [1, "mx-auto", "font-semibold", "p-2.5", "rounded", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], [1, "grid", "grid-cols-4", "year-selector-section", "grid-flow-dense"], [1, "flex", "justify-center", "gap-2"], [1, "flex", "gap-1"], [1, "min-w-max", "font-semibold", "p-2.5", "rounded", "transition-all", "duration-200", "ease-in-out", "cursor-pointer", "hover:bg-gray-100", 3, "click"], [1, "flex", "gap-0.5", "items-center"], [1, "p-1", "text-gray-700", "transition-all", "duration-200", "ease-in-out", "rounded", "cursor-pointer", "hover:bg-gray-100", 3, "click"], ["name", "ic:baseline-keyboard-double-arrow-left", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:sharp-chevron-left", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:sharp-chevron-right", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:baseline-keyboard-double-arrow-right", 1, "w-6", "h-6", "bg-gray-700"], [1, "grid", "grid-cols-7"], [1, "p-2.5", "flex", "items-center", "justify-center", "rounded", "text-sm", 3, "ngClass"], [1, "p-2.5", "flex", "items-center", "rounded", "justify-center", "text-sm", "cursor-pointer", "transition-colors", "hover:text-white", "hover:bg-primary", 3, "ngClass"], [1, "p-2.5", "flex", "items-center", "rounded", "justify-center", "text-sm", "cursor-pointer", "transition-colors", "hover:text-white", "hover:bg-primary", 3, "click", "ngClass"]],
        template: function RangeCalendarComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵtemplate(1, RangeCalendarComponent_Conditional_1_Template, 5, 1)(2, RangeCalendarComponent_Conditional_2_Template, 5, 2)(3, RangeCalendarComponent_Conditional_3_Template, 22, 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isYearSelectorOpen() ? 1 : ctx.isMonthSelectorOpen() ? 2 : 3);
          }
        },
        dependencies: [LepiIcon, CommonModule, i1.NgClass]
      });
    }
  }
  return RangeCalendarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
let LepiDateRange = /*#__PURE__*/(() => {
  class LepiDateRange {
    constructor(config) {
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.required = false;
      this.calendarPosition = 'right';
      this.disabled = false;
      this.expand = false;
      this.selectedStartDate = new EventEmitter();
      this.selectedEndDate = new EventEmitter();
      this.outOfRange = new EventEmitter();
      this.isOpen = signal(false);
      this.segmentItems = signal([{
        name: '7일',
        value: 7,
        type: 'day'
      }, {
        name: '15일',
        value: 15,
        type: 'day'
      }, {
        name: '1개월',
        value: 1,
        type: 'month'
      }, {
        name: '3개월',
        value: 3,
        type: 'month'
      }, {
        name: '6개월',
        value: 6,
        type: 'month'
      }, {
        name: '1년',
        value: 1,
        type: 'year'
      }, {
        name: '3년',
        value: 3,
        type: 'year'
      }, {
        name: '5년',
        value: 5,
        type: 'year'
      }, {
        name: '10년',
        value: 10,
        type: 'year'
      }]);
      this.segment = signal('오늘');
      this._startDate = signal(dayjs().toDate());
      this._endDate = signal(dayjs().add(1, 'month').toDate());
      this.active = computed(() => this.isOpen() ? 'border-primary' : '');
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.onChange = _ => {};
      this.onTouched = () => {};
      effect(() => {
        this.selectedStartDate.emit(this._startDate());
        this.selectedEndDate.emit(this._endDate());
        this.setDates();
      });
    }
    writeValue(obj) {
      if (obj) {
        this.startDate = obj.startDate;
        this.endDate = obj.endDate;
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    ngAfterViewInit() {
      this.setDates();
      setTimeout(() => {
        if (this.startDate) this._startDate.set(this.startDate);
        if (this.endDate) this._endDate.set(this.endDate);
      }, 100);
    }
    open() {
      this.isOpen.set(!this.isOpen());
    }
    setDates() {
      if (this.inputStartDate && this.inputEndDate) {
        this.inputStartDate.nativeElement.value = dayjs(this._startDate()).format('YYYY-MM-DD');
        this.inputEndDate.nativeElement.value = dayjs(this._endDate()).format('YYYY-MM-DD');
      }
    }
    change(ev, type) {
      if (type === 'start') {
        if (this.endDate && dayjs(ev).isAfter(this._endDate())) {
          this._startDate.set(this._endDate());
          this._endDate.set(ev);
          return;
        }
        this._startDate?.set(ev);
      } else {
        if (this._startDate && dayjs(ev).isBefore(this._startDate())) {
          this._endDate.set(this._endDate());
          this._startDate.set(ev);
          return;
        }
        this._endDate?.set(ev);
      }
      this.segment.set('');
    }
    keyupStartDate(ev) {
      if (this.inputStartDate) {
        fromEvent(this.inputStartDate.nativeElement, 'keyup').pipe(debounceTime(500)).subscribe({
          next: () => this._startDate?.set(dayjs(ev.target.value).toDate())
        });
      }
    }
    keyupEndDate(ev) {
      if (this.inputEndDate) {
        fromEvent(this.inputEndDate.nativeElement, 'keyup').pipe(debounceTime(500)).subscribe({
          next: () => this._endDate?.set(dayjs(ev.target.value).toDate())
        });
      }
    }
    handleSegment(item) {
      this.segment.set(item.name);
      const startDate = dayjs().toDate();
      const endDate = dayjs().add(item.value, item.type).toDate();
      this._startDate.set(startDate);
      this._endDate.set(endDate);
    }
    static {
      this.ɵfac = function LepiDateRange_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiDateRange)(i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiDateRange,
        selectors: [["lepi-date-range"]],
        viewQuery: function LepiDateRange_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c11, 5);
            i0.ɵɵviewQuery(_c12, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputStartDate = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputEndDate = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          calendarPosition: "calendarPosition",
          startDate: "startDate",
          endDate: "endDate",
          disabled: [2, "disabled", "disabled", booleanAttribute],
          minDate: "minDate",
          maxDate: "maxDate",
          expand: [2, "expand", "expand", booleanAttribute]
        },
        outputs: {
          selectedStartDate: "selectedStartDate",
          selectedEndDate: "selectedEndDate",
          outOfRange: "outOfRange"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiDateRange,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 14,
        vars: 12,
        consts: [["inputStartDate", ""], ["inputEndDate", ""], ["lepiClickOutside", "", 1, "flex", "flex-col", "gap-2", "select-none", 3, "outside", "ngClass"], [3, "required"], [1, "relative"], [1, "flex", "items-center", "justify-between", "w-full", "transition-all", "duration-200", "border-2", "border-gray-300", "group", "hover:focus-within:border-primary", "hover:border-primary-300", "focus-within:border-primary", 3, "ngClass"], [1, "relative", "flex", "items-center", "gap-2"], ["type", "date", 1, "outline-none", "min-w-max", 3, "keyup"], [1, "absolute", "left-[90px]"], ["name", "heroicons:calendar-days-20-solid", 1, "w-4", "h-4", "transition-all", "duration-200", "cursor-pointer", "group-hover:bg-primary", 3, "click"], [1, "z-10", "bg-white", "absolute", "top-[calc(100%+4px)]", "rounded-md", "shadow-md", 3, "right-0"], [1, "z-10", "bg-white", "absolute", "top-[calc(100%+4px)]", "rounded-md", "shadow-md"], [1, "flex", "h-full"], [1, "flex", "flex-col", "items-center", "py-4", "border-r", "border-gray-200"], [1, "text-center", "cursor-pointer", "transition-all", "duration-200", "min-w-[5rem]", "px-3", "py-2.5", "text-sm", "hover:bg-gray-100", 3, "active"], [1, "border-r", "border-gray-200", "max-w-max", 3, "selected", "outOfRange", "minDate", "maxDate", "value", "startDate", "endDate"], [3, "selected", "dateClick", "outOfRange", "minDate", "maxDate", "value", "startDate", "endDate"], [1, "text-center", "cursor-pointer", "transition-all", "duration-200", "min-w-[5rem]", "px-3", "py-2.5", "text-sm", "hover:bg-gray-100", 3, "click"]],
        template: function LepiDateRange_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "label", 2);
            i0.ɵɵlistener("outside", function LepiDateRange_Template_label_outside_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.isOpen.set(false));
            });
            i0.ɵɵelementStart(1, "lepi-label", 3);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "section", 4)(4, "div", 5)(5, "div", 6)(6, "input", 7, 0);
            i0.ɵɵlistener("keyup", function LepiDateRange_Template_input_keyup_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.keyupStartDate($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "p", 8);
            i0.ɵɵtext(9, "-");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "input", 7, 1);
            i0.ɵɵlistener("keyup", function LepiDateRange_Template_input_keyup_10_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.keyupEndDate($event));
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "lepi-icon", 9);
            i0.ɵɵlistener("click", function LepiDateRange_Template_lepi_icon_click_12_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.open());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(13, LepiDateRange_Conditional_13_Template, 7, 12, "section", 10);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.expand ? "w-full" : "w-max");
            i0.ɵɵadvance();
            i0.ɵɵproperty("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(7, _c1, ctx.active(), ctx.currentSize().input, ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance(8);
            i0.ɵɵclassMap(ctx.isOpen() ? "bg-primary" : "bg-gray-400");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isOpen() ? 13 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, FormsModule, ReactiveFormsModule, LepiIcon, LepiClickOutsideDirective, LepiLabel, RangeCalendarComponent],
        styles: ["input[type=date][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{display:none}.active[_ngcontent-%COMP%]{--tw-bg-opacity: 1;background-color:rgb(6 27 46 / var(--tw-bg-opacity));--tw-text-opacity: 1;color:rgb(30 136 229 / var(--tw-text-opacity))}"]
      });
    }
  }
  return LepiDateRange;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
let LepiTextArea = /*#__PURE__*/(() => {
  class LepiTextArea {
    constructor(injector) {
      this.injector = injector;
      this.placeholder = '';
      this.required = false;
      this.disabled = false;
      this.showLength = true;
      this.class = input('');
      this.onChange = ev => {};
      this.onTouched = () => {};
    }
    writeValue(value) {
      this.value = value ?? '';
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    ngAfterViewInit() {
      /** FormControl Instance 주입 */
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
      }
    }
    onInput(ev) {
      if (this.maxlength) {
        const value = this.textareaRef.nativeElement.value;
        const maxLength = Number(this.maxlength);
        const trimmedValue = value.length > maxLength ? value.slice(0, maxLength) : value;
        this.textareaRef.nativeElement.value = trimmedValue;
        this.writeValue(trimmedValue);
        this.onChange(trimmedValue);
        return;
      }
      this.writeValue(this.textareaRef.nativeElement.value);
      this.onChange(this.textareaRef.nativeElement.value);
      return;
    }
    static {
      this.ɵfac = function LepiTextArea_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiTextArea)(i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiTextArea,
        selectors: [["lepi-text-area"]],
        viewQuery: function LepiTextArea_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c13, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textareaRef = _t.first);
          }
        },
        inputs: {
          value: "value",
          label: "label",
          placeholder: "placeholder",
          maxlength: "maxlength",
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          showLength: "showLength",
          class: [1, "class"]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiTextArea,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 9,
        consts: [["textarea", ""], [1, "flex", "flex-col", "w-full", "gap-2"], [3, "required"], [1, "w-full", "input-wrapper"], ["rows", "4", 1, "w-full", "px-3", "py-1.5", "overflow-auto", "text-sm", "text-gray-700", "transition-all", "duration-200", "border-2", "border-gray-300", "rounded-md", "outline-none", "resize-none", "hover:border-primary-300", "focus-within:border-primary", "hover:focus-within:border-primary", 3, "input", "placeholder", "ngClass", "ngModel"], [1, "input-etc"], [4, "ngIf"], ["class", "maxlength-content", 4, "ngIf"], ["class", "invalid", 4, "ngIf"], [1, "invalid"], [1, "maxlength-content"]],
        template: function LepiTextArea_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "label", 1)(1, "lepi-label", 2);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3)(4, "textarea", 4, 0);
            i0.ɵɵlistener("input", function LepiTextArea_Template_textarea_input_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInput($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵtemplate(7, LepiTextArea_ng_container_7_Template, 2, 1, "ng-container", 6)(8, LepiTextArea_p_8_Template, 2, 2, "p", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("required", ctx.required);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate(ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("border-danger-500", ctx.control == null ? null : ctx.control.invalid);
            i0.ɵɵproperty("placeholder", ctx.placeholder)("ngClass", ctx.class() ? ctx.class() : undefined)("ngModel", ctx.value);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.control && (ctx.control == null ? null : ctx.control.dirty) && (ctx.control == null ? null : ctx.control.errors));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.maxlength && ctx.showLength);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, ReactiveFormsModule, LepiLabel]
      });
    }
  }
  return LepiTextArea;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiInputGroup = /*#__PURE__*/(() => {
  class LepiInputGroup {
    constructor() {
      this.items = [];
      this.changed = new EventEmitter();
      this.form = new FormGroup({});
    }
    ngOnInit() {
      if (this.items && this.items.length > 0) {
        this.items.forEach(item => {
          if (item.type === 'date-range') {
            if (item.required) {
              this.form.addControl(item.formControlName.startDate, new FormControl('', [Validators.required]));
              this.form.addControl(item.formControlName.endDate, new FormControl('', [Validators.required]));
            } else {
              this.form.addControl(item.formControlName.startDate, new FormControl(''));
              this.form.addControl(item.formControlName.endDate, new FormControl(''));
            }
          } else {
            if (item.required) {
              this.form.addControl(item.formControlName, new FormControl(''));
            } else {
              this.form.addControl(item.formControlName, new FormControl('', [Validators.required]));
            }
          }
        });
      }
      this.form.valueChanges.subscribe(() => {
        const data = this.form.getRawValue();
        this.changed.emit(data);
      });
    }
    dateChange(name, value) {
      this.form.get(name)?.setValue(value);
    }
    static {
      this.ɵfac = function LepiInputGroup_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputGroup)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputGroup,
        selectors: [["lepi-input-group"]],
        inputs: {
          items: "items"
        },
        outputs: {
          changed: "changed"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 2,
        consts: [[1, "flex", "flex-col", "w-full", "border-t-2", "border-gray-800", 3, "formGroup"], [4, "ngFor", "ngForOf"], ["class", "flex border-b border-gray-50", 4, "ngIf"], [1, "flex", "border-b", "border-gray-50"], [1, "min-w-[6.25rem]", "bg-gray-100", "p-3", "flex", "items-center", "justify-center"], [3, "required"], [1, "p-3", "w-full"], [3, "formControlName", "debounce", "placeholder"], [3, "formControlName", "max", "min", "placeholder"], [3, "formControlName"], [3, "selectedStartDate", "selectedEndDate"], [3, "formControlName", "maxlength", "placeholder"]],
        template: function LepiInputGroup_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵtemplate(1, LepiInputGroup_ng_container_1_Template, 6, 5, "ng-container", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.form);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.items);
          }
        },
        dependencies: [CommonModule, i1.NgForOf, i1.NgIf, LepiInputText, LepiDatePicker, LepiDateRange, LepiTextArea, LepiInputNumber, LepiLabel, FormsModule, i2.ɵNgNoValidate, i2.NgControlStatus, i2.NgControlStatusGroup, i2.MaxLengthValidator, ReactiveFormsModule, i2.FormGroupDirective, i2.FormControlName]
      });
    }
  }
  return LepiInputGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiInputPassword = /*#__PURE__*/(() => {
  class LepiInputPassword {
    get invalid() {
      return (this.control?.touched || false) && this.control?.invalid;
    }
    get valid() {
      return (this.control?.touched || false) && this.control?.valid;
    }
    constructor(injector, el, config) {
      this.injector = injector;
      this.el = el;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.autocomplete = false;
      this.required = false;
      this.security = false;
      this.debounce = 0;
      this.disabled = false;
      this._value = signal('');
      this.value = '';
      this.isCapsLockOn = signal(false);
      this.isNumLockOn = signal(false);
      this.regLength = /^.{8,}$/;
      this.regNum = /[0-9]/;
      this.regSpecial = /[!@#$%^*+=-]/;
      this.showPlain = signal(false);
      this.onChange = value => {};
      this.onTouched = () => {};
      this.onValidationChange = () => {};
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
    }
    toggle(ev) {
      ev.stopPropagation();
      this.showPlain.set(!this.showPlain());
    }
    ngAfterViewInit() {
      if (!this.inputRef) return;
      /** FormControl Instance 주입 */
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
      }
      /** 문서 전체의 키입력을 Observe하며 CapsLock 상태를 표시 */
      fromEvent(this.el.nativeElement, 'keyup').subscribe({
        next: ev => {
          if (ev.getModifierState) this.isCapsLockOn.set(ev?.getModifierState('CapsLock'));
        }
      });
      /** Input의 키입력을 Observe */
      fromEvent(this.inputRef.nativeElement, 'keyup').subscribe({
        next: () => {
          const value = this.inputRef?.nativeElement.value || '';
          this.writeValue(value);
          this.onChange(this.value);
          this.onTouched();
        }
      });
    }
    validate(c) {
      if (!this.security) return null;
      const valid = [this.regLength, this.regNum, this.regSpecial].every((reg, i) => reg.test(this.inputRef?.nativeElement.value || ''));
      return !valid ? {
        invalid: true
      } : null;
    }
    registerOnValidatorChange(fn) {
      this.onValidationChange = fn;
    }
    writeValue(value) {
      this._value.set(value || '');
      this.value = value || '';
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function LepiInputPassword_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputPassword)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputPassword,
        selectors: [["lepi-input-password"]],
        viewQuery: function LepiInputPassword_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          placeholder: "placeholder",
          autocomplete: [2, "autocomplete", "autocomplete", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          security: [2, "security", "security", booleanAttribute],
          debounce: [2, "debounce", "debounce", numberAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputPassword,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: LepiInputPassword,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 10,
        vars: 20,
        consts: [["inputRef", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [1, "flex", "flex-col", "gap-1.5"], [1, "flex", "items-center", "gap-2", "transition-colors", "border-2", "border-gray-300", "group", 3, "ngClass"], [1, "w-full", "text-gray-700", "outline-none", "disabled:cursor-not-allowed", 3, "type", "value", "ngClass", "required", "autocomplete", "disabled", "placeholder"], [1, "cursor-pointer", 3, "click"], ["name", "ic:baseline-visibility", "class", "w-5 h-5 bg-gray-400", 4, "ngIf"], ["name", "ic:baseline-visibility-off", "class", "w-5 h-5 bg-gray-400", 4, "ngIf"], ["class", "flex flex-col gap-1", 4, "ngIf"], [3, "required"], ["name", "ic:baseline-visibility", 1, "w-5", "h-5", "bg-gray-400"], ["name", "ic:baseline-visibility-off", 1, "w-5", "h-5", "bg-gray-400"], [1, "flex", "flex-col", "gap-1"], [1, "flex", "items-center", "justify-start", "gap-1"], [1, "w-4", "h-4", "bg-gray-700", 3, "name"], [1, "text-xs", "text-gray-700"], ["class", "flex items-center justify-start gap-1", 4, "ngIf"], ["name", "ic:round-warning", 1, "w-4", "h-4", "bg-gray-700"]],
        template: function LepiInputPassword_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiInputPassword_lepi_label_1_Template, 2, 2, "lepi-label", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4);
            i0.ɵɵelement(4, "input", 5, 0);
            i0.ɵɵelementStart(6, "div", 6);
            i0.ɵɵlistener("click", function LepiInputPassword_Template_div_click_6_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggle($event));
            });
            i0.ɵɵtemplate(7, LepiInputPassword_lepi_icon_7_Template, 1, 0, "lepi-icon", 7)(8, LepiInputPassword_lepi_icon_8_Template, 1, 0, "lepi-icon", 8);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, LepiInputPassword_div_9_Template, 14, 4, "div", 9);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_11_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(16, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("type", ctx.showPlain() ? "text" : "password")("value", ctx.value)("ngClass", ctx.currentSize().input)("required", ctx.required)("autocomplete", ctx.autocomplete ? "on" : "off")("disabled", ctx.disabled)("placeholder", (tmp_11_0 = ctx.placeholder) !== null && tmp_11_0 !== undefined ? tmp_11_0 : "\uC601\uBB38, \uC22B\uC790 \uD3EC\uD568 8\uC790 \uC774\uC0C1 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.showPlain());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.showPlain());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.security);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, LepiLabel, LepiIcon, FormsModule]
      });
    }
  }
  return LepiInputPassword;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSelectOption = /*#__PURE__*/(() => {
  class LepiSelectOption {
    constructor() {
      this.selected = new EventEmitter();
      this.textContent = '';
      this.isSelected = false;
      this.isVisible = true;
      this.isSelectedIndex = false;
    }
    ngAfterViewInit() {
      this.textContent = this.content?.nativeElement.textContent ?? '';
    }
    static {
      this.ɵfac = function LepiSelectOption_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSelectOption)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSelectOption,
        selectors: [["lepi-select-option"]],
        viewQuery: function LepiSelectOption_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        inputs: {
          value: "value"
        },
        outputs: {
          selected: "selected"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 4,
        consts: [["content", ""], [1, "px-2", "py-0.5", "transition-all", "duration-200", "rounded-md", "cursor-pointer", 3, "click", "ngClass"], [1, "px-2", "py-1.5", "text-sm", "rounded", "cursor-pointer"]],
        template: function LepiSelectOption_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵlistener("click", function LepiSelectOption_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.selected.emit(ctx.value));
            });
            i0.ɵɵelementStart(1, "p", 2, 0);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("bg-gray-100", ctx.isSelectedIndex);
            i0.ɵɵproperty("ngClass", ctx.isVisible ? "block" : "hidden")("ngClass", ctx.isSelected ? ctx.isSelectedIndex ? "bg-primary-100  font-bold text-primary hover:bg-primary-150" : "bg-primary-50  font-bold text-primary hover:bg-primary-100" : "hover:bg-gray-100 hover:font-bold text-gray-700");
          }
        },
        dependencies: [CommonModule, i1.NgClass]
      });
    }
  }
  return LepiSelectOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSelectOptionGroup = /*#__PURE__*/(() => {
  class LepiSelectOptionGroup {
    constructor() {
      this.isInvisible = false;
    }
    isShow() {
      let isInvisible = true;
      if (this.options) {
        for (const option of this.options.toArray()) {
          if (option.isVisible) {
            isInvisible = false;
          }
        }
      }
      return isInvisible;
    }
    static {
      this.ɵfac = function LepiSelectOptionGroup_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSelectOptionGroup)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSelectOptionGroup,
        selectors: [["lepi-select-option-group"]],
        contentQueries: function LepiSelectOptionGroup_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiSelectOption, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
          }
        },
        viewQuery: function LepiSelectOptionGroup_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c15, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.group = _t.first);
          }
        },
        inputs: {
          label: "label"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 3,
        consts: [["group", ""], [1, "option-group-section"], [1, "option-group-item"]],
        template: function LepiSelectOptionGroup_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0)(2, "p", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵclassProp("hidden", ctx.isShow());
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        dependencies: [CommonModule],
        styles: [".option-group-section[_ngcontent-%COMP%]{margin-bottom:4px;margin-top:4px}.option-group-item[_ngcontent-%COMP%]{padding:4px 8px;margin-bottom:4px;font-weight:600;color:var(--gray-500);font-size:14px}"]
      });
    }
  }
  return LepiSelectOptionGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
let LepiSelect = /*#__PURE__*/(() => {
  class LepiSelect {
    constructor(ngControl) {
      this.ngControl = ngControl;
      this._input = true;
      this.position = 'bottom';
      this.required = false;
      this.search = false;
      this.disabled = false;
      this.selected = new EventEmitter();
      this.onChange = value => {};
      this.onTouched = () => {};
      this.isOpen = signal(false);
      this.selectedIndex = -1;
      if (this.ngControl) this.ngControl.valueAccessor = this;
      effect(() => {
        if (this.isOpen()) {
          window.addEventListener('keydown', ev => {
            if (ev.key === 'ArrowUp' || ev.key === 'ArrowDown') {
              ev.preventDefault();
            }
          });
        }
      });
    }
    writeValue(obj) {
      setTimeout(() => {
        const found = this.options?.find(option => option.value === obj);
        if (found) {
          this.selectedIndex = this.options.toArray().indexOf(found);
          this.currentItem = found?.content?.nativeElement.textContent;
        } else {
          this.currentItem = obj;
          this.selectedIndex = -1;
        }
        this.value = obj;
      }, 50);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    ngAfterContentInit() {
      setTimeout(() => this.prepareOptions(), 50);
      this.options.changes.subscribe({
        next: () => {
          this.prepareOptions();
          const found = this.options?.find(option => option.value === this.value);
          if (found) {
            this.selectedIndex = this.options.toArray().indexOf(found);
            this.currentItem = found?.content?.nativeElement.textContent;
          } else {
            this.currentItem = this.value;
            this.selectedIndex = -1;
          }
        }
      });
    }
    handleOpen() {
      if (this.disabled) return;
      this.isOpen.set(!this.isOpen());
    }
    prepareOptions() {
      if (this.groups) {
        this.groups.map(group => {
          this.options?.reset([...this.options.toArray(), ...group.options]);
        });
      }
      /** LepiSelectOption의 selected$ 이벤트를 수신합니다. */
      scheduled(this.options.map(item => item.selected), asyncScheduler).pipe(mergeAll()).subscribe({
        next: value => {
          this.options?.map((item, index) => {
            if (item.value === value) {
              item.isSelected = true;
              this.currentItem = item.content?.nativeElement.textContent;
              this.selectedIndex = index;
            } else {
              item.isSelected = false;
            }
          });
          this.writeValue(value);
          this.onChange(value);
          this.selected.emit(value);
          this.isOpen.set(false);
        }
      });
    }
    keydown(ev) {
      ev.stopPropagation();
      this.isOpen.set(true);
      const {
        key
      } = ev;
      if (this.selectedIndex < 0 && key === 'ArrowDown') {
        this.selectedIndex = 0;
      } else if (key === 'ArrowUp') {
        this.selectedIndex = this.selectedIndex > 0 ? this.selectedIndex - 1 : 0;
      } else if (key === 'ArrowDown') {
        this.selectedIndex = this.selectedIndex < this.options.length - 1 ? this.selectedIndex + 1 : this.selectedIndex;
      } else if (key === 'Enter') {
        ev.preventDefault();
        this.options?.map((item, index) => {
          if (index === this.selectedIndex) {
            item.isSelected = true;
            this.currentItem = item.content?.nativeElement.textContent;
            this.writeValue(item.value);
            this.onChange(this.value);
            this.selected.emit(item.value);
          } else {
            item.isSelected = false;
          }
          if (this.currentItem) {
            const text = item.content?.nativeElement.textContent;
            this.options.get(index).isVisible = getKoreanRegex(this.currentItem, {
              consonantMatch: true
            }).test(text);
          } else {
            this.options.get(index).isVisible = true;
          }
        });
        this.isOpen.set(false);
        return;
      } else {
        this.selectedIndex = -1;
      }
      this.setIndex();
    }
    // 검색어 입력 시 핸들링
    onInput(ev) {
      const text = this.select.nativeElement.value.trim();
      if (!text || text === '') return;
      this.options?.map((item, index) => {
        if (item.textContent.includes(text)) {
          this.options.get(index).isVisible = true;
        } else {
          this.options.get(index).isVisible = false;
        }
      });
    }
    setIndex() {
      this.options?.map((item, index) => {
        const text = item.content?.nativeElement.textContent;
        const itemValue = item.value?.toString();
        if (index === this.selectedIndex) {
          this.options.get(index).isSelectedIndex = true;
          this.currentItem = text;
          this.writeValue(itemValue);
          this.onChange(this.value);
          this.selected.emit(itemValue);
        } else {
          this.options.get(index).isSelectedIndex = false;
        }
      });
    }
    isEmpty() {
      return this.options?.toArray().every(item => !item.isVisible) ?? true;
    }
    static {
      this.ɵfac = function LepiSelect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSelect)(i0.ɵɵdirectiveInject(i2.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSelect,
        selectors: [["lepi-select"]],
        contentQueries: function LepiSelect_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiSelectOption, 4);
            i0.ɵɵcontentQuery(dirIndex, LepiSelectOptionGroup, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.groups = _t);
          }
        },
        viewQuery: function LepiSelect_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c16, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.select = _t.first);
          }
        },
        inputs: {
          label: "label",
          position: "position",
          required: [2, "required", "required", booleanAttribute],
          placeholder: "placeholder",
          search: [2, "search", "search", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        outputs: {
          selected: "selected"
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 9,
        vars: 13,
        consts: [["select", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], ["lepiClickOutside", "", 1, "relative", "flex", "items-center", "gap-2", "transition-colors", "bg-white", "border-2", "border-gray-300", "rounded-md", "group", 3, "outside", "ngClass"], [1, "flex", "items-center", "w-full", "px-3", 3, "click"], [1, "w-full", "py-1.5", "text-sm", "bg-white", "outline-none", "disabled:cursor-not-allowed", 3, "ngModelChange", "keydown", "input", "placeholder", "ngModel", "readonly", "disabled"], [4, "ngIf"], ["class", "absolute z-50 flex flex-col justify-center w-full gap-1 bg-white rounded-md shadow-md", 3, "top-[calc(100%+4px)]", "bottom-[calc(100%+4px)]", 4, "ngIf"], [3, "required"], ["class", "w-6 h-6 transition-colors select-icon group-hover:bg-primary", "name", "ic:baseline-keyboard-arrow-up", 3, "class", 4, "ngIf"], ["class", "w-6 h-6 transition-colors select-icon group-hover:bg-primary", "name", "ic:baseline-keyboard-arrow-down", 3, "class", 4, "ngIf"], ["name", "ic:baseline-keyboard-arrow-up", 1, "w-6", "h-6", "transition-colors", "select-icon", "group-hover:bg-primary"], ["name", "ic:baseline-keyboard-arrow-down", 1, "w-6", "h-6", "transition-colors", "select-icon", "group-hover:bg-primary"], [1, "absolute", "z-50", "flex", "flex-col", "justify-center", "w-full", "gap-1", "bg-white", "rounded-md", "shadow-md"], [1, "flex", "flex-col", "max-h-[20rem]", "p-1", "overflow-auto"], [1, "flex", "items-center", "h-full", "p-2", "text-sm", "text-center", "text-gray-500", "place-self-center"]],
        template: function LepiSelect_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiSelect_lepi_label_1_Template, 2, 2, "lepi-label", 2);
            i0.ɵɵelementStart(2, "div", 3);
            i0.ɵɵlistener("outside", function LepiSelect_Template_div_outside_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.isOpen.set(false));
            });
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵlistener("click", function LepiSelect_Template_div_click_3_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.handleOpen());
            });
            i0.ɵɵelementStart(4, "input", 5, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function LepiSelect_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.currentItem, $event) || (ctx.currentItem = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵlistener("keydown", function LepiSelect_Template_input_keydown_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.keydown($event));
            })("input", function LepiSelect_Template_input_input_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.onInput($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, LepiSelect_ng_container_6_Template, 3, 2, "ng-container", 6)(7, LepiSelect_ng_container_7_Template, 3, 2, "ng-container", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, LepiSelect_div_8_Template, 3, 5, "div", 7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_5_0;
            i0.ɵɵclassProp("cursor-not-allowed", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-primary", ctx.isOpen());
            i0.ɵɵproperty("ngClass", ctx.disabled ? "cursor-not-allowed bg-gray-100 border-gray-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("placeholder", (tmp_5_0 = ctx.placeholder) !== null && tmp_5_0 !== undefined ? tmp_5_0 : "");
            i0.ɵɵtwoWayProperty("ngModel", ctx.currentItem);
            i0.ɵɵproperty("readonly", !ctx.search)("disabled", ctx.disabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.position === "top");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.position === "bottom");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isOpen());
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgModel, LepiIcon, LepiLabel, LepiClickOutsideDirective],
        styles: [".disabled[_ngcontent-%COMP%]{cursor:not-allowed;--tw-bg-opacity: 1;background-color:rgb(243 244 246 / var(--tw-bg-opacity))}"]
      });
    }
  }
  return LepiSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const components$2 = [LepiSelect, LepiSelectOption, LepiSelectOptionGroup];
let LepiSelectModule = /*#__PURE__*/(() => {
  class LepiSelectModule {
    static {
      this.ɵfac = function LepiSelectModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSelectModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LepiSelectModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [components$2]
      });
    }
  }
  return LepiSelectModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
let LepiInputTel = /*#__PURE__*/(() => {
  class LepiInputTel {
    get prefixes() {
      if (this.telType === 'mobile') {
        return ['010', '011', '012', '016', '019'];
      } else {
        return ['02', '031', '032', '033', '041', '042', '043', '044', '051', '052', '053', '054', '055', '061', '062', '063', '064'];
      }
    }
    get valid() {
      return this.control?.touched && !this.control?.errors;
    }
    get invalid() {
      return this.control?.touched && this.control?.errors;
    }
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.maxlength = 11;
      this.placeholder = '';
      this.required = false;
      this.isDisabled = false;
      this.type = 'text';
      this.telType = 'mobile';
      this.onChange = data => {};
      this.onTouched = () => {};
      this.onValidationChange = () => {};
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
    }
    ngOnInit() {
      if (NgControl) {
        const formControlName = this.injector.get(NgControl);
        if (formControlName && formControlName instanceof FormControlName) {
          this.control = formControlName.control;
          if (this.control?.hasValidator(Validators.required)) {
            this.required = true;
          }
        }
      }
    }
    formatPhoneNumber(event) {
      const phoneNumber = event.target.value.replace(/[^0-9]/g, '');
      event.target.value = phoneNumber;
      this.value = phoneNumber;
      this.writeValue(this.value ?? '');
      this.onChange(this.value);
      this.onTouched();
    }
    onInputChange() {
      const concatenatedValue = `${this.input1}${this.input2}${this.input3}`;
      this.onChange(concatenatedValue);
      this.onTouched();
    }
    writeValue(value) {
      if (this.type === 'select') {
        if (value) {
          const pattern = /^(\d{3})(\d{3,4})(\d{4})$/;
          const parts = pattern.exec(value);
          if (parts) {
            this.input1 = parts[1] || '';
            this.input2 = parts[2] || '';
            this.input3 = parts[3] || '';
          }
        } else {
          this.input1 = '';
          this.input2 = '';
          this.input3 = '';
        }
      } else {
        this.value = value ?? '';
      }
    }
    registerOnValidatorChange(fn) {
      this.onValidationChange = fn;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.isDisabled = isDisabled;
    }
    static {
      this.ɵfac = function LepiInputTel_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputTel)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputTel,
        selectors: [["lepi-input-tel"]],
        viewQuery: function LepiInputTel_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          class: "class",
          fixText: "fixText",
          maxlength: "maxlength",
          placeholder: "placeholder",
          required: [2, "required", "required", booleanAttribute],
          value: "value",
          isDisabled: "isDisabled",
          type: "type",
          telType: "telType"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputTel,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 3,
        consts: [["inputRef", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [4, "ngIf"], [3, "required"], [1, "w-full", "transition-all", "border-2", "border-gray-300", "outline-none", "hover:border-primary-300", "focus:border-primary", 3, "input", "ngModel", "maxlength", "placeholder", "required", "ngClass"], [1, "flex", "items-center", "gap-2"], [1, "flex", "w-20", 3, "ngModelChange", "ngModel", "required"], [3, "value", 4, "ngFor", "ngForOf"], [1, "text-gray-300"], ["type", "text", "placeholder", "0000", 1, "w-20", 3, "ngModelChange", "required", "maxLength", "ngModel"], [3, "value"]],
        template: function LepiInputTel_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiInputTel_lepi_label_1_Template, 2, 2, "lepi-label", 2)(2, LepiInputTel_ng_container_2_Template, 3, 13, "ng-container", 3)(3, LepiInputTel_ng_container_3_Template, 11, 22, "ng-container", 3);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "text");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.type === "select");
          }
        },
        dependencies: [ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.MaxLengthValidator, FormsModule, i2.NgModel, CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, LepiSelectModule, LepiSelect, LepiSelectOption, LepiInputNumber, LepiLabel]
      });
    }
  }
  return LepiInputTel;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiInputChip = /*#__PURE__*/(() => {
  class LepiInputChip {
    get valid() {
      return this.control?.touched && !this.control?.errors;
    }
    get invalid() {
      return this.control?.touched && this.control?.errors;
    }
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.required = false;
      this.disabled = true;
      /** 중복값 허용 여부 */
      this.duplicate = false;
      /** 순서 변경 허용 여부 */
      this.reorder = true;
      this.direction = 'horizontal';
      this.value = [];
      this.onChange = value => {};
      this.onTouched = () => {};
      this.form = new FormGroup({
        value: new FormControl('', [Validators.required])
      });
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
    }
    ngOnInit() {
      const formControlName = this.injector.get(NgControl);
      if (formControlName && formControlName instanceof FormControlName) {
        this.control = formControlName;
      }
    }
    handleEnter(ev) {
      ev.stopPropagation();
      ev.preventDefault();
      const inputValue = this.form.controls.value.value;
      if (!inputValue || inputValue === '') return false;
      if (!this.duplicate && this.value.includes(inputValue)) {
        this.form.reset();
        return false;
      }
      this.value.push(inputValue);
      this.form.reset();
      this.onTouched();
      this.onChange(this.value);
      return false;
    }
    handleDrop(ev) {
      moveItemInArray(this.value, ev.previousIndex, ev.currentIndex);
    }
    removeValue(index) {
      this.value.splice(index, 1);
      this.onChange(this.value);
    }
    writeValue(obj) {
      this.value = obj;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function LepiInputChip_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputChip)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputChip,
        selectors: [["lepi-input-chip"]],
        viewQuery: function LepiInputChip_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          duplicate: [2, "duplicate", "duplicate", booleanAttribute],
          reorder: [2, "reorder", "reorder", booleanAttribute],
          icon: "icon",
          placeholder: "placeholder",
          direction: "direction"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputChip,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 25,
        consts: [[1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [1, "flex", "items-center", "gap-2", "transition-colors", "border-2", "border-gray-300", "group", 3, "ngSubmit", "formGroup", "ngClass"], ["class", "w-5 h-5 bg-gray-400 group-focus-within:bg-primary group-hover:bg-primary", 3, "name", 4, "ngIf"], ["type", "text", "formControlName", "value", 1, "w-full", "text-gray-700", "bg-transparent", "outline-none", "disabled:cursor-not-allowed", 3, "ngClass", "required", "placeholder"], [4, "ngIf"], [1, "pr-2", "overflow-y-auto", "max-h-32"], ["cdkDropList", "", 1, "flex", "gap-1", 3, "cdkDropListDropped", "cdkDropListDisabled", "cdkDropListData", "cdkDropListOrientation", "ngClass"], ["cdkDrag", "", "class", "flex items-center justify-between gap-1 px-2 py-1 border rounded-md select-none bg-gray-50", 3, "cursor-grab", 4, "ngFor", "ngForOf"], [3, "required"], [1, "w-5", "h-5", "bg-gray-400", "group-focus-within:bg-primary", "group-hover:bg-primary", 3, "name"], ["class", "text-danger", 4, "ngIf"], [1, "text-danger"], ["cdkDrag", "", 1, "flex", "items-center", "justify-between", "gap-1", "px-2", "py-1", "border", "rounded-md", "select-none", "bg-gray-50"], [1, "flex", "items-center", "gap-1"], ["name", "mdi:menu", "class", "w-4 h-4 bg-gray-600 cursor-grab", "cdkDragHandle", "", 4, "ngIf"], [1, "text-sm", "text-gray-600", "font-content-title"], ["name", "ic:baseline-close", 1, "w-4", "h-4", "bg-gray-600", "cursor-pointer", 3, "click"], ["name", "mdi:menu", "cdkDragHandle", "", 1, "w-4", "h-4", "bg-gray-600", "cursor-grab"]],
        template: function LepiInputChip_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LepiInputChip_lepi_label_1_Template, 2, 2, "lepi-label", 1);
            i0.ɵɵelementStart(2, "form", 2);
            i0.ɵɵlistener("ngSubmit", function LepiInputChip_Template_form_ngSubmit_2_listener($event) {
              return ctx.handleEnter($event);
            });
            i0.ɵɵtemplate(3, LepiInputChip_lepi_icon_3_Template, 1, 1, "lepi-icon", 3);
            i0.ɵɵelement(4, "input", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(5, LepiInputChip_ng_container_5_Template, 4, 3, "ng-container", 5);
            i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
            i0.ɵɵlistener("cdkDropListDropped", function LepiInputChip_Template_div_cdkDropListDropped_7_listener($event) {
              return ctx.handleDrop($event);
            });
            i0.ɵɵtemplate(8, LepiInputChip_div_8_Template, 6, 4, "div", 8);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("formGroup", ctx.form)("ngClass", i0.ɵɵpureFunction3(17, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.currentSize().input)("required", ctx.required)("placeholder", ctx.placeholder || "");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control == null ? null : ctx.control.touched);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("cdkDropListDisabled", !ctx.reorder)("cdkDropListData", ctx.value)("cdkDropListOrientation", ctx.direction)("ngClass", i0.ɵɵpureFunction3(21, _c17, ctx.direction === "horizontal", ctx.direction === "vertical", ctx.disabled));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.value);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, FormsModule, i2.ɵNgNoValidate, i2.DefaultValueAccessor, i2.NgControlStatus, i2.NgControlStatusGroup, i2.RequiredValidator, LepiIcon, DragDropModule, i4.CdkDropList, i4.CdkDrag, i4.CdkDragHandle, LepiLabel, ReactiveFormsModule, i2.FormGroupDirective, i2.FormControlName],
        styles: [".cdk-drag-preview[_ngcontent-%COMP%]{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder[_ngcontent-%COMP%]{opacity:0}.cdk-drag-animating[_ngcontent-%COMP%]{transition:transform .3s cubic-bezier(0,0,.2,1)}.cdk-drop-list-dragging[_ngcontent-%COMP%]   .cdk-drag[_ngcontent-%COMP%]{transition:transform .25s cubic-bezier(0,0,.2,1)}"]
      });
    }
  }
  return LepiInputChip;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
const Domains = ['naver.com', 'gmail.com', 'kakao.com', 'nate.com'];
let LepiInputEmail = /*#__PURE__*/(() => {
  class LepiInputEmail {
    get valid() {
      return this.control?.touched && !this.control?.errors;
    }
    get invalid() {
      return this.control?.touched && this.control?.errors;
    }
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.placeholder = '';
      this.autocomplete = false;
      this.required = false;
      this.disabled = false;
      this.domains = Domains;
      this.type = 'select';
      this.isOpen = signal(false);
      this.isChecked = signal(null);
      this.userEmail = signal('');
      this.selectedIndex = signal(0);
      this._value = signal('');
      this.value = '';
      this.filteredDomain = computed(() => {
        const inputDomain = this._value().split('@')[1];
        if (!inputDomain || inputDomain === '') return this.domains;
        return this.domains.filter(domain => domain.startsWith(inputDomain));
      });
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.onChange = value => {};
      this.onTouched = () => {};
      this.onValidatorChange = () => {};
    }
    ngOnInit() {
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
      }
    }
    ngAfterViewInit() {
      fromEvent(this.inputRef.nativeElement, 'input').subscribe({
        next: ev => {
          ev.stopPropagation();
          this.writeValue(ev.target.value);
          this.onChange(ev.target.value);
          this._value.set(this.value);
          if (this.type === 'select') {
            if (this.value.includes('@')) {
              this.isOpen.set(true);
              this.userEmail.set(this.value.split('@')[0]);
              this.domains = Domains.filter(item => item.startsWith(this.value.split('@')[1]) ? true : false);
            } else {
              this.isOpen.set(false);
              this.selectedIndex.set(0);
            }
          }
        }
      });
      fromEvent(this.inputRef.nativeElement, 'keydown').subscribe({
        next: ev => {
          ev.stopPropagation();
          if (this.type !== 'select') return;
          if (ev.key === 'ArrowUp') {
            if (this.selectedIndex() > 0) {
              this.selectedIndex.set(this.selectedIndex() - 1);
            }
          } else if (ev.key === 'ArrowDown') {
            if (this.selectedIndex() < this.domains.length - 1) {
              this.selectedIndex.set(this.selectedIndex() + 1);
            }
          } else if (ev.key === 'Enter') {
            ev.preventDefault();
            this.isOpen.set(false);
            if (!ev.target.value.includes('@')) return;
            const domain = ev.target.value.split('@')[1];
            const isMatched = this.domains.some(item => item.startsWith(domain) ? true : false);
            if (isMatched) {
              this.value = this.userEmail() + '@' + this.domains[this.selectedIndex()];
              this.onChange(this.value);
              this.writeValue(this.value);
            }
          }
          if (this.isOpen()) {
            const options = this.options?.toArray();
            if (this.domains.length === 1) this.selectedIndex.set(0);
            if (options && options.length !== 0) options[this.selectedIndex()].nativeElement.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        }
      });
    }
    handleClick(index) {
      if (this.type === 'none') return;
      this.selectedIndex.set(index);
      this.isOpen.set(false);
      this.value = this.userEmail() + '@' + this.domains[this.selectedIndex()];
      this.onChange(this.value);
      this.writeValue(this.value);
    }
    handleHover(ev, index) {
      if (this.type === 'none') return;
      ev.stopPropagation();
      this.selectedIndex.set(index);
    }
    writeValue(obj) {
      this.value = obj;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    validate(control) {
      return Validators.email(control);
    }
    registerOnValidatorChange(fn) {
      this.onValidatorChange = fn;
    }
    static {
      this.ɵfac = function LepiInputEmail_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputEmail)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputEmail,
        selectors: [["lepi-input-email"]],
        viewQuery: function LepiInputEmail_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c18, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          placeholder: "placeholder",
          autocomplete: [2, "autocomplete", "autocomplete", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          disabled: "disabled",
          domains: "domains",
          type: "type"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputEmail,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: LepiInputEmail,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 18,
        consts: [["inputRef", ""], ["options", ""], [1, "flex", "flex-col", "w-full", "gap-2"], [3, "required", 4, "ngIf"], [1, "relative", "flex", "items-center", "w-full", "gap-2", "transition-colors", "border-2", "border-gray-300", "group", 3, "ngClass"], ["type", "email", "inputmode", "email", 1, "relative", "z-20", "w-full", "text-gray-700", "rounded-md", "outline-none", "disabled:cursor-not-allowed", 3, "ngClass", "ngModel", "required", "disabled", "placeholder", "autocomplete"], ["class", "absolute z-10 flex flex-col max-h-[10rem] overflow-auto w-full top-[calc(100%+0.5rem)] left-0 shadow-lg bg-white rounded-md gap-1 px-2 py-1.5", 4, "ngIf"], [4, "ngIf"], [3, "required"], [1, "absolute", "z-10", "flex", "flex-col", "max-h-[10rem]", "overflow-auto", "w-full", "top-[calc(100%+0.5rem)]", "left-0", "shadow-lg", "bg-white", "rounded-md", "gap-1", "px-2", "py-1.5"], ["class", "px-2 py-1.5 text-sm transition-all rounded-md cursor-pointer", 3, "ngClass", "click", "mouseover", 4, "ngFor", "ngForOf"], [1, "px-2", "py-1.5", "text-sm", "transition-all", "rounded-md", "cursor-pointer", 3, "click", "mouseover", "ngClass"], ["class", "text-xs text-danger", 4, "ngIf"], [1, "text-xs", "text-danger"]],
        template: function LepiInputEmail_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, LepiInputEmail_lepi_label_1_Template, 2, 2, "lepi-label", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵelement(3, "input", 5, 0);
            i0.ɵɵtemplate(5, LepiInputEmail_div_5_Template, 2, 1, "div", 6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, LepiInputEmail_ng_container_6_Template, 3, 2, "ng-container", 7);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(14, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.currentSize().input)("ngModel", ctx.value)("required", ctx.required)("disabled", ctx.disabled)("placeholder", ctx.placeholder)("autocomplete", ctx.autocomplete ? "on" : "off");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.isOpen() && ctx.type === "select" && ctx.filteredDomain().length > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.control == null ? null : ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, LepiLabel]
      });
    }
  }
  return LepiInputEmail;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiInputRating = /*#__PURE__*/(() => {
  class LepiInputRating {
    constructor(config) {
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.required = false;
      this.disabled = false;
      this.value = 0;
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
    }
    writeValue(value) {
      this.value = value;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    handleClick(rate) {
      this.value = rate;
      this.onChange?.(this.value);
    }
    static {
      this.ɵfac = function LepiInputRating_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputRating)(i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputRating,
        selectors: [["lepi-input-rating"]],
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputRating,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 2,
        consts: [[1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [1, "flex", "items-center", "gap-1"], ["role", "button", 1, "block", "bg-yellow-400", "cursor-pointer", "w-7", "h-7", 3, "name"], [3, "required"], ["role", "button", 1, "block", "bg-yellow-400", "cursor-pointer", "w-7", "h-7", 3, "click", "name"]],
        template: function LepiInputRating_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LepiInputRating_lepi_label_1_Template, 2, 2, "lepi-label", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵrepeaterCreate(3, LepiInputRating_For_4_Template, 1, 1, "lepi-icon", 3, i0.ɵɵrepeaterTrackByIdentity);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(i0.ɵɵpureFunction0(1, _c19));
          }
        },
        dependencies: [CommonModule, i1.NgIf, LepiLabel, LepiIcon]
      });
    }
  }
  return LepiInputRating;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
let LepiInputDuration = /*#__PURE__*/(() => {
  class LepiInputDuration {
    get valid() {
      return this.control?.touched && !this.control?.errors;
    }
    get invalid() {
      return this.control?.touched && this.control?.errors;
    }
    constructor(injector, config) {
      this.injector = injector;
      this.config = config;
      this.size = input(null);
      this.rounded = input(null);
      this.ngControl = null;
      this.autocomplete = false;
      this.required = false;
      this.debounce = 0;
      this.disabled = false;
      this.value = 0;
      this.hours = signal(0);
      this.minutes = signal(0);
      this.currentSize = computed(() => {
        if (!this.size()) {
          return INPUT_SIZE[this.config?.input?.size || 'md'];
        }
        return INPUT_SIZE[this.size()];
      });
      this.currentRounded = computed(() => {
        if (!this.rounded()) {
          return INPUT_ROUNDED[this.config?.input?.rounded || 'md'];
        }
        return INPUT_ROUNDED[this.rounded()];
      });
      this.onChange = value => {};
      this.onTouched = () => {};
      /** 최대 분을 설정 */
      effect(() => {
        this.hours();
        if (!this.hoursRef) return;
        if (this.hoursRef.nativeElement.value.startsWith('0')) {
          this.hoursRef.nativeElement.value = this.hoursRef.nativeElement.value.replace('0', '');
        }
        if (this.hoursRef.nativeElement.value === '') {
          this.hoursRef.nativeElement.value = '0';
        }
        this.hoursRef.nativeElement.style.width = `${this.hoursRef.nativeElement.value.length ?? 2}ch`;
      });
      effect(() => {
        if (!this.minutesRef) return;
        if (this.minutes() > 59) {
          this.minutesRef.nativeElement.value = '59';
          this.minutes.set(59);
        }
        if (this.minutesRef.nativeElement.value.startsWith('0')) {
          this.minutesRef.nativeElement.value = this.minutesRef.nativeElement.value.replace('0', '');
        }
        if (this.minutesRef.nativeElement.value === '') {
          this.minutesRef.nativeElement.value = '0';
        }
        this.minutesRef.nativeElement.style.width = `${this.minutesRef.nativeElement.value.length ?? 2}ch`;
      }, {
        allowSignalWrites: true
      });
      /** Value를 업데이트 */
      effect(() => {
        const minutes = this.hours() * 60 + this.minutes();
        this.writeValue(minutes);
        this.onChange(minutes);
      }, {
        allowSignalWrites: true
      });
    }
    ngOnInit() {
      if (NgControl) {
        const formControlName = this.injector.get(NgControl);
        if (formControlName && formControlName instanceof FormControlName) {
          this.control = formControlName;
        }
      }
    }
    writeValue(obj) {
      this.value = obj;
      this.hours.set(Math.floor(obj / 60));
      this.minutes.set(obj % 60);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled = isDisabled;
    }
    static {
      this.ɵfac = function LepiInputDuration_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputDuration)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(LEPI_GLOBAL_CONFIG_TOKEN, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputDuration,
        selectors: [["lepi-input-duration"]],
        viewQuery: function LepiInputDuration_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c20, 5);
            i0.ɵɵviewQuery(_c21, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.hoursRef = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.minutesRef = _t.first);
          }
        },
        inputs: {
          size: [1, "size"],
          rounded: [1, "rounded"],
          label: "label",
          autocomplete: [2, "autocomplete", "autocomplete", booleanAttribute],
          required: [2, "required", "required", booleanAttribute],
          debounce: [2, "debounce", "debounce", numberAttribute],
          icon: "icon",
          disabled: "disabled"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputDuration,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 13,
        vars: 22,
        consts: [["hoursRef", ""], ["minutesRef", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [1, "flex", "items-center", "gap-2", "transition-colors", "border-2", "border-gray-300", "group", 3, "ngClass"], ["class", "w-5 h-5 bg-gray-400 group-focus-within:bg-primary group-hover:bg-primary", 3, "name", 4, "ngIf"], ["type", "number", 1, "text-gray-700", "outline-none", "disabled:cursor-not-allowed", 2, "width", "2ch", 3, "ngModelChange", "ngModel", "ngClass", "required", "disabled", "autocomplete"], [1, "min-w-max"], [4, "ngIf"], [3, "required"], [1, "w-5", "h-5", "bg-gray-400", "group-focus-within:bg-primary", "group-hover:bg-primary", 3, "name"], ["class", "text-sm text-danger-500", 4, "ngIf"], [1, "text-sm", "text-danger-500"]],
        template: function LepiInputDuration_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2);
            i0.ɵɵtemplate(1, LepiInputDuration_lepi_label_1_Template, 2, 2, "lepi-label", 3);
            i0.ɵɵelementStart(2, "div", 4);
            i0.ɵɵtemplate(3, LepiInputDuration_lepi_icon_3_Template, 1, 1, "lepi-icon", 5);
            i0.ɵɵelementStart(4, "input", 6, 0);
            i0.ɵɵlistener("ngModelChange", function LepiInputDuration_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.hours.set($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "span", 7);
            i0.ɵɵtext(7, "\uC2DC\uAC04");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "input", 6, 1);
            i0.ɵɵlistener("ngModelChange", function LepiInputDuration_Template_input_ngModelChange_8_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.minutes.set($event));
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "span", 7);
            i0.ɵɵtext(11, "\uBD84");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(12, LepiInputDuration_ng_container_12_Template, 2, 1, "ng-container", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("border-danger", ctx.invalid)("border-success", ctx.valid);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(18, _c3, ctx.disabled ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary", ctx.currentSize().wrapper, ctx.currentRounded()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngModel", ctx.hours())("ngClass", ctx.currentSize().input)("required", ctx.required)("disabled", ctx.disabled)("autocomplete", ctx.autocomplete ? "on" : "off");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngModel", ctx.minutes())("ngClass", ctx.currentSize().input)("required", ctx.required)("disabled", ctx.disabled)("autocomplete", ctx.autocomplete ? "on" : "off");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", ctx.control == null ? null : ctx.control.touched);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.DefaultValueAccessor, i2.NumberValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, LepiLabel, LepiIcon, ReactiveFormsModule],
        styles: ["input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}"]
      });
    }
  }
  return LepiInputDuration;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TimePickerComponent = /*#__PURE__*/(() => {
  class TimePickerComponent {
    constructor() {
      this.minutesRef = viewChild('minutesRef');
      this.hoursRef = viewChild('hoursRef');
      this.currentTime = input();
      this._currentTime = computed(() => {
        const value = this.currentTime();
        const isPM = Number(value.split(':')[0]) >= 12;
        this.isPM.set(isPM);
        this.time.set(value);
      });
      this.pick = new EventEmitter();
      this.time = signal('00:00');
      this.hours = computed(() => {
        const hours = [];
        for (let i = 1; i < 13; i++) {
          if (this.isPM() && i === 12) {
            break;
          }
          hours.push(i.toString().padStart(2, '0'));
        }
        return hours;
      });
      this.minutes = signal(['00']);
      this.currentHour = computed(() => {
        const hour = this.time().split(':')[0];
        if (!this.isPM()) {
          return hour === '00' ? '12' : hour;
        }
        return hour;
      });
      this.currentMinute = computed(() => this.time().split(':')[1]);
      this.isPM = signal(false);
    }
    isSameHour(hour) {
      if (Number(this.currentHour()) > 12) {
        return hour === (Number(this.currentHour()) - 12).toString().padStart(2, '0');
      }
      return hour === this.currentHour();
    }
    ngOnInit() {
      for (let i = 1; i < 60; i++) {
        this.minutes().push(`${i.toString().padStart(2, '0')}`);
      }
    }
    ngAfterViewInit() {
      this.handleScroll();
    }
    handleScroll() {
      const currentHour = document.querySelector(`#hour-${this.currentHour()}`);
      if (currentHour) {
        this.hoursRef().nativeElement.scrollTo({
          behavior: 'smooth',
          top: currentHour['offsetTop'] - 32
        });
      }
      const currentMinute = document.querySelector(`#minute-${this.currentMinute()}`);
      if (currentMinute) {
        this.minutesRef().nativeElement.scrollTo({
          behavior: 'smooth',
          top: currentMinute['offsetTop'] - 32
        });
      }
    }
    selectHour(hour) {
      this.time.set(`${hour}:${this.currentMinute()}`);
      this.change();
    }
    selectMinute(minute) {
      this.time.set(`${this.currentHour()}:${minute}`);
      this.change();
    }
    toggleAMPM(boolean) {
      this.isPM.set(boolean);
      this.change();
    }
    validate() {
      const [hour, minute] = this.time().split(':');
      if (this.isPM()) {
        if (Number(hour) < 12) {
          this.time.set(`${(Number(hour) + 12).toString().padStart(2, '0')}:${minute}`);
        }
      } else {
        if (Number(hour) >= 12) {
          this.time.set(`${(Number(hour) - 12).toString().padStart(2, '0')}:${minute}`);
        }
      }
    }
    change() {
      this.validate();
      this.pick.emit(this.time());
    }
    static {
      this.ɵfac = function TimePickerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TimePickerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TimePickerComponent,
        selectors: [["app-time-picker"]],
        viewQuery: function TimePickerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.minutesRef, _c21, 5);
            i0.ɵɵviewQuerySignal(ctx.hoursRef, _c20, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance(2);
          }
        },
        inputs: {
          currentTime: [1, "currentTime"]
        },
        outputs: {
          pick: "pick"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 16,
        vars: 2,
        consts: [["hoursRef", ""], ["minutesRef", ""], [1, "flex", "min-w-full", "w-max", "shadow-md", "z-10", "bg-white", "rounded-md", "p-2", "px-4", "gap-4"], [1, "flex", "flex-col", "h-full", "gap-2"], [1, "p-3", "px-5", "text-sm", "transition-colors", "cursor-pointer", "rounded", 3, "click", "ngClass"], [1, "flex-1", "pl-4", "picker", "border-l", "border-neutral-100", "max-h-[20rem]", "overflow-y-auto", "overflow-hidden"], [1, "min-w-[7rem]", "w-full", "text-center", "p-3", "text-sm", "transition-colors", "cursor-pointer", "rounded", 3, "id", "ngClass"], [1, "min-w-[7rem]", "w-full", "text-center", "p-3", "text-sm", "transition-colors", "cursor-pointer", "rounded", 3, "click", "id", "ngClass"]],
        template: function TimePickerComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 2)(1, "div", 3)(2, "p", 4);
            i0.ɵɵlistener("click", function TimePickerComponent_Template_p_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleAMPM(false));
            });
            i0.ɵɵtext(3, "\uC624\uC804");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "p", 4);
            i0.ɵɵlistener("click", function TimePickerComponent_Template_p_click_4_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.toggleAMPM(true));
            });
            i0.ɵɵtext(5, "\uC624\uD6C4");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5, 0)(8, "div", 3);
            i0.ɵɵrepeaterCreate(9, TimePickerComponent_For_10_Template, 2, 3, "p", 6, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "div", 5, 1)(13, "div", 3);
            i0.ɵɵrepeaterCreate(14, TimePickerComponent_For_15_Template, 2, 3, "p", 6, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", !ctx.isPM() ? "bg-primary text-white" : "hover:bg-neutral-100");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.isPM() ? "bg-primary text-white" : "hover:bg-neutral-100");
            i0.ɵɵadvance(5);
            i0.ɵɵrepeater(ctx.hours());
            i0.ɵɵadvance(5);
            i0.ɵɵrepeater(ctx.minutes());
          }
        },
        dependencies: [CommonModule, i1.NgClass],
        styles: [".picker[_ngcontent-%COMP%]{-ms-overflow-style:none;scrollbar-width:none}.picker[_ngcontent-%COMP%]::-webkit-scrollbar{display:none}"]
      });
    }
  }
  return TimePickerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const SLIDE_LEFT_IN = (duration = 400) => trigger('slideLeftIn', [state('in', style({
  opacity: 0
})), transition(':leave', [style({
  transform: 'translateX(0)',
  opacity: 1
}), group([animate(`${duration}ms ease-in-out`, style({
  opacity: '0'
}))])]), transition(':enter', [style({
  transform: 'translateX(200%)',
  opacity: 1
}), group([animate(`${duration}ms ease-in-out`, style({
  transform: 'translateX(0)'
}))])])]);
const FADE_IN_OUT = (duration = 400) => trigger('fadeInOut', [state('in', style({
  opacity: 0
})), transition(':leave', [style({
  opacity: 1
}), group([animate(`${duration}ms ease-in-out`, style({
  opacity: '0'
}))])]), transition(':enter', [style({
  opacity: 0
}), group([animate(`${duration}ms ease-in-out`, style({
  opacity: '1'
}))])])]);
const FADE_IN = (duration = 400) => trigger('fadeIn', [state('in', style({
  opacity: 0
})), transition(':leave', [style({
  opacity: 1
}), group([animate(`0ms ease-in-out`, style({
  opacity: '0'
}))])]), transition(':enter', [style({
  opacity: 0
}), group([animate(`${duration}ms ease-in-out`, style({
  opacity: '1'
}))])])]);
let LepiInputTime = /*#__PURE__*/(() => {
  class LepiInputTime {
    constructor() {
      this.inputRef = viewChild('inputRef');
      this.label = input('');
      this.required = input(false, {
        transform: booleanAttribute
      });
      this.readonly = input(false, {
        transform: booleanAttribute
      });
      this.disabled = input(false, {
        transform: booleanAttribute
      });
      this.isOpen = signal(false);
      this.value = model(null);
      this.onChange = value => {};
      this.onTouch = () => {};
      effect(() => {
        this.writeValue(this.value());
        this.onChange(this.value());
      }, {
        allowSignalWrites: true
      });
    }
    ngOnInit() {
      this.writeValue('00:00');
    }
    ngAfterViewInit() {
      fromEvent(this.inputRef().nativeElement, 'change').subscribe(event => {
        this.writeValue(event.target['value']);
      });
    }
    openPicker() {
      this.isOpen.set(true);
    }
    pick(time) {
      this.writeValue(time);
    }
    writeValue(obj) {
      this.value.set(obj);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    setDisabledState(isDisabled) {}
    static {
      this.ɵfac = function LepiInputTime_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiInputTime)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiInputTime,
        selectors: [["lepi-input-time"]],
        viewQuery: function LepiInputTime_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuerySignal(ctx.inputRef, _c2, 5);
          }
          if (rf & 2) {
            i0.ɵɵqueryAdvance();
          }
        },
        inputs: {
          label: [1, "label"],
          required: [1, "required"],
          readonly: [1, "readonly"],
          disabled: [1, "disabled"],
          value: [1, "value"]
        },
        outputs: {
          value: "valueChange"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiInputTime,
          multi: true
        }]), i0.ɵɵStandaloneFeature],
        decls: 9,
        vars: 8,
        consts: [["inputRef", ""], [1, "flex", "flex-col", "gap-2"], [1, "flex", "items-center", "gap-2"], [1, "relative"], [1, "flex", "items-center", "gap-2", "px-3", "text-sm", "transition-colors", "border-2", "rounded-md", "border-neutral-300", "group", 3, "ngClass"], ["type", "time", 1, "w-full", "py-1.5", "outline-none", "text-neutral-700", "disabled:cursor-not-allowed", 3, "ngModelChange", "ngModel", "required", "readonly", "disabled"], ["name", "mdi:clock-outline", 1, "cursor-pointer", "size-5", "bg-neutral-400", "group-focus-within:bg-primary", "min-w-max", "group-hover:bg-primary", 3, "click"], ["lepiClickOutside", "", 1, "absolute", "z-10", "min-size-full", "w-max", 3, "currentTime"], [1, "text-sm", "text-neutral-500"], [3, "required"], ["lepiClickOutside", "", 1, "absolute", "z-10", "min-size-full", "w-max", 3, "outside", "pick", "currentTime"]],
        template: function LepiInputTime_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiInputTime_Conditional_1_Template, 3, 2, "div", 2);
            i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "input", 5, 0);
            i0.ɵɵtwoWayListener("ngModelChange", function LepiInputTime_Template_input_ngModelChange_4_listener($event) {
              i0.ɵɵrestoreView(_r1);
              i0.ɵɵtwoWayBindingSet(ctx.value, $event) || (ctx.value = $event);
              return i0.ɵɵresetView($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "lepi-icon", 6);
            i0.ɵɵlistener("click", function LepiInputTime_Template_lepi_icon_click_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.openPicker());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(7, LepiInputTime_Conditional_7_Template, 1, 1, "app-time-picker", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(8, LepiInputTime_Conditional_8_Template, 2, 0, "p", 8);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_1_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_1_0 = ctx.label()) ? 1 : -1, tmp_1_0);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.disabled() ? "cursor-not-allowed bg-neutral-100 border-neutral-400" : "hover:border-primary-300 hover:focus-within:border-primary focus-within:border-primary");
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.value);
            i0.ɵɵproperty("required", ctx.required())("readonly", ctx.readonly())("disabled", ctx.disabled());
            i0.ɵɵadvance(3);
            i0.ɵɵconditional(ctx.isOpen() ? 7 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.readonly() ? 8 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiIcon, LepiLabel, FormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.RequiredValidator, i2.NgModel, TimePickerComponent, LepiClickOutsideDirective],
        styles: ["input[type=time][_ngcontent-%COMP%]::-webkit-calendar-picker-indicator{display:none}"],
        data: {
          animation: [FADE_IN_OUT()]
        }
      });
    }
  }
  return LepiInputTime;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiHint = /*#__PURE__*/(() => {
  class LepiHint {
    static {
      this.ɵfac = function LepiHint_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiHint)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiHint,
        selectors: [["lepi-hint"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 0,
        consts: [[1, "px-2", "py-1", "rounded-md", "bg-primary-100", "flex", "gap-2", "items-center", "w-max", "text-gray-700", "text-xs"], ["name", "mdi:information-slab-circle", 1, "w-4", "h-4", "bg-primary"], [1, "mb-px"]],
        template: function LepiHint_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "lepi-icon", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
        },
        dependencies: [CommonModule, LepiIcon]
      });
    }
  }
  return LepiHint;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSpinner = /*#__PURE__*/(() => {
  class LepiSpinner {
    static {
      this.ɵfac = function LepiSpinner_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSpinner)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSpinner,
        selectors: [["lepi-spinner"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [[1, "flex", "items-center", "justify-center", "w-full", "h-full"], ["name", "mdi:loading", 1, "animate-spin", "size-20", "bg-primary"]],
        template: function LepiSpinner_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0);
            i0.ɵɵelement(1, "lepi-icon", 1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule, LepiIcon]
      });
    }
  }
  return LepiSpinner;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiFileUploader = /*#__PURE__*/(() => {
  class LepiFileUploader {
    set accept(value) {
      this._accept.set(value);
    }
    constructor() {
      this.lepiError = new EventEmitter();
      this.lepiChanged = new EventEmitter();
      this.required = false;
      this.maxlength = 1;
      this.minlength = 1;
      this.direction = 'column';
      this.value = [];
      this._accept = signal('');
      this.type = computed(() => this._accept().includes('image') ? 'image' : 'file');
      this.disabled = signal(false);
      this.items = signal([{
        url: '',
        filename: '',
        status: 'success'
      }, {
        url: '',
        filename: '',
        status: 'success'
      }, {
        url: '',
        filename: '',
        status: 'success'
      }]);
      this.isDragOvered = signal(false);
      this.isLoading = signal(false);
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    validate() {
      if (this.required && this.items().length === 0) {
        return {
          required: true
        };
      }
      if (this.items().some(item => item.status === 'fail')) return {
        invalid: true
      };
      return null;
    }
    openFileSelect() {
      const input = document.getElementById('lepi-file-uploader');
      input.addEventListener('change', e => {
        const files = e.target.files;
        if (this.items().length + files.length > this.maxlength) {
          this.lepiError.emit(`최대 업로드 개수(${this.maxlength}개)를 초과하였습니다.`);
          return;
        }
        if (files) this.onFileSelect(files);
      });
      input.click();
    }
    onFileDrop(ev) {
      ev.preventDefault();
      const files = ev.dataTransfer?.files;
      if (files) this.onFileSelect(files);
    }
    async onFileSelect(files) {
      const fileList = Array.from(files);
      if (this.items().length + fileList.length > this.maxlength) {
        this.lepiError.emit(`최대 업로드 개수(${this.maxlength}개)를 초과하였습니다.`);
        return;
      }
      for (const file of fileList) {
        if (this.items().length === this.maxlength) {
          this.lepiError.emit(`최대 업로드 개수(${this.maxlength}개)를 초과하였습니다.`);
          return;
        }
        const result = await this.uploadFile(file);
        this.items.update(items => {
          items.push({
            ...result,
            status: 'success'
          });
          return items;
        });
      }
      this.writeValue(this.items().map(item => item.url));
      this.onChange(this.value);
    }
    /** 파일을 업로드 합니다. */
    async uploadFile(file) {
      this.isLoading.set(true);
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const res = await this.uploadHandler(file);
          resolve(res);
          this.isLoading.set(false);
        } catch (error) {
          this.lepiError.emit(error.message);
          reject(error.message);
          this.isLoading.set(false);
        }
      });
    }
    /** 파일을 삭제합니다. */
    async deleteFile(url) {
      this.isLoading.set(true);
      try {
        await this.deleteHandler(url);
        this.items.update(items => {
          const index = items.findIndex(item => item.url === url);
          if (index !== -1) items.splice(index, 1);
          return items;
        });
        this.writeValue(this.items().map(item => item.url));
        this.onChange(this.value);
        this.isLoading.set(false);
      } catch (error) {
        this.items.update(items => {
          const index = items.findIndex(item => item.url === url);
          if (index !== -1) items.splice(index, 1);
          return items;
        });
        this.writeValue(this.items().map(item => item.url));
        this.onChange(this.value);
        this.isLoading.set(false);
      }
    }
    getFilenameFromUrl(url) {
      if (!url) return '';
      if (!url.includes('/')) return url;
      return url.split('/').pop() ?? '';
    }
    writeValue(value) {
      this.value = value || [];
      this.setItems(this.value);
      this.lepiChanged.emit(this.value);
    }
    setItems(value) {
      this.items.set(value.map(url => ({
        url,
        filename: this.getFilenameFromUrl(url),
        status: 'success'
      })));
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    onDragOver(e) {
      e.preventDefault();
      this.isDragOvered.set(true);
    }
    onDragLeave(e) {
      e.preventDefault();
      this.isDragOvered.set(false);
    }
    openImage(url) {
      window.open(url);
    }
    onDrop(ev) {
      if (ev.container === ev.previousContainer) {
        this.items.update(items => {
          const temp = items;
          moveItemInArray(temp, ev.previousIndex, ev.currentIndex);
          return temp;
        });
        this.writeValue(this.items().map(item => item.url));
        this.onChange(this.value);
      }
    }
    static {
      this.ɵfac = function LepiFileUploader_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiFileUploader)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiFileUploader,
        selectors: [["lepi-file-uploader"]],
        inputs: {
          label: "label",
          required: [2, "required", "required", booleanAttribute],
          maxlength: [2, "maxlength", "maxlength", numberAttribute],
          minlength: [2, "minlength", "minlength", numberAttribute],
          direction: "direction",
          hint: "hint",
          uploadHandler: "uploadHandler",
          deleteHandler: "deleteHandler",
          accept: "accept"
        },
        outputs: {
          lepiError: "lepiError",
          lepiChanged: "lepiChanged"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiFileUploader,
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: LepiFileUploader,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 7,
        vars: 8,
        consts: [["files", ""], [1, "flex", "flex-col", "gap-2"], [3, "required", 4, "ngIf"], [4, "ngIf"], [1, "flex", "w-full", "gap-6"], [1, "z-10"], ["id", "lepi-file-uploader", "type", "file", "multiple", "", 1, "hidden", 3, "accept"], [3, "required"], ["class", "flex flex-col w-full gap-2 min-w-max", 4, "ngIf"], ["cdkDropList", "", "class", "flex flex-col gap-2 max-h-[20rem] min-w-[15rem]", 3, "cdkDropListData", "cdkDropListDisabled", "cdkDropListDropped", 4, "ngIf"], [1, "flex", "flex-col", "w-full", "gap-2", "min-w-max"], [1, "p-4", "min-w-[20rem]", "gap-4", "border-2", "border-gray-200", "border-dashed", "rounded-lg", "flex", "flex-col", "items-center", "justify-center", "hover:border-primary", "hover:bg-primary-50", "transition-all", "cursor-pointer", 3, "click", "dragover", "dragleave", "drop", "ngClass"], ["name", "ic:baseline-upload-file", 1, "w-8", "h-8", "bg-primary"], [1, "flex", "flex-col", "gap-1", "text-center"], [1, "text-sm", "text-gray-800"], [1, "text-sm", "text-gray-500"], ["class", "flex w-full text-sm text-gray-500", 4, "ngIf"], [1, "flex", "w-full", "text-sm", "text-gray-500"], ["cdkDropList", "", 1, "flex", "flex-col", "gap-2", "max-h-[20rem]", "min-w-[15rem]", 3, "cdkDropListDropped", "cdkDropListData", "cdkDropListDisabled"], ["cdkDrag", "", "class", "flex w-full justify-between p-2.5 gap-2.5 bg-white border border-gray-200 rounded-md", 4, "ngFor", "ngForOf"], ["cdkDrag", "", 1, "flex", "w-full", "justify-between", "p-2.5", "gap-2.5", "bg-white", "border", "border-gray-200", "rounded-md"], [1, "flex", "gap-2.5", "items-center"], [4, "ngIf", "ngIfElse"], [1, "flex", "flex-col", "gap-1"], [1, "w-full", "truncate", "max-w-[10rem]", "lg:max-w-[25rem]", "text-sm", "text-gray-700", 3, "ngClass"], [1, "flex", "items-center", "gap-4"], ["class", "w-5 h-5 bg-red-500", "name", "ic:round-warning-amber", 4, "ngIf"], ["class", "w-5 h-5 bg-green-500", "name", "ic:baseline-check", 4, "ngIf"], ["class", "w-5 h-5 bg-primary animate-spin", "name", "mdi:loading", 4, "ngIf"], ["name", "ic:outline-close", "class", "w-5 h-5 bg-gray-700 cursor-pointer", 3, "click", 4, "ngIf"], ["class", "rounded-md cursor-pointer w-9 h-9", 3, "src", "click", "error", 4, "ngIf"], ["class", "flex items-center justify-center p-2 border border-gray-200 rounded-md w-9 h-9", 4, "ngIf"], [1, "rounded-md", "cursor-pointer", "w-9", "h-9", 3, "click", "error", "src"], [1, "flex", "items-center", "justify-center", "p-2", "border", "border-gray-200", "rounded-md", "w-9", "h-9"], ["name", "mdi:file-image", 1, "block", "w-6", "h-6", "bg-gray-700"], ["name", "ic:outline-insert-drive-file", 1, "block", "w-6", "h-6", "bg-gray-700"], ["name", "ic:round-warning-amber", 1, "w-5", "h-5", "bg-red-500"], ["name", "ic:baseline-check", 1, "w-5", "h-5", "bg-green-500"], ["name", "mdi:loading", 1, "w-5", "h-5", "bg-primary", "animate-spin"], ["name", "ic:outline-close", 1, "w-5", "h-5", "bg-gray-700", "cursor-pointer", 3, "click"]],
        template: function LepiFileUploader_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 1);
            i0.ɵɵtemplate(1, LepiFileUploader_lepi_label_1_Template, 2, 2, "lepi-label", 2)(2, LepiFileUploader_lepi_hint_2_Template, 2, 1, "lepi-hint", 3);
            i0.ɵɵelementStart(3, "div", 4);
            i0.ɵɵtemplate(4, LepiFileUploader_Conditional_4_Template, 1, 0, "lepi-spinner", 5)(5, LepiFileUploader_Conditional_5_Template, 2, 2);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "input", 6);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.hint);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("flex-row", ctx.direction === "row")("flex-col", ctx.direction === "column");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isLoading() ? 4 : 5);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("accept", ctx._accept());
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, DragDropModule, i4.CdkDropList, i4.CdkDrag, LepiIcon, LepiLabel, LepiHint, FormsModule, LepiSpinner]
      });
    }
  }
  return LepiFileUploader;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/no-output-native */
let LepiRadioOption = /*#__PURE__*/(() => {
  class LepiRadioOption {
    constructor() {
      this.class = 'flex gap-2';
      this.select = new EventEmitter();
      this.value = model();
      this.active = model(false);
      this.label = input();
    }
    static {
      this.ɵfac = function LepiRadioOption_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiRadioOption)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiRadioOption,
        selectors: [["lepi-radio-option"]],
        hostVars: 2,
        hostBindings: function LepiRadioOption_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassMap(ctx.class);
          }
        },
        inputs: {
          value: [1, "value"],
          active: [1, "active"],
          label: [1, "label"]
        },
        outputs: {
          select: "select",
          value: "valueChange",
          active: "activeChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c24,
        decls: 8,
        vars: 3,
        consts: [[1, "flex", "gap-2", "cursor-pointer", "group", 3, "click"], [1, "relative", "flex", "items-center", "justify-center", "w-5", "h-5", "transition-all", "duration-200", "ease-in-out", "border-2", "border-gray-400", "rounded-full", 3, "ngClass"], [1, "absolute", "w-0", "h-0", "transition-all", "duration-200", "ease-in-out", "rounded-full", "group-hover:bg-primary/10", "group-hover:w-8", "group-hover:h-8"], [1, "w-3", "h-3", "transition-colors", "rounded-full", 3, "ngClass"], [1, "flex", "flex-col", "gap-1", "py-0.5", "leading-none"]],
        template: function LepiRadioOption_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c24);
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function LepiRadioOption_Template_div_click_0_listener() {
              return ctx.select.emit(ctx.value());
            });
            i0.ɵɵelementStart(1, "div", 1);
            i0.ɵɵelement(2, "div", 2)(3, "div", 3);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtemplate(5, LepiRadioOption_Conditional_5_Template, 2, 1, "p")(6, LepiRadioOption_Conditional_6_Template, 1, 0);
            i0.ɵɵprojection(7, 0, ["[select]", "description"]);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.active() ? "border-primary" : undefined);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.active() ? "bg-primary" : "bg-white");
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.label() ? 5 : 6);
          }
        },
        dependencies: [CommonModule, i1.NgClass]
      });
    }
  }
  return LepiRadioOption;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiRadio = /*#__PURE__*/(() => {
  class LepiRadio {
    constructor(injector) {
      this.injector = injector;
      this.direction = 'horizontal';
      this.required = false;
      this.disabled = false;
      this.ngControl = null;
      this.value = model();
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    ngOnInit() {
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl && ngControl instanceof FormControlName) {
        this.control = ngControl;
      }
    }
    ngAfterContentInit() {
      if (this.value()) {
        this.onChange(this.value());
        this.options.map(option => option.active.set(false));
        this.options.map(option => {
          if (option.value() == this.value()) {
            option.active.set(true);
          }
        });
      }
      scheduled(this.options.map(item => item.select), asyncScheduler).pipe(mergeAll()).subscribe({
        next: value => {
          const option = this.options.find(option => option.value() == value);
          if (!option) return;
          this.writeValue(option.value());
          this.onChange(option.value());
          this.options.map(option => option.active.set(false));
          this.options.map(option => {
            if (option.value() == this.value()) {
              option.active.set(true);
            }
          });
        }
      });
    }
    writeValue(obj) {
      this.value.set(obj);
      if ((typeof this.value() === 'boolean' ? true : this.value()) && this.options) {
        this.onChange(this.value());
        this.options.map(option => option.active.set(false));
        this.options.map(option => {
          if (option.value() == this.value()) {
            option.active.set(true);
          }
        });
      }
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static {
      this.ɵfac = function LepiRadio_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiRadio)(i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiRadio,
        selectors: [["lepi-radio"]],
        contentQueries: function LepiRadio_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiRadioOption, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
          }
        },
        inputs: {
          label: "label",
          direction: "direction",
          required: [2, "required", "required", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          value: [1, "value"]
        },
        outputs: {
          value: "valueChange"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiRadio,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 3,
        consts: [[1, "flex", "flex-col", "gap-2"], [3, "required"], [1, "flex", "gap-4", "text-sm"]],
        template: function LepiRadio_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LepiRadio_Conditional_1_Template, 2, 2, "lepi-label", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.label ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("flex-col", ctx.direction === "vertical");
          }
        },
        dependencies: [CommonModule, FormsModule, ReactiveFormsModule, LepiLabel],
        styles: [".radio-section[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:8px}.radio-items[_ngcontent-%COMP%]{display:flex;gap:16px}.radio-item[_ngcontent-%COMP%]{display:flex;align-items:center;gap:12px}.col[_ngcontent-%COMP%]{flex-direction:column}.radio-button[_ngcontent-%COMP%]{position:relative;width:22px;height:22px;border:2px solid var(--gray-400);border-radius:9999px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:.2 ease-in-out}.radio-button[_ngcontent-%COMP%]:hover   .radio-absolute-item[_ngcontent-%COMP%]{background-color:var(--primary-50);width:40px;height:40px;transition:.2 ease-in-out}.radio-button.active[_ngcontent-%COMP%]{border-color:var(--primary)}.radio-button.active[_ngcontent-%COMP%]   .radio-circle[_ngcontent-%COMP%]{background-color:var(--primary);width:12px;height:12px;transition:width .2s ease-in-out,height .2s ease-in-out}.radio-label[_ngcontent-%COMP%]{font-size:14px}.radio-text[_ngcontent-%COMP%]{display:flex;flex-direction:column;gap:4px;cursor:pointer}.radio-description[_ngcontent-%COMP%]{font-size:14px;color:var(--gray-500)}.radio-circle[_ngcontent-%COMP%]{width:0px;height:0px;background-color:transparent;transition:all .2;border-radius:9999px}.radio-absolute-item[_ngcontent-%COMP%]{z-index:-10;position:absolute;border-radius:9999px;width:0px;height:0px}"]
      });
    }
  }
  return LepiRadio;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const components$1 = [LepiRadioOption, LepiRadio];
let LepiRadioModule = /*#__PURE__*/(() => {
  class LepiRadioModule {
    static {
      this.ɵfac = function LepiRadioModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiRadioModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LepiRadioModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [components$1]
      });
    }
  }
  return LepiRadioModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/no-output-native */
let LepiSegmentItem = /*#__PURE__*/(() => {
  class LepiSegmentItem {
    constructor() {
      this.class = 'flex-1 w-full';
      this.style = 'width: 100%;';
      this.click = new EventEmitter();
      this.index = -1;
      this.active = false;
    }
    static {
      this.ɵfac = function LepiSegmentItem_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSegmentItem)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSegmentItem,
        selectors: [["lepi-segment-item"]],
        hostVars: 4,
        hostBindings: function LepiSegmentItem_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
            i0.ɵɵclassMap(ctx.class);
          }
        },
        inputs: {
          value: "value",
          icon: "icon",
          iconClass: "iconClass",
          itemLength: [2, "itemLength", "itemLength", numberAttribute],
          label: "label"
        },
        outputs: {
          click: "click"
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 7,
        vars: 5,
        consts: [["item", ""], [1, "flex", "items-center", "justify-center", "flex-1", "gap-2", "px-3", "py-1.5", "font-semibold", "transition-colors", "duration-200", "ease-in-out", "rounded-md", "cursor-pointer", "select-none", "min-w-max", "hover:bg-gray-50", "active:bg-gray-100", 3, "click"], [3, "name", 4, "ngIf"], [1, "text-base", "transition-colors", "duration-200", "ease-in-out", 3, "ngClass"], [4, "ngIf"], ["class", "flex items-center justify-center px-2 py-0.5 pb-1 text-sm rounded-md min-w-max bg-primary-100", 4, "ngIf"], [3, "name"], [1, "flex", "items-center", "justify-center", "px-2", "py-0.5", "pb-1", "text-sm", "rounded-md", "min-w-max", "bg-primary-100"]],
        template: function LepiSegmentItem_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 1, 0);
            i0.ɵɵlistener("click", function LepiSegmentItem_Template_div_click_0_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.click.emit());
            });
            i0.ɵɵtemplate(2, LepiSegmentItem_lepi_icon_2_Template, 1, 1, "lepi-icon", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵtemplate(4, LepiSegmentItem_ng_container_4_Template, 2, 1, "ng-container", 4)(5, LepiSegmentItem_ng_content_5_Template, 1, 0, "ng-content", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(6, LepiSegmentItem_div_6_Template, 2, 1, "div", 5);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.active ? "text-gray-700" : "text-gray-500");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !ctx.label);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", !!ctx.itemLength);
          }
        },
        dependencies: [LepiIcon, CommonModule, i1.NgClass, i1.NgIf]
      });
    }
  }
  return LepiSegmentItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiSegment = /*#__PURE__*/(() => {
  class LepiSegment {
    constructor(ngControl) {
      this.expand = false;
      this.reset = null;
      this.value = signal(null);
      this.disabled = signal(false);
      this.onChange = value => {};
      this.onTouched = () => {};
      if (ngControl) ngControl.valueAccessor = this;
      effect(() => {
        if (this.value() && this.items && this.itemsRef) this.transform(this.value());
      });
    }
    ngAfterContentInit() {
      setTimeout(() => this.transform(this.value()), 300);
      this.items.forEach((item, index) => {
        item.index = index;
        /** SegmentItem의 Click 이벤트를 감지  */
        item.click.subscribe(() => {
          this.writeValue(item.value);
        });
      });
    }
    transform(value) {
      const index = this.items.toArray().findIndex(item => item.value === value);
      if (index === -1) return;
      this.items.forEach((item, _index) => item.active = index === _index);
      this.indicator.nativeElement.style.width = `${this.itemsRef.toArray()[index].nativeElement.offsetWidth}px`;
      this.indicator.nativeElement.style.transform = `translateX(${this.getTranslateX(index)}px)`;
    }
    getTranslateX(index) {
      return this.itemsRef.toArray().splice(0, index).reduce((acc, cur) => acc + cur.nativeElement.offsetWidth, 0);
    }
    writeValue(value) {
      this.value.set(value);
      this.onChange(value);
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    static {
      this.ɵfac = function LepiSegment_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSegment)(i0.ɵɵdirectiveInject(i2.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSegment,
        selectors: [["lepi-segment"]],
        contentQueries: function LepiSegment_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiSegmentItem, 4);
            i0.ɵɵcontentQuery(dirIndex, LepiSegmentItem, 4, ElementRef);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.items = _t);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsRef = _t);
          }
        },
        viewQuery: function LepiSegment_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c25, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.indicator = _t.first);
          }
        },
        inputs: {
          expand: [2, "expand", "expand", booleanAttribute],
          reset: "reset"
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 1,
        consts: [["indicator", ""], [1, "relative", "flex", 3, "ngClass"], [1, "absolute", "transition-all", "duration-300", "ease-in-out", "bg-primary", 2, "height", "0.25rem", "bottom", "-0.25rem"]],
        template: function LepiSegment_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 1);
            i0.ɵɵprojection(1);
            i0.ɵɵelement(2, "div", 2, 0);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.expand ? "w-full" : "max-w-max");
          }
        },
        dependencies: [CommonModule, i1.NgClass],
        encapsulation: 2
      });
    }
  }
  return LepiSegment;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const components = [LepiSegment, LepiSegmentItem];
let LepiSegmentModule = /*#__PURE__*/(() => {
  class LepiSegmentModule {
    static {
      this.ɵfac = function LepiSegmentModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSegmentModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LepiSegmentModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [components]
      });
    }
  }
  return LepiSegmentModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
;
let LepiTopBar = /*#__PURE__*/(() => {
  class LepiTopBar {
    constructor() {
      this.icons = [];
      this.header = '';
      this.description = '';
      this.isScrolled = false;
      this.name = '';
      this.subname = '';
      this.isOpen = true;
    }
    static {
      this.ɵfac = function LepiTopBar_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiTopBar)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiTopBar,
        selectors: [["lepi-top-bar"]],
        viewQuery: function LepiTopBar_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c14, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.content = _t.first);
          }
        },
        inputs: {
          icons: "icons",
          header: "header",
          description: "description",
          isScrolled: "isScrolled"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c27,
        decls: 10,
        vars: 5,
        consts: [["id", "top-bar", 1, "z-50", "flex", "justify-between", "w-full", "p-6", "transition-all", 3, "ngClass"], [1, "flex", "flex-col", "gap-1"], [1, "text-2xl", "font-bold"], [1, "flex", "text-sm", "text-gray-600"], [1, "flex", "items-center", "gap-2"], [1, "flex", "items-center", "gap-2", "p-2", "transition-colors", "rounded-md", "cursor-pointer", "hover:bg-gray-100", "group"], [1, "flex", "items-center", "gap-2", "p-2", "transition-colors", "rounded-md", "cursor-pointer", "hover:bg-gray-100", "group", 3, "click"], [1, "w-5", "h-5", "bg-gray-700", "group-hover:bg-gray-800", 3, "name"], [1, "text-sm"]],
        template: function LepiTopBar_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c26);
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, LepiTopBar_Conditional_4_Template, 2, 1, "div", 3)(5, LepiTopBar_Conditional_5_Template, 1, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "div", 4);
            i0.ɵɵprojection(7);
            i0.ɵɵrepeaterCreate(8, LepiTopBar_For_9_Template, 3, 2, "div", 5, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c28, ctx.isScrolled));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.header);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.description ? 4 : 5);
            i0.ɵɵadvance(4);
            i0.ɵɵrepeater(ctx.icons);
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiIcon]
      });
    }
  }
  return LepiTopBar;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSideMenuItem = /*#__PURE__*/(() => {
  class LepiSideMenuItem {
    constructor() {
      this.active = false;
      this.icon = '';
    }
    static {
      this.ɵfac = function LepiSideMenuItem_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSideMenuItem)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSideMenuItem,
        selectors: [["lepi-side-menu-item"]],
        inputs: {
          routerLinkActive: "routerLinkActive",
          active: [2, "active", "active", booleanAttribute],
          icon: "icon"
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 4,
        consts: [[1, "select-none", "transition-all", "cursor-pointer", "px-3", "py-1.5", "rounded-md", "text-sm", "flex", "justify-between", "items-center", "group", 3, "routerLinkActive", "ngClass"], [1, "flex", "items-center", "gap-3"], [1, "w-6", "h-6", "transition-all", 3, "ngClass", "name"], [1, "flex", "flex-col"]],
        template: function LepiSideMenuItem_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵelement(2, "lepi-icon", 2);
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵproperty("routerLinkActive", (tmp_0_0 = ctx.routerLinkActive) !== null && tmp_0_0 !== undefined ? tmp_0_0 : "")("ngClass", ctx.active ? "bg-primary-50 hover:bg-primary-100 text-primary-400" : "hover:bg-gray-100 text-gray-400 hover:text-gray-700");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.active ? "bg-primary" : "bg-gray-400 group-hover:bg-gray-700")("name", ctx.icon);
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiIcon, RouterModule, i2$1.RouterLinkActive]
      });
    }
  }
  return LepiSideMenuItem;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSideMenu = /*#__PURE__*/(() => {
  class LepiSideMenu {
    constructor() {
      this.label = '';
      this.logo = '';
      this.icon = '';
      this.iconClass = '';
    }
    static {
      this.ɵfac = function LepiSideMenu_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSideMenu)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSideMenu,
        selectors: [["lepi-side-menu"]],
        inputs: {
          label: "label",
          logo: "logo",
          icon: "icon",
          iconClass: "iconClass"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 8,
        vars: 2,
        consts: [[1, "border-r", "border-gray-200", "flex", "flex-col", "h-full", "gap-5", "px-5", "w-max", "min-w-[15.75rem]", "pb-5"], [1, "flex", "gap-2.5", "items-center", "py-7", "px-5", "border-b", "border-gray-200"], [3, "src"], [3, "name", "class"], [1, "font-semibold", "text-gray-700"], [1, "flex", "flex-col", "gap-1"], [3, "name"]],
        template: function LepiSideMenu_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "section", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, LepiSideMenu_Conditional_2_Template, 1, 1, "img", 2)(3, LepiSideMenu_Conditional_3_Template, 1, 3, "lepi-icon", 3);
            i0.ɵɵelementStart(4, "p", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 5);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.icon ? 2 : 3);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.label);
          }
        },
        dependencies: [CommonModule, LepiIcon]
      });
    }
  }
  return LepiSideMenu;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSideMenuItemChild = /*#__PURE__*/(() => {
  class LepiSideMenuItemChild {
    constructor() {
      this.active = false;
    }
    static {
      this.ɵfac = function LepiSideMenuItemChild_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSideMenuItemChild)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSideMenuItemChild,
        selectors: [["lepi-side-menu-item-child"]],
        inputs: {
          routerLinkActive: "routerLinkActive",
          active: [2, "active", "active", booleanAttribute]
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 1,
        consts: [[1, "flex"], [1, "px-7"], [1, "rounded-md", "px-3", "py-1.5", "text-sm", "w-full", "cursor-pointer", "transition-all", "text-gray-400", 3, "ngClass"]],
        template: function LepiSideMenuItemChild_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵprojection(3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", ctx.active ? "bg-primary-50 hover:bg-primary-100 text-primary-400" : "hover:bg-gray-100 text-gray-400 hover:text-gray-700");
          }
        },
        dependencies: [CommonModule, i1.NgClass, RouterModule]
      });
    }
  }
  return LepiSideMenuItemChild;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSideMenuItemGroup = /*#__PURE__*/(() => {
  class LepiSideMenuItemGroup {
    constructor() {
      this.isOpen = false;
      this.routerLink = '';
      this.icon = '';
      this.label = '';
      this.active = false;
    }
    ngOnChanges() {
      this.isOpen = this.active;
    }
    ngAfterContentInit() {
      setTimeout(() => {
        if (this.children && this.children.length > 0) {
          this.children.map(child => {
            if (child.active) {
              this.isOpen = true;
            }
          });
        }
      }, 50);
    }
    static {
      this.ɵfac = function LepiSideMenuItemGroup_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSideMenuItemGroup)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSideMenuItemGroup,
        selectors: [["lepi-side-menu-item-group"]],
        contentQueries: function LepiSideMenuItemGroup_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, LepiSideMenuItemChild, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.children = _t);
          }
        },
        inputs: {
          routerLinkActive: "routerLinkActive",
          routerLink: "routerLink",
          icon: "icon",
          label: "label",
          active: [2, "active", "active", booleanAttribute]
        },
        standalone: true,
        features: [i0.ɵɵInputTransformsFeature, i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 8,
        vars: 9,
        consts: [[1, "flex", "flex-col", "gap-1"], [1, "flex", "items-center", "justify-between", "px-3", "py-1.5", "text-sm", "transition-all", "rounded-md", "cursor-pointer", "select-none", "group", 3, "click", "routerLinkActive", "ngClass"], [1, "flex", "items-center", "gap-3"], [1, "w-6", "h-6", "transition-all", 3, "name", "ngClass"], [1, "flex", "flex-col"], ["name", "mdi:chevron-down", 1, "w-5", "h-5", "bg-gray-400", 3, "ngClass"], ["class", "relative flex flex-col gap-1", 4, "ngIf"], [1, "relative", "flex", "flex-col", "gap-1"], [1, "absolute", "w-px", "h-full", "bg-gray-200", "left-7"]],
        template: function LepiSideMenuItemGroup_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function LepiSideMenuItemGroup_Template_div_click_1_listener() {
              return ctx.isOpen = !ctx.isOpen;
            });
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "lepi-icon", 3);
            i0.ɵɵelementStart(4, "div", 4);
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelement(6, "lepi-icon", 5);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, LepiSideMenuItemGroup_div_7_Template, 3, 0, "div", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance();
            i0.ɵɵproperty("routerLinkActive", (tmp_0_0 = ctx.routerLinkActive) !== null && tmp_0_0 !== undefined ? tmp_0_0 : "")("ngClass", ctx.isOpen ? "bg-primary-50 hover:bg-primary-100 text-primary-400" : "hover:bg-gray-100 active:bg-gray-200 text-gray-400 hover:text-gray-700");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("name", ctx.icon)("ngClass", ctx.isOpen ? "bg-primary" : "bg-gray-400 group-hover:bg-gray-700");
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", ctx.label, " ");
            i0.ɵɵadvance();
            i0.ɵɵclassProp("rotate-180", ctx.isOpen);
            i0.ɵɵproperty("ngClass", ctx.isOpen ? "bg-primary" : "bg-gray-400 group-hover:bg-gray-700");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isOpen);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, RouterModule, i2$1.RouterLinkActive, LepiIcon]
      });
    }
  }
  return LepiSideMenuItemGroup;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiAdminLayout = /*#__PURE__*/(() => {
  class LepiAdminLayout {
    constructor() {
      this.contentScroll = new EventEmitter();
    }
    onScroll(ev) {
      const scrollTop = ev.target.scrollTop;
      if (scrollTop > 0) {
        this.contentScroll.emit(true);
      } else {
        this.contentScroll.emit(false);
      }
    }
    static {
      this.ɵfac = function LepiAdminLayout_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiAdminLayout)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiAdminLayout,
        selectors: [["lepi-admin-layout"]],
        outputs: {
          contentScroll: "contentScroll"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c30,
        decls: 7,
        vars: 0,
        consts: [[1, "relative", "flex", "w-full", "h-screen"], [1, "flex", "flex-col", "w-full", "h-full"], ["id", "layout-content", 1, "w-full", "h-full", "p-6", "overflow-auto", 3, "scroll"]],
        template: function LepiAdminLayout_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c29);
            i0.ɵɵelementStart(0, "section", 0)(1, "div");
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 1);
            i0.ɵɵprojection(4, 1);
            i0.ɵɵelementStart(5, "div", 2);
            i0.ɵɵlistener("scroll", function LepiAdminLayout_Template_div_scroll_5_listener($event) {
              return ctx.onScroll($event);
            });
            i0.ɵɵprojection(6, 2);
            i0.ɵɵelementEnd()()();
          }
        },
        dependencies: [CommonModule]
      });
    }
  }
  return LepiAdminLayout;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
let LepiPageSelect = /*#__PURE__*/(() => {
  class LepiPageSelect {
    constructor(injector) {
      this.injector = injector;
      this.selected = new EventEmitter();
      this.ngControl = null;
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    pages() {
      let pages = [];
      if (this.pageInfo) {
        if (this.pageInfo.totalPages <= 5) {
          for (let i = 1; i <= this.pageInfo.totalPages; i++) {
            pages.push(i);
          }
        } else if (this.pageInfo.currentPage > this.pageInfo.totalPages - 3) {
          pages = [];
          for (let i = this.pageInfo.totalPages - 4; i <= this.pageInfo.totalPages; i++) {
            pages.push(i);
          }
        } else if (this.pageInfo.currentPage >= 3) {
          pages = [];
          for (let i = this.pageInfo.currentPage - 2; i <= this.pageInfo.currentPage + 2; i++) {
            pages.push(i);
          }
        } else if (this.pageInfo.currentPage < 3) {
          pages = [1, 2, 3, 4, 5];
        }
      }
      return pages;
    }
    ngOnInit() {
      this.writeValue;
    }
    writeValue(obj) {
      this.value = obj;
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {}
    setPage(i) {
      if (i >= 1 && i <= this.pageInfo.totalPages) {
        this.selected.emit(i);
        this.writeValue(i);
        this.onChange(i);
      }
    }
    static {
      this.ɵfac = function LepiPageSelect_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiPageSelect)(i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiPageSelect,
        selectors: [["lepi-page-select"]],
        inputs: {
          pageInfo: "pageInfo"
        },
        outputs: {
          selected: "selected"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiPageSelect,
          multi: true
        }]), i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [["class", "relative flex gap-2 text-sm", 4, "ngIf"], [1, "relative", "flex", "gap-2", "text-sm"], ["class", "flex h-8 w-8 cursor-pointer select-none items-center justify-center gap-2.5 rounded px-2 py-1 text-gray-600 hover:transition-colors hover:bg-gray-100 hover:text-white", 3, "click", 4, "ngIf"], ["class", "flex h-8 w-8 cursor-pointer select-none items-center justify-center gap-2.5 rounded px-2 py-1 hover:transition-colors", 3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["class", "flex h-8 w-8 rotate-180 cursor-pointer select-none items-center justify-center gap-2.5 rounded px-2 py-1 text-gray-600 hover:transition-colors hover:bg-gray-100 hover:text-white", 3, "click", 4, "ngIf"], [1, "flex", "h-8", "w-8", "cursor-pointer", "select-none", "items-center", "justify-center", "gap-2.5", "rounded", "px-2", "py-1", "text-gray-600", "hover:transition-colors", "hover:bg-gray-100", "hover:text-white", 3, "click"], ["name", "mdi:chevron-double-left", 1, "w-4", "h-4", "bg-gray-700"], ["name", "mdi:chevron-left", 1, "w-4", "h-4", "bg-gray-700"], [1, "flex", "h-8", "w-8", "cursor-pointer", "select-none", "items-center", "justify-center", "gap-2.5", "rounded", "px-2", "py-1", "hover:transition-colors", 3, "click", "ngClass"], [1, "flex", "h-8", "w-8", "rotate-180", "cursor-pointer", "select-none", "items-center", "justify-center", "gap-2.5", "rounded", "px-2", "py-1", "text-gray-600", "hover:transition-colors", "hover:bg-gray-100", "hover:text-white", 3, "click"]],
        template: function LepiPageSelect_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LepiPageSelect_div_0_Template, 6, 5, "div", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.pageInfo);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, LepiIcon]
      });
    }
  }
  return LepiPageSelect;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiSkeleton = /*#__PURE__*/(() => {
  class LepiSkeleton {
    constructor() {
      this.style = {
        width: '100%',
        height: '100%'
      };
    }
    static {
      this.ɵfac = function LepiSkeleton_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiSkeleton)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiSkeleton,
        selectors: [["lepi-skeleton"]],
        hostVars: 2,
        hostBindings: function LepiSkeleton_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
          }
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 0,
        consts: [[1, "flex", "items-center", "justify-center", "w-full", "h-full", "transition-all", "duration-300", "bg-neutral-300", "aspect-square", "animate-pulse"]],
        template: function LepiSkeleton_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "div", 0);
          }
        },
        dependencies: [CommonModule]
      });
    }
  }
  return LepiSkeleton;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @angular-eslint/no-output-native */
let LepiImage = /*#__PURE__*/(() => {
  class LepiImage {
    constructor() {
      this.loaded = new EventEmitter();
      this.errored = new EventEmitter();
      this.isImageLoaded = signal(null);
      this.style = {
        display: 'block',
        overflow: 'hidden'
      };
      this.isMinimumLoadingDone = signal(false);
      effect(() => {
        this.isImageLoaded() && this.isMinimumLoadingDone() ? this.loaded.emit() : this.errored.emit();
      });
    }
    ngAfterViewInit() {
      if (this.image) {
        this.image.nativeElement.onload = () => {
          this.isImageLoaded.set(true);
        };
        this.image.nativeElement.onerror = () => {
          this.isImageLoaded.set(false);
        };
      }
    }
    static {
      this.ɵfac = function LepiImage_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiImage)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiImage,
        selectors: [["lepi-image"]],
        viewQuery: function LepiImage_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c31, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.image = _t.first);
          }
        },
        hostVars: 2,
        hostBindings: function LepiImage_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵstyleMap(ctx.style);
          }
        },
        inputs: {
          src: "src",
          alt: "alt",
          imageClass: "imageClass"
        },
        outputs: {
          loaded: "loaded",
          errored: "errored"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 6,
        vars: 2,
        consts: [["image", ""], [3, "src"], [1, "object-cover", "w-full", "h-full", 3, "src", "alt", "ngClass"]],
        template: function LepiImage_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, LepiImage_Defer_0_Template, 1, 3)(1, LepiImage_DeferLoading_1_Template, 1, 0)(2, LepiImage_DeferPlaceholder_2_Template, 1, 0);
            i0.ɵɵdefer(3, 0, LepiImage_Defer_3_DepsFn, 1, 2);
            i0.ɵɵtemplate(5, LepiImage_Conditional_5_Template, 2, 1, "img", 1);
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵdeferWhen(ctx.isImageLoaded());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(!ctx.isImageLoaded() ? 5 : -1);
          }
        },
        dependencies: [CommonModule, LepiSkeleton]
      });
    }
  }
  return LepiImage;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-empty-function */
let LepiToggle = /*#__PURE__*/(() => {
  class LepiToggle {
    constructor(injector) {
      this.injector = injector;
      this.disabled = false;
      this._value = signal(false);
      this.value = false;
      this.onChange = ev => {};
      this.onTouched = () => {};
      this.registerOnTouched = () => {};
    }
    ngAfterViewInit() {
      const ngControl = this.injector.get(NgControl, null);
      if (ngControl) {
        this.control = ngControl.control;
      }
    }
    writeValue(obj) {
      this.value = obj;
      this._value.set(obj);
    }
    handleChange(ev) {
      ev.stopPropagation();
      this.value = ev.target.checked;
      this._value.set(this.value);
      this.onChange(this.value);
      this.onTouched();
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    setDisabledState(disabled) {
      this.disabled = disabled;
    }
    static {
      this.ɵfac = function LepiToggle_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiToggle)(i0.ɵɵdirectiveInject(i0.Injector));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiToggle,
        selectors: [["lepi-toggle"]],
        inputs: {
          disabled: [2, "disabled", "disabled", booleanAttribute],
          iconName: "iconName",
          iconClass: "iconClass"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiToggle,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 5,
        consts: [[1, "relative", "flex", "items-center", "w-16", "p-0.5", "cursor-pointer", "rounded-3xl", "border", "transition-all", 3, "ngClass"], ["type", "checkbox", 1, "hidden", 3, "change", "ngModel", "disabled"], [1, "z-0", "transition-all", "rounded-full", "w-7", "h-7", 3, "ngClass"], ["class", "z-10 w-3 h-3 bg-white", 3, "name", "class", 4, "ngIf"], [1, "z-10", "w-3", "h-3", "bg-white", 3, "name"]],
        template: function LepiToggle_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "label", 0)(1, "input", 1);
            i0.ɵɵlistener("change", function LepiToggle_Template_input_change_1_listener($event) {
              return ctx.handleChange($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtemplate(3, LepiToggle_lepi_icon_3_Template, 1, 3, "lepi-icon", 3);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", ctx.value ? "bg-primary-100 border-primary-300" : "bg-gray-100 border-gray-300");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngModel", ctx.value)("disabled", ctx.disabled);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.value ? "scale-100 translate-x-full bg-primary" : "translate-x-0 scale-95 bg-gray-400");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.iconName && ctx.value);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgIf, FormsModule, i2.CheckboxControlValueAccessor, i2.NgControlStatus, i2.NgModel, ReactiveFormsModule, LepiIcon]
      });
    }
  }
  return LepiToggle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiAccordion = /*#__PURE__*/(() => {
  class LepiAccordion {
    constructor() {
      this.header = '';
      this.default = 'open';
      this.id = '';
      this.headerTextClass = '';
      this.isOpen = signal(false);
    }
    ngOnInit() {
      if (this.default === 'open') {
        this.isOpen.set(true);
      } else {
        this.isOpen.set(false);
      }
    }
    toggle() {
      this.isOpen.set(!this.isOpen());
    }
    slotClick(ev) {
      ev.stopPropagation();
    }
    static {
      this.ɵfac = function LepiAccordion_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiAccordion)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiAccordion,
        selectors: [["lepi-accordion"]],
        contentQueries: function LepiAccordion_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, _c32, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.headerContent = _t.first);
          }
        },
        inputs: {
          header: "header",
          default: "default",
          id: "id",
          headerTextClass: "headerTextClass",
          hints: "hints"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c34,
        decls: 15,
        vars: 5,
        consts: [[1, "flex", "flex-col", "w-full", "border", "border-gray-200", "rounded-md"], [1, "flex", "items-center", "justify-between", "w-full", "px-5", "py-3.5", "cursor-pointer", 3, "click"], [1, "flex", "items-center", "w-full", "gap-2"], [1, "flex", "items-center", "gap-3", "min-w-max"], [1, "text-xl", "font-semibold", "text-gray-700", 3, "ngClass"], ["name", "ic:round-keyboard-arrow-up", 1, "w-6", "h-6", "bg-gray-700"], ["name", "ic:round-keyboard-arrow-down", 1, "w-6", "h-6", "bg-gray-700"], [1, "w-full", "cursor-default", 3, "click"], [1, "flex", "items-center", "gap-2", "cursor-default", "min-w-max", 3, "click"], [1, "flex", "flex-col", "gap-6", "px-5", "py-3.5", "pt-0"], [1, "w-full", "h-px", "bg-gray-200"]],
        template: function LepiAccordion_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c33);
            i0.ɵɵelementStart(0, "article", 0)(1, "div", 1);
            i0.ɵɵlistener("click", function LepiAccordion_Template_div_click_1_listener() {
              return ctx.toggle();
            });
            i0.ɵɵelementStart(2, "div", 2)(3, "div")(4, "div", 3)(5, "p", 4);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, LepiAccordion_Conditional_7_Template, 1, 0, "lepi-icon", 5)(8, LepiAccordion_Conditional_8_Template, 1, 0, "lepi-icon", 6);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(9, LepiAccordion_Conditional_9_Template, 2, 0);
            i0.ɵɵelementStart(10, "div", 7);
            i0.ɵɵlistener("click", function LepiAccordion_Template_div_click_10_listener($event) {
              return ctx.slotClick($event);
            });
            i0.ɵɵprojection(11);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(12, "div", 8);
            i0.ɵɵlistener("click", function LepiAccordion_Template_div_click_12_listener($event) {
              return ctx.slotClick($event);
            });
            i0.ɵɵprojection(13, 1);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(14, LepiAccordion_Conditional_14_Template, 3, 0, "div", 9);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(5);
            i0.ɵɵproperty("ngClass", ctx.headerTextClass);
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", ctx.header, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isOpen() ? 7 : 8);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.hints && ctx.hints.length > 0 ? 9 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵconditional(ctx.isOpen() ? 14 : -1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, LepiIcon, LepiHint]
      });
    }
  }
  return LepiAccordion;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogDirective = /*#__PURE__*/(() => {
  class DialogDirective {
    constructor(viewContainerRef, elementRef) {
      this.viewContainerRef = viewContainerRef;
      this.elementRef = elementRef;
      this.class = '';
    }
    static {
      this.ɵfac = function DialogDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DialogDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: DialogDirective,
        selectors: [["", "dialog", ""]],
        inputs: {
          class: "class"
        },
        standalone: true
      });
    }
  }
  return DialogDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalComponent = /*#__PURE__*/(() => {
  class ModalComponent extends BaseComponent {
    constructor(data) {
      super();
      this.data = data;
      this.dialogConfig = computed(() => this.config()?.dialog);
      this.currentRounded = computed(() => `rounded-${this.dialogConfig()?.rounded}` ?? 'rounded');
      this.currentShadow = computed(() => `shadow-${this.dialogConfig()?.shadow}` ?? 'shadow');
      this.hasBackdrop = signal(true);
    }
    ngOnInit() {
      if (this.dialogDirective) {
        const viewContainerRef = this.dialogDirective.viewContainerRef;
        const componentRef = viewContainerRef.createComponent(this.data.component);
        if (this.data.componentProps) {
          Object.entries(this.data.componentProps).map(([key, value]) => {
            componentRef.setInput(key, value);
          });
        }
      }
      if (this.data.hasBackdrop === false) {
        this.hasBackdrop.set(false);
      }
    }
    static {
      this.ɵfac = function ModalComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalComponent)(i0.ɵɵdirectiveInject(DIALOG_DATA));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModalComponent,
        selectors: [["lepi-modal"]],
        viewQuery: function ModalComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(DialogDirective, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogDirective = _t.first);
          }
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 8,
        consts: [[1, "z-[9999]", "fixed", "flex", "items-center", "justify-center", "inset-0", "w-full", "h-full", 3, "ngClass"], [1, "bg-white", "select-none", 3, "ngClass"], ["dialog", "", 1, "rounded-full"]],
        template: function ModalComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "article", 1);
            i0.ɵɵtemplate(2, ModalComponent_ng_template_2_Template, 0, 0, "ng-template", 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("@fadeInOut", undefined)("ngClass", i0.ɵɵpureFunction1(3, _c35, ctx.hasBackdrop()));
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c10, ctx.currentRounded(), ctx.currentShadow()));
          }
        },
        dependencies: [CommonModule, i1.NgClass, DialogDirective, DialogModule],
        data: {
          animation: [FADE_IN_OUT(200)]
        }
      });
    }
  }
  return ModalComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DialogService = /*#__PURE__*/(() => {
  class DialogService {
    constructor(dialog) {
      this.dialog = dialog;
      this.id = signal(0);
      this.ids = signal([]);
    }
    /**
     * 다이얼로그를 생성 후 반환합니다.
     * ID는 자동으로 생성되며 생성 후 ID값을 저장합니다.
     *
     * @param data
     */
    create(component, data) {
      this.id.set(this.id() + 1);
      this.modal = this.dialog.open(component, {
        data,
        id: `modal-${this.id()}`
      });
      this.ids().push(this.modal.id);
      return this.modal;
    }
    /**
     * 제일 위 레이어의 다이얼로그를를 닫습니다.
     */
    dismiss(data, role) {
      const top = this.getTop();
      const result = {
        data: undefined,
        role: undefined
      };
      if (data) result.data = data;
      if (role) result.role = role;
      if (top) top.close(result);
      this.ids().pop();
    }
    /**
     * 제일 위 레이어의 다이얼로그를 반환합니다.
     */
    getTop() {
      const dialogs = document.querySelectorAll('cdk-dialog-container');
      const topId = dialogs.item(dialogs.length - 1)?.id;
      if (topId) {
        const top = this.dialog.getDialogById(topId);
        return top;
      }
      return null;
    }
    static {
      this.ɵfac = function DialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DialogService)(i0.ɵɵinject(i1$1.Dialog));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DialogService,
        factory: DialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModalService = /*#__PURE__*/(() => {
  class ModalService {
    constructor(dialogService) {
      this.dialogService = dialogService;
    }
    create(props) {
      return this.dialogService.create(ModalComponent, props);
    }
    dismiss(data, role) {
      this.dialogService.dismiss(data, role);
    }
    getTop() {
      return this.dialogService.getTop();
    }
    static {
      this.ɵfac = function ModalService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ModalService)(i0.ɵɵinject(DialogService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModalService,
        factory: ModalService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ModalService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertComponent = /*#__PURE__*/(() => {
  class AlertComponent extends BaseComponent {
    constructor(modalService) {
      super();
      this.modalService = modalService;
      this.icon = '';
      this.iconClass = '';
      this.title = '';
      this.content = '';
      this.buttons = [];
      this.dialogConfig = computed(() => this.config()?.dialog);
      this.currentRounded = computed(() => `rounded-${this.dialogConfig()?.rounded}` ?? 'rounded');
      this.currentShadow = computed(() => `shadow-${this.dialogConfig()?.shadow}` ?? 'shadow');
    }
    ngOnInit() {
      if (this.autoDismissTime) {
        setTimeout(() => {
          this.modalService.dismiss();
        }, this.autoDismissTime);
      }
    }
    headerIcon(icon) {
      if (icon !== 'success' && icon !== 'danger') {
        return icon;
      } else if (icon === 'success') {
        return 'mdi:check-circle';
      } else if (icon === 'danger') {
        return 'mdi:alert-outline';
      }
      return '';
    }
    dismiss(button) {
      if (button.handler) {
        button.handler();
      }
      this.modalService.dismiss();
    }
    static {
      this.ɵfac = function AlertComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertComponent)(i0.ɵɵdirectiveInject(ModalService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AlertComponent,
        selectors: [["lepi-alert"]],
        inputs: {
          icon: "icon",
          iconClass: "iconClass",
          title: "title",
          content: "content",
          buttons: "buttons",
          autoDismissTime: "autoDismissTime"
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 11,
        vars: 8,
        consts: [[1, "flex", "flex-col", "w-full", "select-none", "md:min-w-[31.25rem]", "overflow-hidden", 3, "ngClass"], [1, "flex", "items-center", "gap-2", "px-4", "py-3", "border-b", "border-gray-200"], ["class", "w-6 h-6", 3, "class", "bg-danger", "bg-success", "name", 4, "ngIf"], [1, "font-semibold", "text-gray-700"], [1, "flex", "flex-col", "p-4", "gap-2.5"], [1, "text-sm", "text-gray-700", "whitespace-pre-line"], [1, "flex", "justify-end", "w-full", "px-4", "py-3", "bg-gray-50"], [1, "flex", "items-center", "gap-2"], [4, "ngFor", "ngForOf"], [1, "w-6", "h-6", 3, "name"], [3, "click", "color", "variant"]],
        template: function AlertComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, AlertComponent_lepi_icon_2_Template, 1, 7, "lepi-icon", 2);
            i0.ɵɵelementStart(3, "p", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 4)(6, "p", 5);
            i0.ɵɵtext(7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 6)(9, "div", 7);
            i0.ɵɵtemplate(10, AlertComponent_ng_container_10_Template, 3, 3, "ng-container", 8);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c10, ctx.currentRounded(), ctx.currentShadow()));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.icon);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", ctx.content, " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngForOf", ctx.buttons);
          }
        },
        dependencies: [CommonModule, i1.NgClass, i1.NgForOf, i1.NgIf, LepiButton, LepiIcon]
      });
    }
  }
  return AlertComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AlertService = /*#__PURE__*/(() => {
  class AlertService {
    constructor(modalService) {
      this.modalService = modalService;
    }
    show(props) {
      const alert = this.modalService.create({
        component: AlertComponent,
        componentProps: {
          ...props
        }
      });
      return alert;
    }
    static {
      this.ɵfac = function AlertService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || AlertService)(i0.ɵɵinject(ModalService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: AlertService,
        factory: AlertService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return AlertService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideDialogComponent = /*#__PURE__*/(() => {
  class SideDialogComponent extends BaseComponent {
    constructor(data, dialogRef) {
      super();
      this.data = data;
      this.dialogRef = dialogRef;
      this.dialogConfig = computed(() => this.config()?.dialog);
      this.animation = computed(() => this.dialogConfig()?.animation ?? 'slide');
      this.currentRounded = computed(() => `rounded-tl-${this.dialogConfig()?.rounded} rounded-bl-${this.dialogConfig()?.rounded}` ?? 'rounded-tl rounded-bl');
    }
    ngAfterViewInit() {
      if (this.dialogDirectives?.length > 0) {
        this.dialogDirectives.map(dialogDirective => {
          const viewContainerRef = dialogDirective.viewContainerRef;
          const componentRef = viewContainerRef.createComponent(this.data.component);
          if (this.data.componentProps) {
            Object.entries(this.data.componentProps).map(([key, value]) => {
              componentRef.setInput(key, value);
            });
          }
        });
      }
    }
    static {
      this.ɵfac = function SideDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SideDialogComponent)(i0.ɵɵdirectiveInject(DIALOG_DATA), i0.ɵɵdirectiveInject(i1$1.DialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SideDialogComponent,
        selectors: [["lepi-side-dialog"]],
        viewQuery: function SideDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(DialogDirective, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dialogDirectives = _t);
          }
        },
        standalone: true,
        features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "fixed", "top-0", "right-0", "h-full", "overflow-hidden", "bg-white", "rounded-tl", "rounded-bl", "select-none", "min-w-fit", 3, "ngClass"], ["dialog", ""]],
        template: function SideDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, SideDialogComponent_Conditional_0_Template, 2, 2, "article", 0)(1, SideDialogComponent_Conditional_1_Template, 2, 2, "article", 0);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.animation() === "slide" ? 0 : 1);
          }
        },
        dependencies: [CommonModule, i1.NgClass, DialogDirective],
        data: {
          animation: [SLIDE_LEFT_IN(), FADE_IN()]
        }
      });
    }
  }
  return SideDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SideDialogService = /*#__PURE__*/(() => {
  class SideDialogService {
    constructor(dialogService) {
      this.dialogService = dialogService;
    }
    create(props) {
      return this.dialogService.create(SideDialogComponent, props);
    }
    dismiss(data, role) {
      this.dialogService.dismiss(data, role);
    }
    getTop() {
      return this.dialogService.getTop();
    }
    static {
      this.ɵfac = function SideDialogService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SideDialogService)(i0.ɵɵinject(DialogService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SideDialogService,
        factory: SideDialogService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SideDialogService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiModalHeaderComponent = /*#__PURE__*/(() => {
  class LepiModalHeaderComponent {
    constructor() {
      this.icon = '';
      this.iconClass = 'w-6 h-6 bg-neutral-700';
      this.dismiss = new EventEmitter();
    }
    static {
      this.ɵfac = function LepiModalHeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiModalHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiModalHeaderComponent,
        selectors: [["lepi-modal-header"]],
        inputs: {
          icon: "icon",
          iconClass: "iconClass"
        },
        outputs: {
          dismiss: "dismiss"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 6,
        vars: 1,
        consts: [[1, "flex", "px-4", "py-3", "w-full", "items-center", "justify-between", "border-b", "border-neutral-200", "rounded-t"], [1, "flex", "gap-2", "items-center"], [3, "class", "name"], [1, "font-semibold", "text-neutral-700"], ["name", "mdi:close", 1, "w-6", "h-6", "cursor-pointer", "bg-neutral-700", 3, "click"], [3, "name"]],
        template: function LepiModalHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "article", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, LepiModalHeaderComponent_Conditional_2_Template, 1, 3, "lepi-icon", 2);
            i0.ɵɵelementStart(3, "p", 3);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "lepi-icon", 4);
            i0.ɵɵlistener("click", function LepiModalHeaderComponent_Template_lepi_icon_click_5_listener() {
              return ctx.dismiss.emit();
            });
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(ctx.icon ? 2 : -1);
          }
        },
        dependencies: [CommonModule, LepiIcon]
      });
    }
  }
  return LepiModalHeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiModalFooterComponent = /*#__PURE__*/(() => {
  class LepiModalFooterComponent {
    static {
      this.ɵfac = function LepiModalFooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiModalFooterComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiModalFooterComponent,
        selectors: [["lepi-modal-footer"]],
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 2,
        vars: 0,
        consts: [[1, "flex", "bg-neutral-50", "px-4", "py-3", "rounded-b"]],
        template: function LepiModalFooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "article", 0);
            i0.ɵɵprojection(1);
            i0.ɵɵelementEnd();
          }
        },
        dependencies: [CommonModule]
      });
    }
  }
  return LepiModalFooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-unused-vars */
let LepiDataGrid = /*#__PURE__*/(() => {
  class LepiDataGrid {
    constructor() {
      this.itemDrop = new EventEmitter();
      this.checked = new EventEmitter();
      this.id = input('');
      this.columns = input([]);
      this.rowData = input([]);
      this.option = input();
      this.isGroup = signal(false);
      this.visible = signal(true);
      this.defaultColumn = signal(undefined);
    }
    ngOnInit() {
      this.isGroup.set(this.option()?.group?.enable ?? false);
      if (this.option()?.group?.groupBy) {
        const column = this.columns().find(col => col.field === this.option()?.group?.groupBy);
        this.defaultColumn.set(column);
      } else {
        const filterArray = this.option()?.group?.columnFilter ?? [];
        const column = this.columns().filter(col => !filterArray.includes(col.field));
        this.defaultColumn.set(column[0]);
      }
    }
    handleGroup(col) {
      this.isGroup.set(true);
      this.defaultColumn.set(col);
      this.reload();
    }
    handleDisableGroup() {
      this.isGroup.set(false);
      this.reload();
    }
    reload() {
      this.visible.set(false);
      setTimeout(() => {
        this.visible.set(true);
      }, 1000);
    }
    static {
      this.ɵfac = function LepiDataGrid_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiDataGrid)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiDataGrid,
        selectors: [["lepi-data-grid"]],
        hostAttrs: ["ngSkipHydration", "true"],
        inputs: {
          id: [1, "id"],
          columns: [1, "columns"],
          rowData: [1, "rowData"],
          option: [1, "option"]
        },
        outputs: {
          itemDrop: "itemDrop",
          checked: "checked"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c37,
        decls: 6,
        vars: 1,
        consts: [["loading", ""], [1, "flex", "flex-col", "w-full", "h-full", "gap-6"], [1, "flex", "items-center", "justify-center", "w-full", "h-full", "p-4"], [3, "enableGroup", "id", "columns", "rowData", "option"], [3, "defaultColumn", "id", "columns", "rowData", "option"], [3, "checked", "selectCurrentColumn", "itemDrop", "enableGroup", "id", "columns", "rowData", "option"], [3, "selectCurrentColumn", "disableGroup", "defaultColumn", "id", "columns", "rowData", "option"], [4, "ngTemplateOutlet"], ["name", "line-md:loading-twotone-loop", 1, "size-10", "bg-primary"]],
        template: function LepiDataGrid_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c36);
            i0.ɵɵtemplate(0, LepiDataGrid_Defer_0_Template, 2, 1)(1, LepiDataGrid_DeferPlaceholder_1_Template, 2, 1);
            i0.ɵɵdefer(2, 0, LepiDataGrid_Defer_2_DepsFn, null, 1);
            i0.ɵɵtemplate(4, LepiDataGrid_ng_template_4_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵdeferWhen(ctx.rowData());
          }
        },
        dependencies: [CommonModule, i1.NgTemplateOutlet, LepiIcon],
        styles: [".cell[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:1rem .5rem;text-align:left;font-size:.875rem;line-height:1.25rem}.cell-header[_ngcontent-%COMP%]{padding:1rem .5rem;text-align:left;font-size:.875rem;line-height:1.25rem}"]
      });
    }
  }
  return LepiDataGrid;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiFileDownload = /*#__PURE__*/(() => {
  class LepiFileDownload {
    constructor() {
      this.name = input('');
      this.url = input('');
    }
    handleDownload() {
      if (!this.url()) return;
      this.downloadFile(this.url(), this.name());
    }
    async downloadFile(url, name) {
      const res = await fetch(url);
      const blob = await res.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = name;
      a.target = '_blank';
      a.click();
    }
    static {
      this.ɵfac = function LepiFileDownload_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiFileDownload)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiFileDownload,
        selectors: [["app-file-download"]],
        inputs: {
          name: [1, "name"],
          url: [1, "url"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 1,
        consts: [[1, "overflow-hidden", "bg-white", "rounded-md"], ["variant", "outline", "icon", "material-symbols:download-2", 3, "click"], [1, "truncate", "max-w-[15rem]"]],
        template: function LepiFileDownload_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "lepi-button", 1);
            i0.ɵɵlistener("click", function LepiFileDownload_Template_lepi_button_click_1_listener() {
              return ctx.handleDownload();
            });
            i0.ɵɵelementStart(2, "p", 2);
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(ctx.name());
          }
        },
        dependencies: [CommonModule, LepiButton]
      });
    }
  }
  return LepiFileDownload;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiGridFileDownload = /*#__PURE__*/(() => {
  class LepiGridFileDownload {
    constructor() {
      this.column = input();
      this.row = input();
      this.value = computed(() => this.row()[this.column().field]);
      this.isArray = computed(() => Array.isArray(this.value()));
    }
    static {
      this.ɵfac = function LepiGridFileDownload_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiGridFileDownload)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiGridFileDownload,
        selectors: [["lepi-grid-file-download"]],
        inputs: {
          column: [1, "column"],
          row: [1, "row"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 3,
        vars: 1,
        consts: [[1, "flex", "flex-col", "gap-1"], [3, "url", "name"]],
        template: function LepiGridFileDownload_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, LepiGridFileDownload_Conditional_1_Template, 2, 0)(2, LepiGridFileDownload_Conditional_2_Template, 1, 2, "app-file-download", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.isArray() ? 1 : 2);
          }
        },
        dependencies: [LepiFileDownload],
        encapsulation: 2
      });
    }
  }
  return LepiGridFileDownload;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const get = (obj, path, defaultValue = undefined) => {
  const travel = regexp => String.prototype.split.call(path, regexp).filter(Boolean).reduce((res, key) => res !== null && res !== undefined ? res[key] : res, obj);
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
  return result === undefined || result === obj ? defaultValue : result;
};
let LepiGridImage = /*#__PURE__*/(() => {
  class LepiGridImage {
    constructor() {
      this.row = input();
      this.column = input();
      this.image = computed(() => get(this.row(), this.column().field));
    }
    handleClick(ev) {
      ev.preventDefault();
      ev.stopPropagation();
      const a = document.createElement('a');
      a.href = this.image();
      a.target = '_blank';
      a.click();
    }
    static {
      this.ɵfac = function LepiGridImage_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiGridImage)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiGridImage,
        selectors: [["lepi-grid-image"]],
        inputs: {
          row: [1, "row"],
          column: [1, "column"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 1,
        consts: [[1, "overflow-hidden", "transition-all", "bg-white", "rounded-md", "cursor-pointer", "aspect-video", "w-[10rem]", "hover:shadow-xl", 3, "click"], [1, "object-cover", "w-full", "h-full", "aspect-video", 3, "src"]],
        template: function LepiGridImage_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵlistener("click", function LepiGridImage_Template_div_click_0_listener($event) {
              return ctx.handleClick($event);
            });
            i0.ɵɵelement(1, "img", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵproperty("src", ctx.image(), i0.ɵɵsanitizeUrl);
          }
        },
        dependencies: [CommonModule]
      });
    }
  }
  return LepiGridImage;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiTextField = /*#__PURE__*/(() => {
  class LepiTextField {
    constructor() {
      this.label = input.required();
    }
    static {
      this.ɵfac = function LepiTextField_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiTextField)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiTextField,
        selectors: [["lepi-text-field"]],
        inputs: {
          label: [1, "label"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 5,
        vars: 1,
        consts: [[1, "flex", "flex-col", "gap-3"], [1, "font-semibold", "text-gray-800"], [1, "text-sm", "text-gray-500"]],
        template: function LepiTextField_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "p", 2);
            i0.ɵɵprojection(4);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.label());
          }
        },
        dependencies: [CommonModule]
      });
    }
  }
  return LepiTextField;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const CustomTableCell = Node.create({
  name: 'tableCell',
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: 'block+',
  addAttributes() {
    return {
      backgroundColor: {
        default: null,
        renderHTML: attributes => {
          if (!attributes['backgroundColor']) {
            return {};
          }
          return {
            style: `background-color: ${attributes['backgroundColor']}`
          };
        },
        parseHTML: element => element.style.backgroundColor.replace(/"/g, '')
      },
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: element => {
          const colwidth = element.getAttribute('colwidth');
          const value = colwidth ? [parseInt(colwidth, 10)] : null;
          return value;
        }
      }
    };
  },
  tableRole: 'cell',
  isolating: true,
  parseHTML() {
    return [{
      tag: 'td'
    }];
  },
  renderHTML({
    HTMLAttributes
  }) {
    return ['td', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  }
});
let LepiEditor = /*#__PURE__*/(() => {
  class LepiEditor {
    constructor(imageHandler) {
      this.imageHandler = imageHandler;
      this.format = 'html';
      this.image = true;
      this.disabled = false;
      this.viewer = false;
      this.minHeight = '300px';
      this.isCurrentNodeTable = signal(false);
      this.currentNodeTextSize = signal('h1');
      this.currentTextAlign = signal('left');
      this.currentTextAlignIcon = computed(() => `mdi:format-align-${this.currentTextAlign()}`);
      this.colors = ['#fff', '#d4d4d4', '#737373', '#3f3f46', '#0a0a0a', '#ef4444', '#f97316', '#f59e0b', '#eab308', '#84cc16', '#22c55e', '#10b981', '#14b8a6', '#06b6d4', '#0ea5e9', '#3b82f6', '#6366f1', '#8b5cf6', '#a855f7'];
      this.onChange = value => {};
      this.onTouched = () => {};
    }
    ngAfterViewInit() {
      this.initializeEditor();
    }
    handleCommand(command, event) {
      event.preventDefault();
      event.stopPropagation();
      command();
    }
    initializeEditor() {
      if (this.editor) return;
      this.editor = new Editor({
        element: this.editorRef.nativeElement,
        extensions: [StarterKit, Underline, Image.configure({
          allowBase64: false
        }), Color, TextStyle, TextAlign.configure({
          types: ['paragraph', 'heading']
        }), Highlight.configure({
          multicolor: true
        }), Table.configure({
          resizable: true
        }), TableRow, CustomTableCell, TableHeader, Link.configure({
          autolink: true,
          defaultProtocol: 'https'
        }), Youtube.configure({})],
        onTransaction: ({
          editor,
          transaction
        }) => {
          // check if image node was deleted
          this.handleImageDelete(transaction);
          this.detectTextSize(editor);
          this.detectTextAlign(editor);
        },
        onSelectionUpdate: ({
          editor
        }) => {
          this.detectTextSize(editor);
        },
        onUpdate: ({
          editor
        }) => {
          switch (this.format) {
            case 'html':
              this.onChange(editor.getHTML());
              break;
            case 'json':
              this.onChange(JSON.stringify(editor.getJSON()));
              break;
          }
        },
        onCreate: ({
          editor
        }) => {
          console.log;
          editor.view.dom.spellcheck = false;
          if (this.disabled) {
            editor.setEditable(false);
          }
        }
      });
    }
    selectImage(event) {
      event.stopPropagation();
      event.preventDefault();
      const a = document.createElement('input');
      a.type = 'file';
      a.accept = 'image/*';
      a.click();
      a.onchange = e => {
        const file = e.target.files[0];
        this.imageHandler.upload(file).then(({
          url
        }) => {
          this.editor.commands.setImage({
            src: url
          });
        });
      };
    }
    detectTextSize(editor) {
      const currentNode = editor.state.selection.$from.node();
      if (currentNode.type.name === 'paragraph') this.currentNodeTextSize.set('p');
      if (currentNode.type.name === 'heading') {
        switch (currentNode.attrs['level']) {
          case 1:
            this.currentNodeTextSize.set('h1');
            break;
          case 2:
            this.currentNodeTextSize.set('h2');
            break;
          case 3:
            this.currentNodeTextSize.set('h3');
            break;
        }
      }
    }
    detectTextAlign(editor) {
      const currentNode = editor.state.selection.$from.node();
      if (currentNode.attrs['textAlign']) {
        this.currentTextAlign.set(currentNode.attrs['textAlign']);
      } else {
        this.currentTextAlign.set('left');
      }
    }
    changeTextNode(size) {
      if (size === 'p') {
        this.editor.chain().focus().setParagraph().run();
        return;
      }
      this.editor.chain().focus().setHeading({
        level: parseInt(size[1])
      }).run();
    }
    handleImageDelete(transaction) {
      const current = [];
      transaction.doc.content.forEach(node => {
        if (node.type.name == 'image') {
          current.push(node);
        }
      });
      const before = [];
      transaction.before.content.forEach(node => {
        if (node.type.name == 'image') {
          before.push(node);
        }
      });
      if (!current || before.length == 0) {
        return;
      }
      const deletedImageNodes = before.filter(node => {
        const src = node.attrs['src'];
        return !current.find(curNode => curNode.attrs['src'] == src);
      });
      if (deletedImageNodes.length > 0) {
        deletedImageNodes.forEach(async node => {
          await this.imageHandler.delete(node.attrs['src']);
        });
      }
    }
    writeValue(content) {
      if (!this.editor) this.initializeEditor();
      if (this.format === 'html') {
        // check content is html
        const parser = new DOMParser();
        const doc = parser.parseFromString(content, 'text/html');
        if (doc.body.innerHTML !== '') {
          this.editor.commands.setContent(content);
        } else {
          console.error('Selected format is HTML but the content is not HTML.');
        }
        this.editor.commands.setContent(content);
      } else if (this.format === 'json') {
        try {
          const json = JSON.parse(content);
          this.editor.commands.setContent(json);
        } catch (error) {
          console.error('Selected format is JSON but the content is not JSON.');
        }
      }
    }
    addYoutube(src) {
      this.editor.commands.setYoutubeVideo({
        src
      });
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
      this.editor.setEditable(!isDisabled);
    }
    isYoutubeUrl(url) {
      function isHostYoutube(url) {
        return ['youtube.com', 'youtu.be'].some(host => url.includes(host));
      }
      function hasVideoId(url) {
        const videoId = url.split('v=')[1];
        return videoId;
      }
      return isHostYoutube(url) && hasVideoId(url);
    }
    getYouTubeVideoId(url) {
      const videoId = url.split('v=')[1];
      return videoId;
    }
    static {
      this.ɵfac = function LepiEditor_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiEditor)(i0.ɵɵdirectiveInject(LEPI_EDITOR_IMAGE_HANDLER));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiEditor,
        selectors: [["lepi-editor"]],
        viewQuery: function LepiEditor_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c38, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.editorRef = _t.first);
          }
        },
        inputs: {
          format: "format",
          image: [2, "image", "image", booleanAttribute],
          disabled: [2, "disabled", "disabled", booleanAttribute],
          viewer: [2, "viewer", "viewer", booleanAttribute],
          minHeight: [2, "minHeight", "minHeight", numberAttribute]
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: LepiEditor,
          multi: true
        }]), i0.ɵɵInputTransformsFeature, i0.ɵɵStandaloneFeature],
        decls: 14,
        vars: 9,
        consts: [["editorRef", ""], ["textColorMenu", ""], ["backgroundColorMenu", ""], ["cellBackgroundColorMenu", ""], ["textAlignMenu", ""], ["youtubeForm", ""], ["youtubeInputRef", ""], ["id", "lepi-editor", 1, "flex", "flex-col", "gap-1", "rounded-md"], ["id", "lepi-editor-toolbar", 1, "flex", "items-center", "gap-4", "px-4", "py-1", "border-b", "*:flex", "*:items-center", "*:gap-1"], [1, "h-full", "*:h-full", "*:outline-none", 3, "click"], [1, "buttons"], [3, "ngModelChange", "ngModel"], ["value", "h1"], ["value", "h2"], ["value", "h3"], ["value", "p"], ["lepiTooltip", "", "tooltipText", "\uAD75\uAC8C", 1, "toggleable", 3, "click"], ["name", "mdi:format-bold"], ["lepiTooltip", "", "tooltipText", "\uBC11\uC904", 1, "toggleable", 3, "click"], ["name", "mdi:format-underline"], ["lepiTooltip", "", "tooltipText", "\uC774\uD0E4\uB9AD\uCCB4", 1, "toggleable", 3, "click"], ["name", "mdi:format-italic"], ["lepiTooltip", "", "tooltipText", "\uAE00\uC790\uC0C9", 3, "cdkMenuTriggerFor"], ["name", "mdi:format-color-text", 1, "block", "size-5", 3, "ngStyle"], ["lepiTooltip", "", "tooltipText", "\uBC30\uACBD\uC0C9", 1, "toggleable", 3, "cdkMenuTriggerFor"], ["name", "mdi:format-color-highlight", 3, "ngStyle"], ["lepiTooltip", "", "tooltipText", "\uAE00\uBA38\uB9AC \uBAA9\uB85D", 3, "click"], ["name", "mdi:format-list-bulleted"], ["lepiTooltip", "", "tooltipText", "\uC21C\uC11C \uBAA9\uB85D", 3, "click"], ["name", "mdi:format-list-numbered"], ["lepiTooltip", "", "tooltipText", "\uBB38\uB2E8 \uC815\uB82C", 3, "cdkMenuTriggerFor"], [3, "name"], ["lepiTooltip", "", "tooltipText", "\uC774\uBBF8\uC9C0", 3, "click"], ["name", "mdi:file-image"], ["lepiTooltip", "", "tooltipText", "\uC720\uD29C\uBE0C", 3, "cdkMenuTriggerFor"], ["name", "mdi:youtube"], ["lepiTooltip", "", "tooltipText", "\uD45C \uC0BD\uC785", 3, "click", "disabled"], ["name", "mdi:table", 1, "block", "bg-neutral-900", "size-6"], ["lepiTooltip", "", "tooltipText", "\uD14C\uC774\uBE14 \uC0AD\uC81C", 3, "click"], ["name", "mdi:table-remove"], ["lepiTooltip", "", "tooltipText", "\uC624\uB978\uCABD\uC5D0 \uC0BD\uC785", 3, "click"], ["name", "mdi:table-column-plus-after"], ["lepiTooltip", "", "tooltipText", "\uC544\uB798\uC5D0 \uC0BD\uC785", 3, "click"], ["name", "mdi:table-row-plus-after"], ["lepiTooltip", "", "tooltipText", "\uC5F4 \uC0AD\uC81C", 3, "click"], ["name", "mdi:table-column-remove"], ["lepiTooltip", "", "tooltipText", "\uD589 \uC0AD\uC81C", 3, "click"], ["name", "mdi:table-row-remove"], ["lepiTooltip", "", "tooltipText", "\uC140 \uBC30\uACBD\uC0C9", 3, "cdkMenuTriggerFor"], ["name", "mdi:format-color-fill"], ["lepiTooltip", "", "tooltipText", "\uC140 \uBD84\uD560", 3, "click"], ["name", "mdi:table-split-cell"], ["lepiTooltip", "", "tooltipText", "\uC140 \uBCD1\uD569", 3, "click", "disabled"], ["name", "mdi:table-merge-cells"], ["cdkMenu", "", 1, "grid", "grid-flow-row", "grid-cols-5", "gap-1", "p-2", "bg-white", "rounded-md", "shadow-sm"], ["cdkMenuItem", "", 1, "border", "rounded-full", "size-6", "border-neutral-200", 3, "ngStyle"], ["cdkMenuItem", "", 1, "border", "rounded-full", "size-6", "border-neutral-200", 3, "click", "ngStyle"], ["cdkMenu", "", 1, "flex", "flex-col", "mt-1", "overflow-hidden", "rounded-md", "shadow-md", "bg-neutral-200"], ["cdkMenuItem", "", 1, "flex", "items-center", "justify-center", "p-1", "transition-colors", "border", "rounded-md", "border-neutral-400", "hover:bg-neutral-300", "text-neutral-100", 3, "click"], ["name", "mdi:format-align-left", 1, "block", "size-6", "bg-neutral-800"], ["name", "mdi:format-align-center", 1, "block", "size-6", "bg-neutral-800"], ["name", "mdi:format-align-right", 1, "block", "size-6", "bg-neutral-800"], ["cdkMenu", "", 1, "flex", "flex-col", "gap-2", "p-4", "bg-white", "shadow-xl"], [1, "text-sm", "font-bold"], ["label", "URL"], [3, "videoId"], ["cdkMenuItem", "", 1, "self-end", 3, "click", "disabled"]],
        template: function LepiEditor_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵelementStart(0, "div", 7);
            i0.ɵɵtemplate(1, LepiEditor_Conditional_1_Template, 38, 22, "section", 8);
            i0.ɵɵelementStart(2, "div", 9, 0);
            i0.ɵɵlistener("click", function LepiEditor_Template_div_click_2_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.editor.commands.focus());
            });
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(4, LepiEditor_ng_template_4_Template, 3, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(6, LepiEditor_ng_template_6_Template, 3, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(8, LepiEditor_ng_template_8_Template, 3, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(10, LepiEditor_ng_template_10_Template, 7, 0, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(12, LepiEditor_ng_template_12_Template, 8, 2, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵclassProp("border", !ctx.viewer);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.viewer ? 1 : -1);
            i0.ɵɵadvance();
            i0.ɵɵstyleMap(i0.ɵɵpureFunction1(7, _c39, ctx.minHeight + "px"));
            i0.ɵɵclassProp("p-8", !ctx.viewer);
          }
        },
        dependencies: [CommonModule, i1.NgStyle, FormsModule, i2.NgControlStatus, i2.NgModel, LepiIcon, LepiSelect, LepiSelectOption, LepiTooltipDirective, LepiInputText, CdkMenuModule, i3.CdkMenu, i3.CdkMenuItem, i3.CdkMenuTrigger, LepiButton, YouTubePlayer],
        styles: ["#lepi-editor .buttons lepi-icon{display:block;width:1.5rem;height:1.5rem}#lepi-editor .buttons button{display:flex;align-items:center;justify-content:center;border-radius:.375rem;border-width:1px;--tw-border-opacity: 1;border-color:rgb(163 163 163 / var(--tw-border-opacity));padding:.25rem;--tw-text-opacity: 1;color:rgb(245 245 245 / var(--tw-text-opacity));transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}#lepi-editor .buttons button:hover{--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity))}#lepi-editor .buttons button:disabled{cursor:not-allowed}#lepi-editor .buttons button:disabled lepi-icon{--tw-bg-opacity: 1;background-color:rgb(212 212 212 / var(--tw-bg-opacity))}#lepi-editor .buttons button:not(.toggleable) lepi-icon{--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}#lepi-editor .buttons button.toggleable.active lepi-icon{--tw-bg-opacity: 1;background-color:rgb(38 38 38 / var(--tw-bg-opacity))}#lepi-editor .buttons button.toggleable:not(.active) lepi-icon{--tw-bg-opacity: 1;background-color:rgb(115 115 115 / var(--tw-bg-opacity))}#lepi-editor table{min-width:8rem;border-width:1px}#lepi-editor table th,#lepi-editor table td{position:relative;min-width:2.5rem;border-width:1px;padding:.5rem}#lepi-editor table th.selectedCell:after,#lepi-editor table td.selectedCell:after{content:\"\";position:absolute;inset:0;background-color:#0000001a}#lepi-editor ol{list-style-type:decimal}#lepi-editor ol li{margin-left:1rem}#lepi-editor ul{list-style-type:disc}#lepi-editor ul li{margin-left:1rem}#lepi-editor h1{font-size:1.5rem;line-height:2rem;font-weight:700}#lepi-editor h2{font-size:1.25rem;line-height:1.75rem;font-weight:700}#lepi-editor h3{font-size:1.125rem;line-height:1.75rem;font-weight:700}#lepi-editor a{cursor:pointer;--tw-text-opacity: 1;color:rgb(59 130 246 / var(--tw-text-opacity));text-decoration-line:underline}\n"],
        encapsulation: 2
      });
    }
  }
  return LepiEditor;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiEditorViewer = /*#__PURE__*/(() => {
  class LepiEditorViewer {
    get sanitizedContent() {
      return this.sanitizer.bypassSecurityTrustHtml(this.content);
    }
    constructor(sanitizer) {
      this.sanitizer = sanitizer;
      this.format = 'html';
    }
    static {
      this.ɵfac = function LepiEditorViewer_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiEditorViewer)(i0.ɵɵdirectiveInject(i1$2.DomSanitizer));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: LepiEditorViewer,
        selectors: [["lepi-editor-viewer"]],
        inputs: {
          content: "content",
          format: "format"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 2,
        consts: [["disabled", "", "viewer", "", 3, "ngModel", "format"]],
        template: function LepiEditorViewer_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "lepi-editor", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngModel", ctx.content)("format", ctx.format);
          }
        },
        dependencies: [CommonModule, LepiEditor, FormsModule, i2.NgControlStatus, i2.NgModel]
      });
    }
  }
  return LepiEditorViewer;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LepiGlobalConfigModule = /*#__PURE__*/(() => {
  class LepiGlobalConfigModule {
    static forRoot(config) {
      return {
        ngModule: LepiGlobalConfigModule,
        providers: [{
          provide: LEPI_GLOBAL_CONFIG_TOKEN,
          useValue: config
        }]
      };
    }
    static {
      this.ɵfac = function LepiGlobalConfigModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LepiGlobalConfigModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LepiGlobalConfigModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return LepiGlobalConfigModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const provideLepiGlobalConfig = config => {
  return makeEnvironmentProviders([{
    provide: LEPI_GLOBAL_CONFIG_TOKEN,
    useValue: config
  }]);
};
const Colors = ['primary', 'secondary', 'success', 'danger', 'warning', 'medium', 'dark'];
const Sizes = ['sm', 'md', 'lg', 'xl'];
const Roundeds = ['sm', 'md', 'lg', 'xl', 'full'];
const Variants = ['solid', 'text', 'outline'];

//버튼

/**
 * Generated bundle index. Do not edit.
 */

export { LepiTextField as $, LepiRadio as A, LepiRadioOption as B, LepiRadioModule as C, Domains as D, LepiSegment as E, FADE_IN as F, LepiSegmentItem as G, LepiSegmentModule as H, LepiTopBar as I, LepiSideMenu as J, LepiSideMenuItem as K, LepiSkeleton as L, LepiSideMenuItemChild as M, LepiSideMenuItemGroup as N, LepiAdminLayout as O, LepiHint as P, LepiImage as Q, LepiToggle as R, LepiAccordion as S, AlertService as T, SideDialogService as U, ModalService as V, LepiModalHeaderComponent as W, LepiModalFooterComponent as X, LepiDataGrid as Y, LepiGridFileDownload as Z, LepiGridImage as _, LepiPageSelect as a, LepiSpinner as a0, LepiEditor as a1, LepiEditorViewer as a2, LEPI_GLOBAL_CONFIG_TOKEN as a3, LEPI_EDITOR_IMAGE_HANDLER as a4, LepiGlobalConfigModule as a5, provideLepiGlobalConfig as a6, Colors as a7, Sizes as a8, Roundeds as a9, Variants as aa, LepiSelectModule as b, LepiSelect as c, LepiSelectOption as d, LepiSelectOptionGroup as e, LepiIcon as f, LepiCheckbox as g, LepiBadge as h, LepiButton as i, LepiInputText as j, LepiDateRange as k, LepiInputNumber as l, LepiLabel as m, LepiMultiLepiCheckbox as n, LepiCheckboxModule as o, LepiInputGroup as p, LepiInputPassword as q, LepiInputTel as r, LepiInputChip as s, LepiInputEmail as t, LepiInputRating as u, LepiInputDuration as v, LepiInputTime as w, LepiTextArea as x, LepiDatePicker as y, LepiFileUploader as z };
